import { useEffect, useRef, useState } from "react";
import ShowError from "../recVisual/ShowError";
import Loader from "../recVisual/Loader";
import { crearTabla, dividirLista, esformatoNumero, formatearFecha, formatearTexto, generarTextoDiasSemana, getConfirmacion, guardarDatoLocal,  infoGuardadaEsMismoDia,  isFlagUpdate,  presentarError, presentarLog, quitarCharEspeciales, quitarTildes, reconstruirDatosOrigen, recuperarDatoLocal, registrarLogEventos, reportarError, setFlagUpdate, showMensajePantalla, superaTiempoActualizacion, valorNumero } from "../helpers/funciones";
import { getDatos } from "../gestionDatos/getDatos";
import { C_colorAccent, C_uniformeGrisOscuro, C_uniformeBlanco,  C_colorPrimary, C_colorPrimaryDark, SEP_3, SEP_4, SEP_D_1, SEPARADOR_PARAMETROS_BD, C_uniformeNegro, C_colorTextoSinInfo, ID_MODULO_ADMIN_TORNEO,  ID_MODULO_PRINCIPAL_ADMIN, C_transparente,   C_fondoGrisSuperClaro, C_uniformeRosa, ID_MODULO_DETALLE_EQUIPO, ID_MODULO_INFO_EQUIPO, SEP_2, C_uniformeVerdeClaro, C_uniformeAzulClaro, C_fondolistaspar, SEP_1 } from "../constantes/generales";


import ic_escudo_base_gris from '../recGraficos/ic_escudo_base_gris.png';
import ic_salir from '../recGraficos/ic_salir_w.png'
import ic_jugadorsinimagen from '../recGraficos/ic_jugadorsinimagen.png';
import ic_flecha_expandir from '../recGraficos/ic_flecha_expandir.png';
import ic_torneo_gris_w from '../recGraficos/ic_torneo_gris_w.png';
import ic_tomarfoto_dark from '../recGraficos/ic_tomarfoto_dark.png';
import ic_configura_gris from '../recGraficos/ic_configura_gris.png';
import ic_configura_blanco from '../recGraficos/ic_configura_blanco.png';
import ic_expandir_vertical_blanco from '../recGraficos/ic_expandir_vertical_blanco.png';
import ic_contraer_vertical_blanco from '../recGraficos/ic_contraer_vertical_blanco.png';
import ic_transparente from '../recGraficos/ic_transparente.png';
import ic_cancelar_gris from '../recGraficos/ic_cancelar_gris.png';
import ic_agregar from '../recGraficos/ic_agregar.png';
import ic_buscar_gris from '../recGraficos/ic_buscar_gris.png';
import ic_upload_primary from '../recGraficos/ic_upload_primary.png';
import ic_copiar_blanco from '../recGraficos/ic_copiar_blanco.png';
import ic_borrar_primary from '../recGraficos/ic_borrar_primary.png';
import ic_borrar_rojo from '../recGraficos/ic_borrar_rojo.png';
import ic_borrar_blanco from '../recGraficos/ic_borrar_blanco.png';
import ic_borrar_gris from '../recGraficos/ic_borrar_gris.png';
import ic_ok from '../recGraficos/ic_ok.png';
import ic_modificar_gris from '../recGraficos/ic_modificar_gris.png';
import ic_ayuda_accent from '../recGraficos/ic_ayuda_accent.png';
import ic_programar from '../recGraficos/ic_programar.png';
import ic_activo from '../recGraficos/ic_activo.png';
import ic_inactivo from '../recGraficos/ic_inactivo.png';
import ic_contraer_vertical_primary from '../recGraficos/ic_contraer_vertical_primary.png';
import ic_expandir_vertical_primary from '../recGraficos/ic_expandir_vertical_primary.png';
import ic_puntos_verticales_blancos from '../recGraficos/ic_puntos_verticales_blancos.png';
import ic_jugador_registro_gris from '../recGraficos/ic_jugador_registro_gris.png';
import ic_detalle_gris from '../recGraficos/ic_detalle_gris.png';
import ic_detalle_primary from '../recGraficos/ic_detalle_primary.png';
import ic_actualizar from '../recGraficos/ic_actualizar.png';
import ic_android_primary from '../recGraficos/ic_android_primary.png';
import ic_manual_primary from '../recGraficos/ic_manual_primary.png';
import ic_detalle_blanco from '../recGraficos/ic_detalle_blanco.png';
import ic_fase_eliminacion_blanco from '../recGraficos/ic_fase_eliminacion_blanco.png';
import ic_fase_eliminacion from '../recGraficos/ic_fase_eliminacion.png';
import ic_fase_grupos from '../recGraficos/ic_fase_grupos.png';
import ic_entrar_gris from '../recGraficos/ic_entrar_gris.png';


import DinamicoElementosTorneo from "../gestionVisual/DinamicoElementosTorneo";
import Modal from "../recVisual/Modal";
import { useModal } from "../helpers/useModal";
import { estilosSelect } from "../estilos/estilosSelect";
import { listaDosItems } from "../recVisual/listaDesplegable";
import Select from "react-select";

import "../estilos/BF_BordesFondos.css";
import "../estilos/IP_Inputs.css";
import GestionImagen from "../gestionVisual/GestionImagen";
import ModalFull from "../recVisual/ModalFull";
import Calendar from "react-calendar";
import SelHorario from "../recVisual/SelHorario";
import Admin_Canchas from "./Admin_Canchas";


let ruta=recuperarDatoLocal("rutaRecursos");
const nomClase="Admin_Torneo_WB";
const idModulo=ID_MODULO_ADMIN_TORNEO;

let idUser="";
let tipoUser=recuperarDatoLocal("tipoUser");

let idTorneo="";
let idSede="";

let torneoNuevo=false;
let nuevoGrupo="0";
let actualizarGrupos="0";    
let aceptoCambioTipoTorneo=false;    
let objNuevoTipoTorneo=null;

let regEquipoSel=-1;
let regEquipoNuevoSel=-1;
let omitioAlerta=false;
let textoFinal="";
let letCambioGrupo=false;
let letCambioGrupoJornada=false;
let tipoGestionGrupos="FASE DE GRUPOS";
let consultoInfoEGJ=false;
let hayJornadasGrupo=false;
let infoGestionJornadasINICIAL=[];

let registroSel=-1;


let datosInicial = {
    tituloVentana:"",
    fotoUsuario:ic_jugadorsinimagen,
    rolUsuario:"",
    nomUsuario:"",
    nomEmpresa:"",
    nomSede:"",
    nomTorneo:"",
    escudoTorneo:ic_torneo_gris_w,
    descTorneo:"",
    reglamento:"",
    activo:""
};

let matrizCampos=[
    {id: "NOMBRE_TORNEO",  idx: 0, valor: "", ultValor:"", error: "Ingrese el nombre del Torneo (Mínimo 3 letras)"},
    {id: "DESCRIPCION",  idx: 1, valor: "", ultValor:"", error: ""},
    {id: "ESCUDO",  idx: 2, valor: "", ultValor:"", error: ""},
    {id: "HORARIO",  idx: 3, valor: "", ultValor:"", error: "Defina el Horario del Torneo"},
    {id: "FECHA_INICIO",  idx: 4, valor: "", ultValor:"", error: "Defina la Fecha de Inicio del Torneo"},
    {id: "FECHA_LIMITE_PLANTILLA",  idx: 5, valor: "", ultValor:"", error: ""},
    {id: "FECHA_LIMITE_EQUIPO",  idx: 6, valor: "", ultValor:"", error: ""},
    {id: "TIPO_TORNEO",  idx: 7, valor: "0", ultValor:"", error: "Defina el Tipo de Torneo"},
    {id: "PERMITE_EMPATE",  idx: 8, valor: "1", ultValor:true, error: ""},
    {id: "PARAMETROS_JUEGO",  idx: 9, valor: [], ultValor:[], error: [], regParams: []},
    {id: "PARAMETROS_OTROS",  idx: 10, valor: [], ultValor:[], error: [], regParams: []},
    {id: "PUNTOS_GANADOR",  idx: 11, valor: "3", ultValor:"3", error: ""},
    {id: "PUNTOS_EMPATE_GANADOR",  idx: 12, valor: "1", ultValor:"", error: ""},
    {id: "PUNTOS_EMPATE_PERDEDOR",  idx: 13, valor: "1", ultValor:"", error: ""},
    {id: "PUNTOS_PERDEDOR",  idx: 14, valor: "0", ultValor:"", error: ""},
    {id: "HORARIO_SHOW",  idx: 15, valor: "", ultValor:"", error: "Defina el Horario del Torneo"},
    {id: "REGLAMENTO",  idx: 16, valor: "", ultValor:"", error: ""},
    {id: "FILTRO_BUSQUEDA",  idx: 17, valor: "", ultValor:"", error: ""},
];

let tipoTorneos=[
                {value:"0", label:"Seleccione El Tipo de Torneo", texto2:""},
                {value:"1", label:"Todos Contra Todos", texto2:"Único Partido - Todos los equipos"},
                {value:"2", label:"Todos Contra Todos Ida y Vuelta", texto2:"Ida y Vuelta - Todos los equipos"},
                {value:"3", label:"Por Grupos", texto2:"Único Partido - Equipos en Grupos"},
                {value:"4", label:"Por Grupos Ida y Vuelta", texto2:"Ida y Vuelta - Equipos en Grupos"},
                {value:"5", label:"Eliminación Directa", texto2:"Torneo sin fase de grupos"}
            ];

let listaJornadasEliminacion=[
                {value:"0", label:"Partido Único", texto2:""},
                {value:"1", label:"Partido Ida y Vuelta", texto2:""},
                {value:"2", label:"Por Grupos (Partido Único)", texto2:""},
                {value:"3", label:"Por Grupos (Ida y Vuelta)", texto2:""}
            ];

let infoBusquedaBase = {
    tipoLista:"",
    imagen:ic_jugadorsinimagen,
    titulo:"",
    texto:"",
    datosTotal:[],
    datosFiltrados:[]
};

let copa = { idcopa:"-1", nombreCopa:"Copa Principal", jornadas:[], tienePartidos:false, estado:""};
let jornada = { idjornada:"", nombreJornada:"", tienePartidos:"0", tipoJornadaEliminacion:"0", nombreTJE: listaJornadasEliminacion[0].label, estado:"", listaTipoJornada:listaJornadasEliminacion, tipoJornadaSel:0, infoGrupos:[], gruposGuadados:false };

let tipoSeleccion="telefono";




let paramsAjustado="";
 


let titulo="";
let mensaje="";
let ventanaMensaje;


let datosSedeConsultados=false;
let cancelarBusqueda=false;
let textoBuscar="";


let listaOrigenSel="";
let regListaSel=-1;
let regCampoSel=-1;
let estaCreandoCopa=false;
let estaCreandoJornada=false;


let infoTorneoO = [];
let infoTorneo = [];
function crearInfoTorneo(datos){    
    const nomFuncion="crearInfoTorneo";

    try{        
        let torneo = {
            idtorneo:"",
            idsede:"",
            nombre:"",
            descripcion:"",
            horario:"",
            activo:"",
            escudo:"",
            tienePartidos:"",
            reglamento:"",
            fecha_maxreg:"",
            fechainicio:"",
            tipo_torneo:"",
            permite_empate:"",
            puntos_desempate:"",
            tipo_arbitros:"",
            tipo_registroinfo:"",
            mostrar_invitados:"",
            indiceEscudo:"",
            tieneTarjetaAzul:"",
            puntos_ganador:"",
            puntos_empate:"",
            puntos_perdedor:"",
            perdedor_empate:"",
            fecha_max_equipo:"",
            publicidad:"",
            indicePublicidad:"",
            indiceReglamento:"",
            indicativo:""
        }
    
        infoTorneoO = [];
        infoTorneo = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , torneo);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idtorneo=datos[i][j];
                if(j===1) registro.idsede=datos[i][j];
                if(j===2) registro.nombre=datos[i][j];
                if(j===3) registro.descripcion=datos[i][j];
                if(j===4) registro.horario=datos[i][j];
                if(j===5) registro.activo=datos[i][j];
                if(j===6) registro.escudo=datos[i][j];
                if(j===7) registro.tienePartidos=datos[i][j];
                if(j===8) registro.reglamento=datos[i][j];
                if(j===9) registro.fecha_maxreg=datos[i][j];
                if(j===10) registro.fechainicio=datos[i][j];
                if(j===11) registro.tipo_torneo=datos[i][j];
                if(j===12) registro.permite_empate=datos[i][j];
                if(j===13) registro.puntos_desempate=datos[i][j];
                if(j===14) registro.tipo_arbitros=datos[i][j];
                if(j===15) registro.tipo_registroinfo=datos[i][j];
                if(j===16) registro.mostrar_invitados=datos[i][j];
                if(j===17) registro.indiceEscudo=datos[i][j];
                if(j===18) registro.tieneTarjetaAzul=datos[i][j];
                if(j===19) registro.puntos_ganador=datos[i][j];
                if(j===20) registro.puntos_empate=datos[i][j];
                if(j===21) registro.puntos_perdedor=datos[i][j];
                if(j===22) registro.perdedor_empate=datos[i][j];
                if(j===23) registro.fecha_max_equipo=datos[i][j];
                if(j===24) registro.publicidad=datos[i][j];
                if(j===25) registro.indicePublicidad=datos[i][j];
                if(j===26) registro.indiceReglamento=datos[i][j];
                if(j===27) registro.indicativo=datos[i][j];
            }
            infoTorneoO.push(registro);
            infoTorneo.push(datos[i]);

            idSede=registro.idsede;
            
        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoParametrosO = [];
let infoParametros = [];
function crearInfoParametros(datos){    
    const nomFuncion="crearInfoParametros";

    try{        
        let parametro = {
            idparametro:"",
            titulo:"",
            nombre:"",
            descripcion:"",
            tipo:"",
            valorDefecto:"",
            valormin:"",
            valormax:"",
            orden:"",
            valorOriginal:"",
            valorActual:""
        }
    
        infoParametrosO = [];
        infoParametros = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , parametro);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idparametro=datos[i][j];
                if(j===1) registro.titulo=datos[i][j];
                if(j===2) registro.nombre=datos[i][j];
                if(j===3) registro.descripcion=datos[i][j];
                if(j===4) registro.tipo=datos[i][j];
                if(j===5) registro.valorDefecto=datos[i][j];
                if(j===6) registro.valormin=datos[i][j];
                if(j===7) registro.valormax=datos[i][j];
                if(j===8) registro.orden=datos[i][j];
                if(j===9) registro.valorOriginal=datos[i][j];
                if(j===10) registro.valorActual=datos[i][j];
            }

            

            if(registro.valormin===("0") && registro.valormax==("1")){
                if(registro.valorActual===("")) registro.valorActual = registro.valorDefecto;
            }


            infoParametrosO.push(registro);
            infoParametros.push(datos[i]);
            
        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoEquiposO = [];
let infoEquipos = [];
function crearInfoEquipos(datos){    
    const nomFuncion="crearInfoEquipos";

    try{        
        let equipo = {
            idequipo:"",
            escudo:"",
            nombrelargo:"",
            activo:"",
            tienePartidos:"",
            numgrupo:"",
            borrado:"0",
            esCambioGrupo:"0",
            numequipo:"",            
            indice: 0,
            nuevoGrupo:""
        }
    
        infoEquiposO = [];
        infoEquipos = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , equipo);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idequipo=datos[i][j];
                if(j===1) registro.escudo=datos[i][j];
                if(j===2) registro.nombrelargo=datos[i][j];
                if(j===3) registro.activo=datos[i][j];
                if(j===4) registro.tienePartidos=datos[i][j];
                if(j===5){
                    registro.numgrupo=datos[i][j];
                    registro.nuevoGrupo=datos[i][j];
                }
                if(j===6) registro.borrado=datos[i][j];
            }
            infoEquiposO.push(registro);
            infoEquipos.push(datos[i]);            

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoJornadasO = [];
let infoJornadas = [];
function crearInfoJornadas(datos){    
    const nomFuncion="crearInfoJornadas";

    try{        
        let jornada = {
            idcopa:"",
            nombreCopa:"",
            idjornada:"",
            numeroNuevo:"",
            nombreJornada:"",
            tipoJornada:"",
            tipoJornadaEliminacion:"",
            tieneEquiposGrupo:"",
            tienePartidos:""
        }
    
        infoJornadasO = [];
        infoJornadas = [];
        hayJornadasGrupo=false;
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , jornada);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idcopa=datos[i][j];
                if(j===1) registro.nombreCopa=datos[i][j];
                if(j===2) registro.idjornada=datos[i][j];
                if(j===3) registro.numeroNuevo=datos[i][j];
                if(j===4) registro.nombreJornada=datos[i][j];
                if(j===5) registro.tipoJornada=datos[i][j];
                if(j===6) registro.tipoJornadaEliminacion=datos[i][j];
                if(j===7) registro.tieneEquiposGrupo=datos[i][j];
                if(j===8) registro.tienePartidos=datos[i][j];
            }

            if(registro.tipoJornadaEliminacion==="2" || registro.tipoJornadaEliminacion==="3") {
                hayJornadasGrupo=true;
            }

            infoJornadasO.push(registro);
            infoJornadas.push(datos[i]);            


        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoArbitrosO = [];
let infoArbitros = [];
function crearInfoArbitros(datos){    
    const nomFuncion="crearInfoArbitros";

    try{        
        let arbitro = {
            idarbitro:"",
            tipo:"",
            foto:"",
            nombre:""
        }
    
        infoArbitrosO = [];
        infoArbitros = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , arbitro);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idarbitro=datos[i][j];
                if(j===1) registro.tipo=datos[i][j];
                if(j===2) registro.foto=datos[i][j];
                if(j===3) registro.nombre=datos[i][j];
            }

            infoArbitrosO.push(registro);
            infoArbitros.push(datos[i]);            

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoCanchasO = [];
let infoCanchas = [];
function crearInfoCanchas(datos){    
    const nomFuncion="crearInfoCanchas";

    try{        
        let cancha = {
            idcancha:"",
            numero:"",
            nombre:"",
            indice:0,
            borrado:"0"
        }
    
        infoCanchasO = [];
        infoCanchas = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , cancha);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idcancha=datos[i][j];
                if(j===1) registro.numero=datos[i][j];
                if(j===2) registro.nombre=datos[i][j];
                if(j===3) registro.borrado=datos[i][j];
            }
            
            infoCanchasO.push(registro);
            infoCanchas.push(datos[i]);            

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoCobrosO = [];
let infoCobros = [];
function crearInfoCobros(datos){    
    const nomFuncion="crearInfoCobros";

    try{        
        let cobro = {
            idconfig:"",
            idtorneo:"",
            numconfig:"",
            nombreCobro:"",
            descripcion:"",
            tipoCobro:"",
            nombreTipoCobro:"",
            tipoevento:"",
            nombreTipoEvento:"",
            nivelcobro:"",
            nombreNivelCobro:"",
            fechaInicio:"",
            fechaFin:"",
            fechaLimitePago:"",
            porcAntesPartido:"",
            diasDespuesEvento:"",
            generaBloqueo:"",
            valorCobro:"",
            interes:"",
            periodicidadInteres:"",
            activo:"",
            permiteEpago:"",
            fechaActual:"",
            valorPagos:""
        }
    
        infoCobrosO = [];
        infoCobros = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , cobro);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idconfig=datos[i][j];
                if(j===1) registro.idtorneo=datos[i][j];
                if(j===2) registro.numconfig=datos[i][j];
                if(j===3) registro.nombreCobro=datos[i][j];
                if(j===4) registro.descripcion=datos[i][j];
                if(j===5) registro.tipoCobro=datos[i][j];
                if(j===6) registro.nombreTipoCobro=datos[i][j];
                if(j===7) registro.tipoevento=datos[i][j];
                if(j===8) registro.nombreTipoEvento=datos[i][j];
                if(j===9) registro.nivelcobro=datos[i][j];
                if(j===10) registro.nombreNivelCobro=datos[i][j];
                if(j===11) registro.fechaInicio=datos[i][j];
                if(j===12) registro.fechaFin=datos[i][j];
                if(j===13) registro.fechaLimitePago=datos[i][j];
                if(j===14) registro.porcAntesPartido=datos[i][j];
                if(j===15) registro.diasDespuesEvento=datos[i][j];
                if(j===16) registro.generaBloqueo=datos[i][j];
                if(j===17) registro.valorCobro=datos[i][j];
                if(j===18) registro.interes=datos[i][j];
                if(j===19) registro.periodicidadInteres=datos[i][j];
                if(j===20) registro.activo=datos[i][j];
                if(j===21) registro.permiteEpago=datos[i][j];
                if(j===22) registro.fechaActual=datos[i][j];
                if(j===23) registro.valorPagos=datos[i][j];
            }
            
            infoCobrosO.push(registro);
            infoCobros.push(datos[i]);            

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoCamposO = [];
let infoCampos = [];
function crearInfoCampos(datos){    
    const nomFuncion="crearInfoCampos";

    try{        
        let campo = {
            idconfig:"",
            idtorneo:"",
            numcampo:"",
            nombreCampo:"",
            descripcion:"",
            tipoCampo:"",
            nombreTipoCampo:"",
            valorMin:"",
            valorMax:"",
            obligatorio:"",
            activo:"",
            tieneValores:""
        }
    
        infoCamposO = [];
        infoCampos = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , campo);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idconfig=datos[i][j];
                if(j===1) registro.idtorneo=datos[i][j];
                if(j===2) registro.numcampo=datos[i][j];
                if(j===3) registro.nombreCampo=datos[i][j];
                if(j===4) registro.descripcion=datos[i][j];
                if(j===5) registro.tipoCampo=datos[i][j];
                if(j===6) registro.nombreTipoCampo=datos[i][j];
                if(j===7) registro.valorMin=datos[i][j];
                if(j===8) registro.valorMax=datos[i][j];
                if(j===9) registro.obligatorio=datos[i][j];
                if(j===10) registro.activo=datos[i][j];
                if(j===11) registro.tieneValores=datos[i][j];
            }
            infoCamposO.push(registro);
            infoCampos.push(datos[i]);

        }

                

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}


let infoEquipoO = [];
let infoEquipo = [];
function crearInfoEquipo(datos){    
    const nomFuncion="crearInfoEquipo";

    try{        
        let equipo = {
            idequipo:"",
            idsede:"",
            nombrelargo:"",
            nombrecorto:"",
            escudo:"",
            uniforme1:"",
            uniforme2:"",
            fotos:"",
            activo:"",
            indice:""
        }
    
        infoEquipoO = [];
        infoEquipo = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , equipo);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idequipo=datos[i][j];
                if(j===1) registro.idsede=datos[i][j];
                if(j===2) registro.nombrelargo=datos[i][j];
                if(j===3) registro.nombrecorto=datos[i][j];
                if(j===4) registro.escudo=datos[i][j];
                if(j===5) registro.uniforme1=datos[i][j];
                if(j===6) registro.uniforme2=datos[i][j];
                if(j===7) registro.fotos=datos[i][j];
                if(j===8) registro.activo=datos[i][j];
                if(j===9) registro.indice=datos[i][j];

            }
            infoEquipoO.push(registro);
            infoEquipo.push(datos[i]);            

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}


let infoJugadoresO = [];
let infoJugadores = [];
function crearInfoJugadores(datos){    
    const nomFuncion="crearInfoJugadores";

    try{        
        let jugador = {
            indice:0,
            idjugador:"",
            foto:"",
            nomPosicion:"",
            numero:"",
            activo:"",
            nombre:"",
            tieneEstadisticasCobros:"",
            esadmin:"",
            telefono:"",
            registrado:"",
            idposicion:""
        }
    
        infoJugadoresO = [];
        infoJugadores = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , jugador);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idjugador=datos[i][j];
                if(j===1) registro.foto=datos[i][j];
                if(j===2) registro.nomPosicion=datos[i][j];
                if(j===3) registro.numero=datos[i][j];
                if(j===4) registro.activo=datos[i][j];
                if(j===5) registro.nombre=datos[i][j];
                if(j===6) registro.tieneEstadisticasCobros=datos[i][j];
                if(j===7) registro.esadmin=datos[i][j];
                if(j===8) registro.telefono=datos[i][j];
                if(j===9) registro.registrado=datos[i][j];
                if(j===10) registro.idposicion=datos[i][j];
            }
            infoJugadoresO.push(registro);
            infoJugadores.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}


let jugadoresSedeO = [];
let jugadoresSede = [];
function crearInfoJugadoresSede(datos){    
    const nomFuncion="crearInfoJugadoresSede";

    try{        
        let jugador = {
            idjugador:"",
            foto:"",
            nombre:"",
            telefono:"",
            registrado:"",
            pendiente:"",
            cantEquipos:"",
            nomBusqueda:"",
        }
    
        jugadoresSedeO = [];
        jugadoresSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , jugador);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idjugador=datos[i][j];
                if(j===1) registro.foto=datos[i][j];
                if(j===2){
                    registro.nombre=datos[i][j];
                    registro.nomBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }
                if(j===3) registro.telefono=datos[i][j];
                if(j===4) registro.registrado=datos[i][j];
                if(j===5) registro.pendiente=datos[i][j];
                if(j===6) registro.cantEquipos=datos[i][j];
            }
            jugadoresSedeO.push(registro);
            jugadoresSede.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let jugadoresTorneoO = [];
let jugadoresTorneo = [];
function crearInfoJugadoresTorneo(datos){    
    const nomFuncion="crearInfoJugadoresTorneo";

    try{        
        let jugador = {
            idjugador:"",
            telefono:"",
            nombre:"",
            nomEquipo:""
        }
    
        jugadoresTorneoO = [];
        jugadoresTorneo = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , jugador);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idjugador=datos[i][j];
                if(j===1) registro.telefono=datos[i][j];
                if(j===2) registro.nombre=datos[i][j];
                if(j===3) registro.nomEquipo=datos[i][j];
            }
            jugadoresTorneoO.push(registro);
            jugadoresTorneo.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let equiposSedeO = [];
let equiposSede = [];
function crearInfoEquiposSede(datos){    
    const nomFuncion="crearInfoEquiposSede";

    try{        
        let equipo = {
            indice: 0,
            idEquipo:"",
            escudo:"",
            nombreLargo:"",
            sinInfo:"",
            activo:"",
            tJugadores:"",
            jEnTorneo:"",
            nomTorneo:"",
            nomLargoBusqueda:"",
            nomTorneoBusqueda:"",
            jugadores:[],
            maxJugTorneo:0,
            jugSeleccionados:0
        }
    
        equiposSedeO = [];
        equiposSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , equipo);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idEquipo=datos[i][j];
                if(j===1) registro.escudo=datos[i][j];
                if(j===2){
                    registro.nombreLargo=datos[i][j];
                    registro.nomLargoBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }
                if(j===3) registro.sinInfo=datos[i][j];
                if(j===4) registro.activo=datos[i][j];
                if(j===5) registro.tJugadores=datos[i][j];
                if(j===6) registro.jEnTorneo=datos[i][j];
                if(j===7){
                    registro.nomTorneo=datos[i][j];
                    registro.nomTorneoBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }
            }

            //having tjugadores>0 and (tjugadores-jentorneo)>0
            if(valorNumero(registro.tJugadores)>0){
                equiposSedeO.push(registro);
                equiposSede.push(datos[i]);
            }            

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let jugadoresEquipoSelO = [];
let jugadoresEquipoSel = [];
function crearInfoJugadoresEquipoSel(datos){    
    const nomFuncion="crearInfoJugadoresEquipoSel";

    try{        
        let jugador = {
            idjugador:"",
            foto:"",
            nombre:"",
            esadmin:"",
            camiseta:"",
            jEnTorneo:"",
            seleccionado:false
        }
    
        jugadoresEquipoSelO = [];
        jugadoresEquipoSel = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , jugador);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idjugador=datos[i][j];
                if(j===1) registro.foto=datos[i][j];
                if(j===2) registro.nombre=datos[i][j];
                if(j===3) registro.esadmin=datos[i][j];
                if(j===4) registro.camiseta=datos[i][j];
                if(j===5) registro.jEnTorneo=datos[i][j];
            }
            jugadoresEquipoSelO.push(registro);
            jugadoresEquipoSel.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let canchasSedeO = [];
let canchasSede = [];
let cancha = {
            indice: -1,
            idCancha:"",
            sinInfo1:"",
            nombreNum:"",
            nombre:"",
            activo:"",
            horario:"",
            numero:"",
            nomBusqueda:"",
        }
function crearInfoCanchasSede(datos){    
    const nomFuncion="crearInfoCanchasSede";

    try{        
        
    
        canchasSedeO = [];
        canchasSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , cancha);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idCancha=datos[i][j];
                if(j===1) registro.sinInfo1=datos[i][j];
                if(j===2) registro.nombreNum=datos[i][j];
                if(j===3){
                    registro.nombre=datos[i][j];
                    registro.nomBusqueda=quitarTildes(datos[i][j]).toUpperCase();
                }                
                if(j===4) registro.activo=datos[i][j];
                if(j===5) registro.horario=datos[i][j];
                if(j===6) registro.numero=datos[i][j];
            }

            canchasSedeO.push(registro);
            canchasSede.push(datos[i]);

        }


    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

let infoEquiposJornadaO = [];
let equiposGrupoJornadaO = [];
let egj = {
            indice: -1,
            idjornada:"",
            idequipo:"",
            grupo:"",
            tienePartidos:""
        }
function crearInfoEqGrupoJornada(datos){    
    const nomFuncion="crearInfoEqGrupoJornada";

    try{        
        
    
        equiposGrupoJornadaO = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , egj);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idjornada=datos[i][j];
                if(j===1) registro.idequipo=datos[i][j];
                if(j===2) registro.grupo=datos[i][j];
                if(j===3) registro.tienePartidos=datos[i][j];
            }

            equiposGrupoJornadaO.push(registro);

        }


    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}




const Admin_Torneo = ({params="", definirModulo, modOrigen=0, paramOrigen=""}) => {
    const [esError, setEsError] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showMensaje, setShowMensaje] = useState(false);
    const [msjModal, setMsjModal] = useState("");

    const refBusqueda=useRef(null);

    const [showParametros, setShowParametros] = useState(true);
    const [showOpciones, setShowOpciones] = useState(true);

    const [showParamConfigUS, setShowParamConfigUS] = useState(true);
    const [showParamJuegoUS, setShowParamJuegoUS] = useState(true);
    const [showParamOpcionalUS, setShowParamOpcionalUS] = useState(false);

    const [showSeccionEquiposUS, setShowSeccionEquiposUS] = useState(false);
    const [showOpcionesEquiposUS, setShowOpcionesEquiposUS] = useState(false);
    const [equiposInscribirUS, setEquiposInscribirUS] = useState([]);
    const [cantEquiposUS, setCantEquiposUS] = useState(0);
    const [infoEquiposUS, setInfoEquiposUS] = useState([]);
    const [configGruposUS, setConfigGruposUS] = useState([]);
    const [configSinGruposUS, setConfigSinGruposUS] = useState([]);
    const [tipoSelGruposUS, setTipoSelGruposUS] = useState("");


    const [showSeccionCanchasUS, setShowSeccionCanchasUS] = useState(false);
    const [infoCanchasUS, setInfoCanchasUS] = useState([]);
    const [cantCanchasUS, setCantCanchasUS] = useState(0);


    const [showSeccionJornadasUS, setShowSeccionJornadasUS] = useState(false);
    const [infoJornadasUS, setInfoJornadasUS] = useState([]);
    const [cantJornadasUS, setCantJornadasUS] = useState(0);
    const [infoGestionJornadasUS, setIinfoGestionJornadasUS] = useState([]);
    const [jornadaSelUS, setJornadaSelUS] = useState(-1);
    const [consultoInfoEGJUS, setConsultoInfoEGJUS] = useState(false);


    const [showSeccionArbitrosUS, setShowSeccionArbitrosUS] = useState(false);
    const [showSeccionCobrosUS, setShowSeccionCobrosUS] = useState(false);
    const [showSeccionPublicidadUS, setShowSeccionPublicidadUS] = useState(false);
    const [showSeccionInfoAdicionalUS, setShowSeccionInfoAdicionalUS] = useState(false);

    const [showAlertaEquiposUS, setShowAlertaEquiposUS] = useState(false);


    const [clickAceptarUS, setClickAceptarUS] = useState(false);

    const [esTorneoNuevoUS, setEsTorneoNuevoUS] = useState(false);
    const [tienePartidosUS, setTienePartidosUS] = useState(false);
    const [parametrosJuegoUS, setParametrosJuegoUS] = useState([]);
    const [parametrosOpcionalUS, setParametrosOpcionalUS] = useState([]);

    const [arrCampos, setArrCampos] = useState(matrizCampos);
    const [datosMod, setDatosMod] = useState(datosInicial);

    const [tipoListaUS, setTipoListaUS] = useState("Telefono_Delegado");

    const [showFechaLimEquipoUS, setShowFechaLimEquipoUS] = useState(false);

    const [listaTipoTorneoUS, setListaTipoTorneoUS] = useState([]);
    const [tipoTorneoSelUS, setTipoTorneoSelUS] = useState(0);
    const [permiteEmpatesFGUS, setPermiteEmpatesFGUS] = useState(false);
    const [permiteEditarPuntosUS, setPermiteEditarPuntosUS] = useState(false);

    const [listaGruposUS, setListaGruposUS] = useState([]);
    const [grupoSelUS, setgGrupoSelUS] = useState(0);
    

    const [isOpenGestionGrupos, openGestionGrupos, closeGestionGrupos] = useModal(false);
    const [isOpenSelGrupo, openSelGrupo, closeSelGrupo] = useModal(false);
    const [isOpenSelJugadoresEq, openSelJugadoresEq, closeSelJugadoresEq] = useModal(false);
    const [isOpenBusqueda, openBusqueda, closeBusqueda] = useModal(false);
    const [isOpenImagen, openImagen, closeImagen] = useModal(false);
    const [isOpenFoto, openFoto, closeFoto] = useModal(false);
    const [isOpenMenu, openMenu, closeMenu] = useModal(false);
    const [isOpenCalendar, openCalendar, closeCalendar] = useModal(false);
    const [selectedDate, setSelectedDate] = useState(null);

    const [isOpenNewCancha, openNewCancha, closeNewCancha] = useModal(false);

    const [isOpenGestionJornadas, openGestionJornadas, closeGestionJornadas] = useModal(false);
    
    const [abrirHorarioUS, setAbrirHorarioUS] = useState(false);

    const [tituloMenu, setTituloMenu] = useState("");
    const [opcionesMenu, setOpcionesMenu] = useState([]);
    const [opcionSel, setOpcionSel] = useState(-1);
   

    const [datosEncontrados, setDatosEncontrados] = useState([]);
    const [infoBusquedaUS, setInfoBusquedaUS] = useState(infoBusquedaBase);
    const [infoEquipoSelUS, setInfoEquipoSelUS] = useState(null);
    const [datosCargadosBusqueda, setDatosCargadosBusqueda] = useState(false);



    const [tipoImagenSelUS, setTipoImagenSelUS] = useState("");
    const [imgActualSelUS, setImgActualSelUS] = useState("");   
    const [srcFotoUS, setSrcFotoUS] = useState("");


    const [irHastaFin, setIrHastaFin] = useState(false);
    const [irHastaFinJornada, setIrHastaFinJornada] = useState(false);
    
    var respuesta = {
        datos: "",
        exito: false,
        conectado: false,
        hayDatos: false,
        mensaje: ''
    }

    useEffect(() => {
        const nomFuncion="useEffect";

        try{          
            datosSedeConsultados=false;

            setListaTipoTorneoUS(tipoTorneos);
            
            let ultParametros=recuperarDatoLocal("ultParametros" + idModulo);
            idTorneo="";
            let actualizar=false;
            let info;
        

            if(params!=="-1"){                
                info=dividirLista(params,SEP_4,5);
                let ultParametrosTotal=ultParametros;
                let datosParametrosGuardados=dividirLista(ultParametrosTotal,SEP_4,2);               

                if(datosParametrosGuardados[0]!=="-1" && datosParametrosGuardados[0]!=="") idTorneo=datosParametrosGuardados[0];      
                else idTorneo="-1"; 
            
            }

            if(idTorneo===""){
                    torneoNuevo=true;
                    actualizar=false;
                    guardarDatoLocal("ultParametros" + idModulo, "-1");
            }
            else if(idTorneo!==info[0]){
                    torneoNuevo=false;
                    actualizar=true;
                    idTorneo=info[0];

                    guardarDatoLocal("ultParametros" + idModulo, idTorneo);
            } 


            paramsAjustado=idTorneo;

            if(isFlagUpdate()) actualizar=true;

                if(torneoNuevo){
                    if(!actualizar) {
                        actualizar= (superaTiempoActualizacion(idModulo + "Nuevo"));
                    }

                    if(actualizar){
                        BD_solicitarDatos("INFO_ADMIN_TORNEO_NUEVO",[]);   
                    }
                    else{
                        cargarDatosGuardadosModuloNuevo();
                    }
                                
                }
                else{
                    if(!actualizar) {
                        actualizar= (superaTiempoActualizacion(idModulo));
                    }
                    
                    
                    actualizar=true;
                    if(actualizar){
                        BD_solicitarDatos("INFO_INICIAL",[]);    
                    }
                    else{
                        cargarDatosGuardadosModulo();
                    }
                }

                
                
            
    

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }     
        

    }, [params]);


    if(params==="") return null;

    const BD_solicitarDatos = (tipoDatos, params) => {
        let nomFuncion="BD_solicitarDatos"; 

        try{
            let actualizar=true;
            let SEP=SEPARADOR_PARAMETROS_BD;
            let paramQuery="";
            let tipoConsulta="";
            let funcion="";
            let consulta="";
            let zonaHoraria="0";
            let mostrarError=true;
            let mostrarProcesando=true;

            let codigoFinal="";
            
            if(actualizar){      
                
                zonaHoraria="" + valorNumero(recuperarDatoLocal("zonahoraria"));

                if(tipoDatos==="INFO_INICIAL"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleTorneo";
                    consulta="INFO_ADMIN_TORNEO";
                    
                    paramQuery= idTorneo;
                } else if(tipoDatos==="INFO_ADMIN_TORNEO_NUEVO"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleTorneo";
                    consulta="INFO_ADMIN_TORNEO_NUEVO";
                    
                    paramQuery="";
                } else if(tipoDatos==="CREAR_NUEVO_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="CREAR_NUEVO_TORNEO";

                    let datos=params[0];
                    let nombreTorneo=params[1];
                    
                    paramQuery=datos + SEP + idSede + SEP + nombreTorneo;
                    
                } else if(tipoDatos==="ACTUALIZAR_CAMPOS_ADMIN_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="ACTUALIZAR_CAMPOS_ADMIN_TORNEO";
                    mostrarProcesando=false;


                    let esTipoTorneo="0"; 
                    let txtParejasUdt="";
                    let parejas=params.split(SEP_D_1);
                    for(let i=0;i<parejas.length;i++){
                        let columnas=parejas[i].split(SEP_3);
                        let valor="";
                        if(columnas.length===2) valor=columnas[1].trim();

                        if(columnas[0]===("tipo_torneo")) esTipoTorneo="1";

                        if(valor==="NULL"){
                            if(txtParejasUdt==="") txtParejasUdt=columnas[0] + "=NULL ";
                            else txtParejasUdt=txtParejasUdt + ", " + columnas[0] + "=NULL ";
                        }
                        else{
                            if(txtParejasUdt==="") txtParejasUdt=columnas[0] + "='" + valor + "' ";
                            else txtParejasUdt=txtParejasUdt + ", " + columnas[0] + "='" + valor + "' ";
                        }
                    }
                    
                    if(esTipoTorneo==="1") paramQuery= idTorneo + SEP + txtParejasUdt + SEP + actualizarGrupos + SEP + nuevoGrupo;
                    else paramQuery= idTorneo + SEP + txtParejasUdt;

                } else if(tipoDatos==="ACTUALIZAR_PARAMS_ADMIN_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="ACTUALIZAR_PARAMS_ADMIN_TORNEO";
                    mostrarProcesando=false;

                    let paramsUpdate=params;
                    paramQuery= idTorneo + SEP + paramsUpdate;

                } else if(tipoDatos==="CANTIDADES_INFO_JUGADORES_SEDE"){
                    tipoConsulta="consultarDato";
                    funcion="getListasDetalleEquipo";
                    consulta="CANTIDADES_INFO_JUGADORES_SEDE";
                    mostrarProcesando=false;

                    let idSede= recuperarDatoLocal("idSede");
                    paramQuery= idSede + SEP + idTorneo;

                } else if(tipoDatos==="RECUPERAR_INFO_JUGADORES_SEDE"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleEquipo";
                    consulta="RECUPERAR_INFO_JUGADORES_SEDE";
                    mostrarProcesando=false;

                    let idSede= recuperarDatoLocal("idSede");
                    let consultar=params;
                    paramQuery= idSede + SEP + idTorneo  + SEP + consultar;

                    datosSedeConsultados=false;
                } else if(tipoDatos==="BORRAR_IMAGEN_SERVIDOR_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="BORRAR_IMAGEN_SERVIDOR_TORNEO";
                    mostrarProcesando=false;

                    paramQuery=idTorneo;
                } else if(tipoDatos==="GUARDAR_IMAGEN_SERVIDOR"){
                    tipoConsulta="ENVIAR_IMAGEN";
                    funcion="torneo";
                    consulta="";
                    mostrarProcesando=false;

                    let imagen=params.replace("data:image/jpeg;base64,","");
                    let id="";
                    let indice="0";

                    id=idTorneo;
                    indice=infoTorneoO[0].indiceEscudo;                   
                    
                    paramQuery=[imagen,id,indice];


                } else if(tipoDatos==="ACTIVAR_INACTIVAR_EQUIPO_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="ACTIVAR_INACTIVAR_EQUIPO_TORNEO";
                    mostrarProcesando=false;

                    let reg=params;
                    let idEq=infoEquiposO[reg].idequipo;
                    let nuevoActivo="1";
                    if(infoEquiposO[reg].activo==="1") nuevoActivo="0";

                    paramQuery= idTorneo + SEP + idEq + SEP + nuevoActivo;
                } else if(tipoDatos==="RETIRAR_EQUIPO_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="RETIRAR_EQUIPO_TORNEO";
                    mostrarProcesando=false;

                    let reg=params;
                    let idEq=infoEquiposO[reg].idequipo;

                    paramQuery= idTorneo + SEP + idEq;
                } else if(tipoDatos==="INSCRIBIR_EQUIPOS_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="INSCRIBIR_EQUIPOS_TORNEO";

                    paramQuery= idSede + SEP + idTorneo + SEP + textoFinal;
                } else if(tipoDatos==="INFO_DETALLE_EQUIPOS_TORNEO"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleTorneo";
                    consulta="INFO_DETALLE_EQUIPOS_TORNEO";
                    
                    paramQuery=idTorneo;
                } else if(tipoDatos==="INFO_EQUIPOS_SEDE_NO_TORNEO"){
                    tipoConsulta="consultarTabla";
                    funcion="getInfoSede";
                    consulta="INFO_EQUIPOS_SEDE_NO_TORNEO";
                    mostrarProcesando=false;
                    
                    paramQuery= idSede + SEP + idTorneo;

                } else if(tipoDatos==="IMPORTAR_EQUIPO_SEDE_A_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="IMPORTAR_EQUIPO_SEDE_A_TORNEO";

                    let idEquipo=equiposSedeO[regEquipoNuevoSel].idEquipo;
                    let jugadores="0";
                    if(textoFinal!=="") jugadores=textoFinal;

                    paramQuery= idTorneo + SEP + idEquipo + SEP + jugadores;
                } else if(tipoDatos==="INFO_JUGADORES_EQUIPO"){
                    tipoConsulta="consultarTabla";
                    funcion="getListaEquipo";
                    consulta="INFO_JUGADORES_EQUIPO";
                    mostrarProcesando=false;
                
                    let idEquipo=equiposSedeO[regEquipoNuevoSel].idEquipo;
                    paramQuery= idTorneo + SEP + idEquipo;

                } else if(tipoDatos==="GUARDAR_CONFIGURACION_GRUPOS_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="GUARDAR_CONFIGURACION_GRUPOS_TORNEO";

                    let datos=params;

                    paramQuery= idTorneo + SEP + datos;
                } else if(tipoDatos==="INFO_CANCHAS_SEDE"){
                    tipoConsulta="consultarTabla";
                    funcion="getInfoSede";
                    consulta="INFO_CANCHAS_SEDE";
                    mostrarProcesando=false;
                    
                    paramQuery= idSede;

                } else if(tipoDatos==="RETIRAR_CANCHA_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="RETIRAR_CANCHA_TORNEO";
                    mostrarProcesando=false;

                    let reg=params;
                    let idcancha=infoCanchasO[reg].idcancha;

                    paramQuery= idTorneo + SEP + idcancha;
                } else if(tipoDatos==="ASOCIAR_CANCHA_A_TORNEO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="ASOCIAR_CANCHA_A_TORNEO";

                    let reg=params;
                    let idcancha=canchasSedeO[reg].idCancha;

                    paramQuery= idTorneo + SEP + idcancha;
                } else if(tipoDatos==="INFO_DETALLE_CANCHAS_TORNEO"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleTorneo";
                    consulta="INFO_DETALLE_CANCHAS_TORNEO";
                    
                    paramQuery=idTorneo;
                } else if(tipoDatos==="INFO_EQUIPOS_GRUPO_JORNADA"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleTorneo";
                    consulta="INFO_EQUIPOS_GRUPO_JORNADA";

                    mostrarProcesando=false;
                    
                    paramQuery=idTorneo;
                } else if(tipoDatos==="GUARDAR_CONFIGURACION_JORNADAS"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarTorneo";
                    consulta="GUARDAR_CONFIGURACION_JORNADAS";

                    let infoJornadas=params;

                    paramQuery= idTorneo + SEP + infoJornadas;
                } else if(tipoDatos==="INFO_DETALLE_JORNADAS_TORNEO"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleTorneo";
                    consulta="INFO_DETALLE_JORNADAS_TORNEO";
                    
                    paramQuery=idTorneo;
                } 
                
                if(mostrarProcesando) setLoading(true);

                getDatos()
                .get(tipoConsulta,funcion,consulta,paramQuery,zonaHoraria)
                .then((res) => {
                    nomFuncion="BD_solicitarDatos.respuesta"; 

                    try{
                        respuesta=res;
                        if (respuesta.exito) {
                            if(tipoDatos==="INFO_INICIAL"){
                                presentarLog(nomClase + " - SOLICITA_DATOS"); 
    
                                guardarDatoLocal("ultAcceso" + idModulo,Date.now());
                                guardarDatoLocal("datos" + idModulo + idTorneo, respuesta.datos);
    
                                crearInfoTorneo(crearTabla(respuesta.datos,"1"));
                                crearInfoParametros(crearTabla(respuesta.datos,"2"));
                                crearInfoEquipos(crearTabla(respuesta.datos,"3")); 
                                crearInfoJornadas(crearTabla(respuesta.datos,"4")); 
                                crearInfoArbitros(crearTabla(respuesta.datos,"5")); 
                                crearInfoCanchas(crearTabla(respuesta.datos,"6")); 
                                crearInfoCobros(crearTabla(respuesta.datos,"7")); 
                                crearInfoCampos(crearTabla(respuesta.datos,"8")); 

                                if(infoTorneoO.length>0){
                                    if(valorNumero(infoTorneoO[0].tienePartidos)>0) setTienePartidosUS(true);
                                    else setTienePartidosUS(false);
                                }

                                setEsTorneoNuevoUS(false);   
                                setShowParamConfigUS(false);
                                setShowParamJuegoUS(false);
                                setShowParamOpcionalUS(false);
 
                                generarDatosPresentar();
                            
                                registrarLogEventos(idModulo, "1", idTorneo,"");
                            } else if(tipoDatos==="INFO_ADMIN_TORNEO_NUEVO"){
                                presentarLog(nomClase + " - SOLICITA_DATOS"); 
    
                                guardarDatoLocal("ultAcceso" + idModulo + "Nuevo",Date.now());
                                guardarDatoLocal("datos" + idModulo + "Nuevo", respuesta.datos);
    
                                crearInfoParametros(crearTabla(respuesta.datos,"2"));
    
                                setEsTorneoNuevoUS(true);   
                                
                                generarDatosPresentar();
                            
                                registrarLogEventos(idModulo, "1", idTorneo,"");
                            } else if(tipoDatos==="CREAR_NUEVO_TORNEO"){

                                if(respuesta.datos==="-1"){
                                    titulo="";
                                    mensaje="Nombre del Torneo ya existe, corrija la información e intente nuevamente.";
                                    ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ALERTA","MEDIA");
                                }
                                else{
                                    setFlagUpdate(true);

                                    if(respuesta.datos===""){
                                            torneoNuevo=true;
                                            actualizar=false;

                                            salir();
                                    }
                                    else {
                                            torneoNuevo=false;
                                            idTorneo=respuesta.datos;

                                            titulo="";
                                            mensaje="Torneo creado con éxito.";
                                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                            paramsAjustado=idTorneo;
                                            guardarDatoLocal("ultParametros" + idModulo, idTorneo);
                    
                                            BD_solicitarDatos("INFO_INICIAL",[]);   
                                    } 
                                    
                                }
                                
                            } else if(tipoDatos==="ACTUALIZAR_CAMPOS_ADMIN_TORNEO"){
                                
                                //let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                                let fecha="";
    
                                let llaves=params.split(SEP_D_1);
                                for(let i=0;i<llaves.length;i++){
                                    let columnas=llaves[i].split(SEP_3);
                                    if(columnas.length===2){
                                        if(columnas[0]==="nombre") {
                                            infoTorneo[0][2]=columnas[1];
                                            infoTorneoO[0].nombre=columnas[1];
                                            setFlagUpdate(true);
                                        }
                                        else if(columnas[0]==="descripcion")  {
                                            infoTorneo[0][3]=columnas[1];
                                            infoTorneoO[0].descripcion=columnas[1];
                                            setFlagUpdate(true);
                                        }
                                        else if(columnas[0]==="horario")  {
                                            infoTorneo[0][4]=columnas[1];
                                            infoTorneoO[0].horario=columnas[1];
                                        }
                                        else if(columnas[0]==="fechainicio")  {
                                            if(columnas[1]!=="NULL") fecha=columnas[1];
                                            infoTorneo[0][10]=fecha;
                                            infoTorneoO[0].fechainicio=fecha;  
                                        }
                                        else if(columnas[0]==="fecha_maxreg")  {
                                            if(columnas[1]!=="NULL") fecha=columnas[1];
                                            infoTorneo[0][9]=fecha;
                                            infoTorneoO[0].fecha_maxreg=fecha;  

                                            if(!showFechaLimEquipoUS){
                                                infoTorneo[0][23]=fecha;
                                                infoTorneoO[0].fecha_max_equipo=fecha;
                                            }
                                        }
                                        else if(columnas[0]==="fecha_max_equipo")  {
                                            if(columnas[1]!=="NULL") fecha=columnas[1];
                                            infoTorneo[0][23]=fecha;
                                            infoTorneoO[0].fecha_max_equipo=fecha;   
                                        }
                                        else if(columnas[0]==="tipo_torneo")  {
                                            infoTorneo[0][11]=columnas[1];
                                            infoTorneoO[0].tipo_torneo=columnas[1];  
                                        }
                                        else if(columnas[0]==="puntos_ganador")  {
                                            infoTorneo[0][19]=columnas[1];
                                            infoTorneoO[0].puntos_ganador=columnas[1]; 
                                        }
                                        else if(columnas[0]==="puntos_empate")  {
                                            infoTorneo[0][20]=columnas[1];
                                            infoTorneoO[0].puntos_empate=columnas[1]; 
                                        }
                                        else if(columnas[0]==="perdedor_empate")  {
                                            infoTorneo[0][22]=columnas[1];
                                            infoTorneoO[0].perdedor_empate=columnas[1];  
                                        }
                                        else if(columnas[0]==="puntos_perdedor")  {
                                            infoTorneo[0][21]=columnas[1];
                                            infoTorneoO[0].puntos_perdedor=columnas[1]; 
                                        }
                                        else if(columnas[0]==="permite_empate")  {
                                            infoTorneo[0][12]=columnas[1];
                                            infoTorneoO[0].permite_empate=columnas[1];  
                                        }
                
                                    }
                                }
    
                                //setArrCampos(tempArreglo);                                                     
                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 
                            } else if(tipoDatos==="ACTUALIZAR_PARAMS_ADMIN_TORNEO"){

                                let llaves=params.split(SEP_D_1);
                                for(let i=0;i<llaves.length;i++){
                                    let columnas=llaves[i].split(SEP_3);

                                    if(columnas.length===2){
                                        for(let j=0;j<infoParametros.length;j++){
                                            if(infoParametros[j][0]===(columnas[0])){                                                
                                                infoParametros[j][9]=columnas[1];
                                                infoParametrosO[j].valorOriginal=columnas[1];
                                                j=infoParametros.length;
                                            }
                                        }
                
                                    }
                                }
                                                        
                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 

                            } else if(tipoDatos==="CANTIDADES_INFO_JUGADORES_SEDE"){
                                presentarLog("SOLICITA_CANTIDADES " + "DS"); 

                                let consultar="";

                                let datoRes= dividirLista(respuesta.datos,SEP,2);
                                let valGuardadoSede=recuperarDatoLocal("c" + ID_MODULO_INFO_EQUIPO + "s" + idSede);
                                let valGuardadoTorneo=recuperarDatoLocal("c" + ID_MODULO_INFO_EQUIPO + "t" + idTorneo);                               


                                if(datoRes[0]!=valGuardadoSede) consultar="SEDE";
                                if(datoRes[1]!=valGuardadoTorneo){
                                    if(consultar==="SEDE") consultar="TODO";
                                    else consultar="TORNEO";
                                }

                                if(consultar!==""){
                                    BD_solicitarDatos("RECUPERAR_INFO_JUGADORES_SEDE", consultar);   
                                    if(consultar==="SEDE") cargarDatosGuardadosAdicionales("DS", "TORNEO");  
                                    if(consultar==="TORNEO") cargarDatosGuardadosAdicionales("DS", "SEDE");                                
                                }
                                else cargarDatosGuardadosAdicionales("DS", "TODO");
                                
                            } else if(tipoDatos==="RECUPERAR_INFO_JUGADORES_SEDE"){
                                let tipo="DS";
                                presentarLog("SOLICITA_DATOS " + tipo); 

                                let consultar=params;

                                if(consultar==="TODO"){
                                    guardarDatoLocal("ultAcceso" + ID_MODULO_INFO_EQUIPO + tipo + "s" + idSede,Date.now());
                                    guardarDatoLocal("ultAcceso" + ID_MODULO_INFO_EQUIPO + tipo + "t" + idTorneo,Date.now());
                                    guardarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "s" + idSede, respuesta.datos);
                                    guardarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "t" + idTorneo, respuesta.datos);

                                    crearInfoJugadoresSede(crearTabla(respuesta.datos,"1"));
                                    crearInfoJugadoresTorneo(crearTabla(respuesta.datos,"2"));

                                    guardarDatoLocal("c" + ID_MODULO_INFO_EQUIPO + "s" + idSede, jugadoresSedeO.length);
                                    guardarDatoLocal("c" + ID_MODULO_INFO_EQUIPO + "t" + idTorneo, jugadoresTorneoO.length);
                                } else if(consultar==="SEDE"){
                                    guardarDatoLocal("ultAcceso" + ID_MODULO_INFO_EQUIPO + tipo + "s" + idSede,Date.now());
                                    guardarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "s" + idSede, respuesta.datos);

                                    crearInfoJugadoresSede(crearTabla(respuesta.datos,"1"));
                                    guardarDatoLocal("c" + ID_MODULO_INFO_EQUIPO + "s" + idSede, jugadoresSedeO.length);
                                } else if(consultar==="TORNEO"){
                                    guardarDatoLocal("ultAcceso" + ID_MODULO_INFO_EQUIPO + tipo + "t" + idTorneo,Date.now());
                                    guardarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "t" + idTorneo, respuesta.datos);

                                    crearInfoJugadoresTorneo(crearTabla(respuesta.datos,"2"));
                                    guardarDatoLocal("c" + ID_MODULO_INFO_EQUIPO + "t" + idTorneo, jugadoresTorneoO.length);
                                }
                                
                                datosSedeConsultados=true;

                                registrarLogEventos(idModulo, "9", idTorneo,"");
                            } else if(tipoDatos==="BORRAR_IMAGEN_SERVIDOR_TORNEO"){
                                // let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                                // tempArreglo[2].valor="";
                                // setArrCampos(tempArreglo);
                                                            
                                infoTorneo[0][6]="";
                                infoTorneoO[0].escudo="";
                                                            
                                titulo="";
                                mensaje="Imágen BORRADA con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA"); 
                                                            
                                reconstruirListasModulo(); 
                                generarDatosPresentar();
                                setFlagUpdate(true);
                            } else if(tipoDatos==="GUARDAR_IMAGEN_SERVIDOR"){
                                let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                                tempArreglo[2].valor=params;
                                setArrCampos(tempArreglo);

                                let newIndice=valorNumero(infoTorneoO[0].indiceEscudo) + 1;
                                infoTorneo[0][17]="" + newIndice;
                                infoTorneoO[0].indiceEscudo="" + newIndice; 

                                setFlagUpdate(true);

                                titulo="";
                                mensaje="Imágen actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA"); 

                                reconstruirListasModulo();
                                
                            } else if(tipoDatos==="ACTIVAR_INACTIVAR_EQUIPO_TORNEO"){
                                
                                let reg=params;

                                if(infoEquiposO[reg].activo==="1") {
                                    infoEquipos[reg][3]="0";
                                    infoEquiposO[reg].activo="0";
                                }
                                else {
                                    infoEquipos[reg][3]="1";
                                    infoEquiposO[reg].activo="1";
                                }

                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");
                                setFlagUpdate(true);
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 
                            } else if(tipoDatos==="RETIRAR_EQUIPO_TORNEO"){
                                let reg=params;
                                if(respuesta.datos==="-1"){
                                    infoEquipos[reg][6]="0";
                                    infoEquiposO[reg].borrado="0";

                                    titulo="";
                                    mensaje="Equipo No puede ser borrado del Torneo, Tiene partidos programados o pagos realizados.";
                                    ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR","MEDIA");
                                }
                                else{
                                    infoEquipos[reg][6]="1";
                                    infoEquiposO[reg].borrado="1";

                                    titulo="";
                                    mensaje="Información actualizada con éxito";
                                    ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");
                                }
                                                                
                                setFlagUpdate(true);
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 
                            } else if(tipoDatos==="INSCRIBIR_EQUIPOS_TORNEO"){
                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                setEquiposInscribirUS([]);

                                BD_solicitarDatos("INFO_DETALLE_EQUIPOS_TORNEO");
                            } else if(tipoDatos==="INFO_DETALLE_EQUIPOS_TORNEO"){
                                presentarLog(nomClase + " - SOLICITA_DATOS EQUIPOS"); 
        
                                crearInfoEquipos(crearTabla(respuesta.datos,"3")); 
 
                                setShowParamConfigUS(false);
                                setShowParamJuegoUS(false);
                                setShowParamOpcionalUS(false);
 
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 

                                setShowSeccionEquiposUS(true);

                                buscarTexto();
                            
                                //registrarLogEventos(idModulo, "1", idTorneo,"");
                            } else if(tipoDatos==="INFO_EQUIPOS_SEDE_NO_TORNEO"){
                                presentarLog(nomClase + " - SOLICITA_DATOS EQUIPOS_SEDE"); 

                                guardarDatoLocal("ultAcceso" + idModulo + "IES" + idSede,Date.now());
                                guardarDatoLocal("datos" + idModulo + "IES" + idSede, respuesta.datos);
        
                                crearInfoEquiposSede(crearTabla(respuesta.datos,"1")); 
                                setDatosCargadosBusqueda(true);

                                buscarTexto();
                            } else if(tipoDatos==="IMPORTAR_EQUIPO_SEDE_A_TORNEO"){
                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                BD_solicitarDatos("INFO_DETALLE_EQUIPOS_TORNEO");
                            } else if(tipoDatos==="INFO_JUGADORES_EQUIPO"){
                                presentarLog(nomClase + " - SOLICITA_DATOS JUGADORES_EQUIPO"); 
        
                                crearInfoJugadoresEquipoSel(crearTabla(respuesta.datos,"1")); 
                                setDatosCargadosBusqueda(true);

                                equiposSedeO[regEquipoNuevoSel].jugadores=jugadoresEquipoSelO;
                                
                                setInfoEquipoSelUS(equiposSedeO[regEquipoNuevoSel]);
                            } else if(tipoDatos==="GUARDAR_CONFIGURACION_GRUPOS_TORNEO"){
                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                setEquiposInscribirUS([]);

                                BD_solicitarDatos("INFO_DETALLE_EQUIPOS_TORNEO");
                            } else if(tipoDatos==="INFO_CANCHAS_SEDE"){
                                presentarLog(nomClase + " - SOLICITA_DATOS CANCHAS_SEDE"); 

                                guardarDatoLocal("ultAccesoICS" + idSede,Date.now());
                                guardarDatoLocal("datosICS" + idSede, respuesta.datos);
        
                                crearInfoCanchasSede(crearTabla(respuesta.datos,"1")); 
                                setDatosCargadosBusqueda(true);
                                guardarDatoLocal("infoCanchasSede",JSON.stringify(canchasSedeO));

                                buscarTexto();
                            } else if(tipoDatos==="RETIRAR_CANCHA_TORNEO"){
                                let reg=params;

                                infoCanchasO[reg][3]="1";
                                infoCanchasO[reg].borrado="1";

                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");
                                                                
                                setFlagUpdate(true);
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 
                            } else if(tipoDatos==="ASOCIAR_CANCHA_A_TORNEO"){
                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                BD_solicitarDatos("INFO_DETALLE_CANCHAS_TORNEO");
                            } else if(tipoDatos==="INFO_DETALLE_CANCHAS_TORNEO"){
                                presentarLog(nomClase + " - SOLICITA_DATOS CANCHAS"); 
        
                                crearInfoCanchas(crearTabla(respuesta.datos,"6")); 
 
                                setShowParamConfigUS(false);
                                setShowParamJuegoUS(false);
                                setShowParamOpcionalUS(false);
 
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 

                                setShowSeccionCanchasUS(true);

                                buscarTexto();
                            
                                //registrarLogEventos(idModulo, "1", idTorneo,"");
                            } else if(tipoDatos==="INFO_EQUIPOS_GRUPO_JORNADA"){
                                presentarLog(nomClase + " - SOLICITA_DATOS EGJ"); 
        
                                crearInfoEqGrupoJornada(crearTabla(respuesta.datos,"1"));        
                                
                                if(equiposGrupoJornadaO.length>0){
                                    let tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasINICIAL));

                                    for(let i=0;i<tempArreglo.length;i++){
                                        for(let j=0;j<tempArreglo[i].jornadas.length;j++){
                                            let c_jor=tempArreglo[i].jornadas[j];
                                            if(c_jor.tipoJornadaEliminacion==="2" || c_jor.tipoJornadaEliminacion==="3"){
                                                let tempGrupos=[];
                                                for(let k=0;k<equiposGrupoJornadaO.length;k++){
                                                    if(c_jor.idjornada===equiposGrupoJornadaO[k].idjornada){
                                                        tempGrupos.push(equiposGrupoJornadaO[k])
                                                    }
                                                }
                                                tempArreglo[i].jornadas[j].infoGrupos=tempGrupos;
                                                tempArreglo[i].jornadas[j].gruposGuadados=true;

                                            }
                                        }
                                    }

                                    infoGestionJornadasINICIAL=JSON.parse(JSON.stringify(tempArreglo));

                                    tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));

                                    for(let i=0;i<tempArreglo.length;i++){
                                        for(let j=0;j<tempArreglo[i].jornadas.length;j++){
                                            let c_jor=tempArreglo[i].jornadas[j];
                                            if(c_jor.tipoJornadaEliminacion==="2" || c_jor.tipoJornadaEliminacion==="3"){
                                                let tempGrupos=[];
                                                for(let k=0;k<equiposGrupoJornadaO.length;k++){
                                                    if(c_jor.idjornada===equiposGrupoJornadaO[k].idjornada){
                                                        tempGrupos.push(equiposGrupoJornadaO[k])
                                                    }
                                                }
                                                tempArreglo[i].jornadas[j].infoGrupos=tempGrupos;
                                                tempArreglo[i].jornadas[j].gruposGuadados=true;

                                            }
                                        }
                                    }

                                    setIinfoGestionJornadasUS(tempArreglo);  
                                }

                                setConsultoInfoEGJUS(true);
                                consultoInfoEGJ=true;
                               
                            } else if(tipoDatos==="GUARDAR_CONFIGURACION_JORNADAS"){
                                titulo="";
                                mensaje="Información actualizada con éxito";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                BD_solicitarDatos("INFO_DETALLE_JORNADAS_TORNEO");
                            } else if(tipoDatos==="INFO_DETALLE_JORNADAS_TORNEO"){
                                presentarLog(nomClase + " - SOLICITA_DATOS JORNADAS"); 
        
                                crearInfoJornadas(crearTabla(respuesta.datos,"4")); 
 
                                setShowParamConfigUS(false);
                                setShowParamJuegoUS(false);
                                setShowParamOpcionalUS(false);
                                setShowSeccionJornadasUS(true);

                                consultoInfoEGJ=false;
                                setConsultoInfoEGJUS(false);
 
                                reconstruirListasModulo();  
                                generarDatosPresentar(); 

                                

                            } 
            
                        } else {
                            if(respuesta.conectado){
                                reportarError( nomClase, nomFuncion, respuesta.mensaje, "");
                                if(mostrarError) setEsError(1);
                            } 
                            else{    
                                presentarError(nomClase,nomFuncion,respuesta.mensaje,"");                        
                                setEsError(2);
                            }                       
                        }

                    }catch(err){
                        reportarError( nomClase, nomFuncion, "", err);
                    } 
                    
        
                    setLoading(false);
                    
                });
            }
            
           

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    } 

    const cargarDatosGuardadosModulo = () => {
        let nomFuncion="cargarDatosGuardadosModulo"; 

        try{             
            presentarLog(nomClase + " - RECUPERA_DATOS"); 
            let datosModulo=recuperarDatoLocal("datos" + idModulo + idTorneo);

            if(datosModulo!==""){
                crearInfoTorneo(crearTabla(datosModulo,"1"));
                crearInfoParametros(crearTabla(datosModulo,"2"));
                crearInfoEquipos(crearTabla(datosModulo,"3")); 
                crearInfoJornadas(crearTabla(datosModulo,"4")); 
                crearInfoArbitros(crearTabla(datosModulo,"5")); 
                crearInfoCanchas(crearTabla(datosModulo,"6")); 
                crearInfoCobros(crearTabla(datosModulo,"7")); 
                crearInfoCampos(crearTabla(datosModulo,"8")); 

                if(infoTorneoO.length>0){
                    if(valorNumero(infoTorneoO[0].tienePartidos)>0) setTienePartidosUS(true);
                    else setTienePartidosUS(false);
                }

                setEsTorneoNuevoUS(false);   
                setShowParamConfigUS(false);
                setShowParamJuegoUS(false);
                setShowParamOpcionalUS(false);
                                
                generarDatosPresentar();

            } 
            else BD_solicitarDatos("INFO_INICIAL",[]);

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 
    }

    const cargarDatosGuardadosModuloNuevo = () => {
        let nomFuncion="cargarDatosGuardadosModuloNuevo"; 

        try{             
            presentarLog(nomClase + " - RECUPERA_DATOS"); 
            let datosModulo=recuperarDatoLocal("datos" + idModulo + "Nuevo");

            if(datosModulo!==""){
                crearInfoParametros(crearTabla(datosModulo,"2"));
                
                setEsTorneoNuevoUS(true);                  
                generarDatosPresentar();

            } 
            else BD_solicitarDatos("INFO_ADMIN_TORNEO_NUEVO",[]);

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 
    }

    const cargarDatosGuardadosEquiposSede = () => {
        let nomFuncion="cargarDatosGuardadosEquiposSede"; 

        try{             
            presentarLog(nomClase + " - RECUPERA_DATOS EQUIPOS_SEDE"); 
            let datosModulo=recuperarDatoLocal("datos" + idModulo + "IES" + idSede);

            if(datosModulo!==""){
                crearInfoEquiposSede(crearTabla(datosModulo,"1"));   
                setDatosCargadosBusqueda(true);      
                buscarTexto();                         

            } 
            else BD_solicitarDatos("INFO_EQUIPOS_SEDE_NO_TORNEO"); 

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 
    }

    const cargarDatosGuardadosCanchasSede = () => {
        let nomFuncion="cargarDatosGuardadosCanchasSede"; 

        try{             
            presentarLog(nomClase + " - RECUPERA_DATOS CANCHAS_SEDE"); 
            let datosModulo=recuperarDatoLocal("datosICS" + idSede);

            if(datosModulo!==""){
                crearInfoCanchasSede(crearTabla(datosModulo,"1"));   
                setDatosCargadosBusqueda(true);  
                guardarDatoLocal("infoCanchasSede",JSON.stringify(canchasSedeO));

                buscarTexto();
            } 
            else BD_solicitarDatos("INFO_CANCHAS_SEDE"); 

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 
    }

    const cargarDatosGuardadosAdicionales = (tipo, consultar) => {
        let nomFuncion="cargarDatosGuardadosAdicionales"; 

        try{             
            presentarLog("RECUPERA_DATOS " + tipo); 


            if(consultar==="TODO"){
                let datosModuloSede=recuperarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "s" + idSede);
                let datosModuloTorneo=recuperarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "t" + idTorneo);
                let consultarNuevo="";
                
                if(datosModuloSede!==""){
                    crearInfoJugadoresSede(crearTabla(datosModuloSede,"1"));
                    
                    datosSedeConsultados=true;
                } 
                else consultarNuevo="SEDE";

                if(datosModuloTorneo!==""){
                    crearInfoJugadoresTorneo(crearTabla(datosModuloTorneo,"2"));  
                                        
                    datosSedeConsultados=true;
                } 
                else{
                    if(consultarNuevo==="SEDE") consultarNuevo="TODO";
                    else consultarNuevo="TORNEO";
                }

                if(consultarNuevo!=="") BD_solicitarDatos("RECUPERAR_INFO_JUGADORES_SEDE", consultarNuevo);
            } else if(consultar==="SEDE"){
                let datosModuloSede=recuperarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "s" + idSede);
                
                if(datosModuloSede!==""){
                    crearInfoJugadoresSede(crearTabla(datosModuloSede,"1"));
                    
                    datosSedeConsultados=true;
                } 
                else BD_solicitarDatos("RECUPERAR_INFO_JUGADORES_SEDE", "SEDE");

            } else if(consultar==="TORNEO"){
                let datosModuloTorneo=recuperarDatoLocal("datos" + ID_MODULO_INFO_EQUIPO + tipo + "t" + idTorneo);
                
                if(datosModuloTorneo!==""){
                    crearInfoJugadoresTorneo(crearTabla(datosModuloTorneo,"2"));
                    
                    datosSedeConsultados=true;
                } 
                else BD_solicitarDatos("RECUPERAR_INFO_JUGADORES_SEDE", "TORNEO");

            }
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 
    }

    const reconstruirListasModulo = () => {
        let nomFuncion="reconstruirListasModulo"; 

        try{ 
            
            let datosFinales=[];
            datosFinales=reconstruirDatosOrigen(datosFinales,infoTorneo,"1");
            datosFinales=reconstruirDatosOrigen(datosFinales,infoParametros,"2");
            datosFinales=reconstruirDatosOrigen(datosFinales,infoEquipos,"3");
            datosFinales=reconstruirDatosOrigen(datosFinales,infoJornadas,"4");
            datosFinales=reconstruirDatosOrigen(datosFinales,infoArbitros,"5");
            datosFinales=reconstruirDatosOrigen(datosFinales,infoCanchas,"6");
            datosFinales=reconstruirDatosOrigen(datosFinales,infoCobros,"7");
            datosFinales=reconstruirDatosOrigen(datosFinales,infoCampos,"8");
            
            guardarDatoLocal("datos" + idModulo + idTorneo, datosFinales);

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    } 

    const generarDatosPresentar = () => {
        let nomFuncion="generarDatosPresentar";

        try{
            let datosTemp=JSON.parse(JSON.stringify(datosMod));         
            let tempArreglo=JSON.parse(JSON.stringify(arrCampos));

            //LLENAR PARAMETROS

            let tempPJuego=[];
            let tempPOpcional=[];
            //let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
            tempArreglo[9].valor=[];
            tempArreglo[9].ultValor=[];
            tempArreglo[9].error=[];
            tempArreglo[9].regParams=[];
            tempArreglo[10].valor=[];
            tempArreglo[10].ultValor=[];
            tempArreglo[10].error=[];  
            tempArreglo[10].regParams=[];           

            if(infoParametrosO.length>0){
                let i;
                for(i=0;i<infoParametrosO.length;i++){

                    if(infoParametrosO[i].tipo==="1"){
                       tempPJuego.push(infoParametrosO[i]);
                       tempArreglo[9].valor.push(infoParametrosO[i].valorOriginal);
                       tempArreglo[9].ultValor.push(infoParametrosO[i].valorOriginal);                       
                       tempArreglo[9].error.push("");
                       tempArreglo[9].regParams.push(i);
                    }
                    else if(infoParametrosO[i].tipo==="2"){
                       tempPOpcional.push(infoParametrosO[i]);
                       tempArreglo[10].valor.push(infoParametrosO[i].valorOriginal);
                       tempArreglo[10].ultValor.push(infoParametrosO[i].valorOriginal);                       
                       tempArreglo[10].error.push("");
                       tempArreglo[10].regParams.push(i);
                    }
                }
            }

            setParametrosJuegoUS(tempPJuego);
            setParametrosOpcionalUS(tempPOpcional);

            ////

            datosTemp.nomUsuario=recuperarDatoLocal("nomUsuario");
            datosTemp.nomEmpresa=recuperarDatoLocal("nomEmpresa");
            datosTemp.nomSede=recuperarDatoLocal("nomSede");
            datosTemp.fotoUsuario=recuperarDatoLocal("fotoUsuario");
            if(datosTemp.fotoUsuario!=="") datosTemp.fotoUsuario= ruta + datosTemp.fotoUsuario;
            else datosTemp.fotoUsuario=ic_jugadorsinimagen;

            
            if(!torneoNuevo){
                datosTemp.nomTorneo=infoTorneoO[0].nombre;
                if(infoTorneoO[0].escudo!=="") datosTemp.escudoTorneo= ruta + infoTorneoO[0].escudo;
                else datosTemp.escudoTorneo=ic_torneo_gris_w;  

                datosTemp.descTorneo= infoTorneoO[0].descripcion;
                datosTemp.reglamento= infoTorneoO[0].reglamento;
                datosTemp.activo= infoTorneoO[0].activo;

                tempArreglo[0].valor=datosTemp.nomTorneo;
                tempArreglo[0].ultValor=datosTemp.nomTorneo;
                tempArreglo[1].valor=datosTemp.descTorneo;
                tempArreglo[1].ultValor=datosTemp.descTorneo;
                tempArreglo[2].valor=datosTemp.escudoTorneo;
                tempArreglo[2].ultValor=datosTemp.escudoTorneo;
                if(datosTemp.reglamento!=="") tempArreglo[16].valor=ruta + datosTemp.reglamento;
                else tempArreglo[16].valor="";
                tempArreglo[16].ultValor=tempArreglo[16].valor;

                tempArreglo[3].valor=infoTorneoO[0].horario;
                tempArreglo[3].ultValor=infoTorneoO[0].horario;
                tempArreglo[15].valor=generarTextoDiasSemana(infoTorneoO[0].horario);
                tempArreglo[4].valor=infoTorneoO[0].fechainicio;
                tempArreglo[4].ultValor=infoTorneoO[0].fechainicio;
                tempArreglo[5].valor=infoTorneoO[0].fecha_maxreg;
                tempArreglo[5].ultValor=infoTorneoO[0].fecha_maxreg;
                tempArreglo[6].valor=infoTorneoO[0].fecha_max_equipo;
                tempArreglo[6].ultValor=infoTorneoO[0].fecha_max_equipo;
                if(infoTorneoO[0].fecha_maxreg!==infoTorneoO[0].fecha_max_equipo) setShowFechaLimEquipoUS(true);
                else setShowFechaLimEquipoUS(false); 

                tempArreglo[7].valor=infoTorneoO[0].tipo_torneo;
                tempArreglo[7].ultValor=infoTorneoO[0].tipo_torneo;
                tempArreglo[8].valor=infoTorneoO[0].permite_empate;
                tempArreglo[8].ultValor=infoTorneoO[0].permite_empate;

                tempArreglo[11].valor=infoTorneoO[0].puntos_ganador;
                tempArreglo[11].ultValor=infoTorneoO[0].puntos_ganador;
                tempArreglo[12].valor=infoTorneoO[0].puntos_empate;
                tempArreglo[12].ultValor=infoTorneoO[0].puntos_empate;
                tempArreglo[13].valor=infoTorneoO[0].perdedor_empate;
                tempArreglo[13].ultValor=infoTorneoO[0].perdedor_empate;
                tempArreglo[14].valor=infoTorneoO[0].puntos_perdedor;
                tempArreglo[14].ultValor=infoTorneoO[0].puntos_perdedor;

                if(infoTorneoO[0].tipo_torneo==="0" || infoTorneoO[0].tipo_torneo==="5") setPermiteEmpatesFGUS(false);
                else setPermiteEmpatesFGUS(true);

                

                let temp_tipoTorneo=JSON.parse(JSON.stringify(tipoTorneos));
                temp_tipoTorneo.splice(0,1);
                
                if(valorNumero(infoTorneoO[0].tienePartidos)>0){
                    if(infoTorneoO[0].tipo_torneo==="5"){
                        temp_tipoTorneo=[];
                        temp_tipoTorneo.push(tipoTorneos[5]); 
                    }                    
                }

                setListaTipoTorneoUS(temp_tipoTorneo);
                setTipoTorneoSelUS(seleccionarItemLista(temp_tipoTorneo, infoTorneoO[0].tipo_torneo));

                //ARMAR LISTA DE EQUIPOS
                let contEquipos=0;
                let grupoActual="0";
                    let numeroEq=0;
                    for(let i=0;i<infoEquiposO.length;i++){

                        if(infoEquiposO[i].borrado==="0") contEquipos++;

                        if(infoTorneoO[0].tipo_torneo===("3") || infoTorneoO[0].tipo_torneo===("4")){
                            if(i===0) {
                                numeroEq++;
                                infoEquiposO[i].esCambioGrupo="1";                              
                                grupoActual=infoEquiposO[i].numgrupo; 
                            }
                            else if(infoEquiposO[i].numgrupo!==grupoActual){
                                numeroEq=1;
                                infoEquiposO[i].esCambioGrupo="1"; 
                                grupoActual=infoEquiposO[i].numgrupo;                            
                            }
                            else{
                                numeroEq++; 
                            }
                            infoEquiposO[i].numequipo="" + numeroEq;
                        }
                        
                    }
                
                setInfoEquiposUS(infoEquiposO);
                setCantEquiposUS(contEquipos);


                //ARMAR LISTA DE CANCHAS
                let contCanchas=0;
                    for(let i=0;i<infoCanchasO.length;i++){
                        if(infoCanchasO[i].borrado==="0") contCanchas++;                        
                    }
                
                setInfoCanchasUS(infoCanchasO);
                setCantCanchasUS(contCanchas);

                

                //ARMAR LISTA JORNADAS
                let copaActual="";
                let contCopas=0;
                let tempCopas=[];
                let tempJornadas=[];
                
                let regCopa=Object.assign({} , copa);
                for(let i=0;i<infoJornadasO.length;i++){

                    if(infoJornadasO[i].idcopa!==copaActual){
                        if(tempJornadas.length>0){
                                tempCopas[contCopas].jornadas=tempJornadas;
                                tempJornadas=[];
                                contCopas++; 
                        }
                            
                        regCopa=Object.assign({} , copa);
                        regCopa.idcopa=infoJornadasO[i].idcopa;
                        regCopa.nombreCopa=infoJornadasO[i].nombreCopa;
                        regCopa.jornadas=[];
                        tempCopas.push(regCopa);

                        copaActual=infoJornadasO[i].idcopa;
                    }

                    let regJornada=Object.assign({} , jornada);
                        regJornada.idjornada=infoJornadasO[i].idjornada;
                        regJornada.nombreJornada=infoJornadasO[i].nombreJornada;
                        regJornada.tienePartidos=infoJornadasO[i].tienePartidos;
                        regJornada.tipoJornadaEliminacion=infoJornadasO[i].tipoJornadaEliminacion;
                        /*if(infoJornadasO[i].tipoJornadaEliminacion==="0") regJornada.nombreTJE="Partido Único";
                        if(infoJornadasO[i].tipoJornadaEliminacion==="1") regJornada.nombreTJE="Partido Ida y Vuelta";
                        if(infoJornadasO[i].tipoJornadaEliminacion==="2") regJornada.nombreTJE="Grupos - Partido Único";
                        if(infoJornadasO[i].tipoJornadaEliminacion==="3") regJornada.nombreTJE="Grupos - Ida y Vuelta";*/
                        regJornada.tipoJornadaSel=valorNumero(infoJornadasO[i].tipoJornadaEliminacion);
                        regJornada.nombreTJE=listaJornadasEliminacion[regJornada.tipoJornadaSel].label
                        tempJornadas.push(regJornada);

                    if(regJornada.tienePartidos!=="0") tempCopas[contCopas].tienePartidos=true;
                }

                if(tempJornadas.length>0){
                    tempCopas[contCopas].jornadas=tempJornadas;
                    tempJornadas=[];
                }

                setCantJornadasUS(infoJornadasO.length);
                setInfoJornadasUS(tempCopas);

                infoGestionJornadasINICIAL=JSON.parse(JSON.stringify(tempCopas));
                let tempIngoGestionJornadas=JSON.parse(JSON.stringify(tempCopas));
                if(tempIngoGestionJornadas.length===0){                        
                    tempIngoGestionJornadas.push(copa);
                }
                setIinfoGestionJornadasUS(tempIngoGestionJornadas);
                                
            }
            else{
                datosTemp.nomTorneo="Nuevo Torneo";
                datosTemp.escudoTorneo=ic_torneo_gris_w; 
            }
            

            datosTemp.tituloVentana="Administración Torneos";
            datosTemp.rolUsuario="Administrador:";       
            
            setArrCampos(tempArreglo); 
            setDatosMod(datosTemp);


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 

    }

    const buscarParametro = (id) => {
        let nomFuncion="buscarParametro"; 

        let respuesta="";
        try{ 
            
            for(let i=0; i<infoParametrosO.length; i++){
                if(infoParametrosO[i].idparametro===id){
                    respuesta=infoParametrosO[i].valorOriginal;
                    i=infoParametrosO.length;
                }
            }
                                            
                            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  

        return respuesta;
    } 
        

    const validarCampo = (e, campo, maxlen) => {
        let nomFuncion="validarCampo"; 

        try{
            let newValor = e.target.value;
            if(!campo.includes("PARAMETRO_") && maxlen!==null && newValor.length>maxlen) newValor=newValor.substring(0,maxlen);

            let tempArreglo=JSON.parse(JSON.stringify(arrCampos));

            if(campo==="NOMBRE_TORNEO"){  
                tempArreglo[0].error=matrizCampos[0].error;
                
                tempArreglo[0].valor=newValor; 
                if(newValor.length>=3) tempArreglo[0].error="";   
                
                setArrCampos(tempArreglo);  
            } else if(campo==="DESCRIPCION"){  
                //tempArreglo[1].error=matrizCampos[1].error;
                
                tempArreglo[1].valor=newValor; 
                    //if(newValor.length>=3) tempArreglo[1].error="";   
                
                setArrCampos(tempArreglo);  
            } else if(campo==="PUNTOS_GANADOR"){  
                tempArreglo[0].error=matrizCampos[0].error;

                let valNum=valorNumero(newValor);
                if(valNum>=1 && valNum<=5){
                    tempArreglo[0].valor=newValor; 
                    tempArreglo[0].error="";  
                }
                  
                
                setArrCampos(tempArreglo);  
            } else if(campo==="TEXTO_RESALTAR"){
                tempArreglo[4].error="";
                tempArreglo[4].valor=newValor; 
                setArrCampos(tempArreglo);  
            } else if(campo==="TEXTO_PUNTOS_BARRA"){
                tempArreglo[5].error="";
                if(newValor==="") tempArreglo[5].valor=newValor;                
                else{
                    if(esformatoNumero(newValor))  tempArreglo[5].valor=newValor;                    
                }   
                setArrCampos(tempArreglo); 
            } else if(campo==="FILTRO_BUSQUEDA_TELEFONO"){
                if(newValor==="" || esformatoNumero(newValor)) {
                    tempArreglo[17].valor=newValor;
                    if(newValor.length<10) tempArreglo[17].error="Ingrese un teléfono de MÍNIMO 10 números.";
                    else if(newValor.length>=10 && newValor.length<15) tempArreglo[17].error="";
                    
                    setArrCampos(tempArreglo);  
                    textoBuscar=newValor;
                }
                
                cancelarBusqueda=true;
                buscarTexto();
            } else if(campo==="FILTRO_BUSQUEDA_NOMBRE"){

                tempArreglo[17].error="";                
                tempArreglo[17].valor=newValor; 

                if(newValor==="") {
                    tempArreglo[17].error="Ingrese el nombre del usuario a buscar.";
                }

                setArrCampos(tempArreglo);  
                textoBuscar=newValor;
                
                cancelarBusqueda=true;
                buscarTexto();                

            } else if(campo==="CAMBIAR_PRMITE_EMPATES"){
                let permiteEmpates="0";

                let puntosGanador="3";
                let puntosGanadorEmpate="1";
                let puntosPerdedorEmpate="1";
                let puntosPerdedor="0";

                if(arrCampos[8].valor==="1") permiteEmpates="0";
                else permiteEmpates="1";

                    tempArreglo[8].valor=permiteEmpates;
                    if(permiteEmpates==="1"){  
                        puntosGanadorEmpate="1";
                        puntosPerdedorEmpate="1";
                        //setPermiteEmpatesFGUS(true);
                    }
                    else{
                        puntosGanadorEmpate="2";
                        puntosPerdedorEmpate="1";
                        //setPermiteEmpatesFGUS(false);
                    }

                    tempArreglo[8].valor= permiteEmpates;
                    tempArreglo[11].valor= puntosGanador;
                    tempArreglo[12].valor= puntosGanadorEmpate;
                    tempArreglo[13].valor= puntosPerdedorEmpate;
                    tempArreglo[14].valor= puntosPerdedor;

                    setArrCampos(tempArreglo); 

                    if(!esTorneoNuevoUS){
                        let txtActualizar="puntos_ganador" + SEP_3 + puntosGanador + SEP_D_1;
                        txtActualizar=txtActualizar + "puntos_empate" + SEP_3 + puntosGanadorEmpate + SEP_D_1;
                        txtActualizar=txtActualizar + "perdedor_empate" + SEP_3 + puntosPerdedorEmpate + SEP_D_1;
                        txtActualizar=txtActualizar + "puntos_perdedor" + SEP_3 + puntosPerdedor + SEP_D_1;
                        txtActualizar=txtActualizar + "permite_empate" + SEP_3 + permiteEmpates;                                    

                        BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);
                    }
                    
            } else if(campo==="CAMBIAR_PARAMETRO_JUEGO"){
                let i=maxlen;
                if(arrCampos[9].valor[i]==="1") tempArreglo[9].valor[i]="0"; 
                else tempArreglo[9].valor[i]="1"; 

                setArrCampos(tempArreglo); 

                clickGenerico("SALE_PARAMETRO_JUEGO", tempArreglo);

            } else if(campo==="CAMBIAR_PARAMETRO_OPCIONAL"){
                let i=maxlen;
                if(arrCampos[10].valor[i]==="1") tempArreglo[10].valor[i]="0"; 
                else tempArreglo[10].valor[i]="1"; 

                setArrCampos(tempArreglo); 

                clickGenerico("SALE_PARAMETRO_OPCIONAL", tempArreglo);

            } else if(campo==="PARAMETRO_JUEGO"){
                if(newValor.length>4) newValor=newValor.substring(0,4);
                let hayError=false;

                if(esformatoNumero(newValor) || newValor===""){
                    let i=maxlen[0];
                    let valMin=maxlen[1];
                    let valMax=maxlen[2];
                    tempArreglo[9].error[i]="Valor Fuera de Rango";

                    let valor=valorNumero(newValor);

                    if(valor>=valMin && valor<=valMax) tempArreglo[9].error[i]="";     
                    else hayError=true;               
                    
                    tempArreglo[9].valor[i]=newValor;                       
                }


                let v5=0, v6=0, v7=0, v8=0, v10=0;
                let i5=0, i6=0, i7=0, i8=0, i10=0;


                for(let i=0;i<parametrosJuegoUS.length;i++){
                    if(parametrosJuegoUS[i].idparametro==="5"){
                        v5=valorNumero(tempArreglo[9].valor[i]); 
                        i5=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    } 
                    if(parametrosJuegoUS[i].idparametro==="6"){
                        v6=valorNumero(tempArreglo[9].valor[i]);
                        i6=i;
                    } 
                    if(parametrosJuegoUS[i].idparametro==="7"){
                        v7=valorNumero(tempArreglo[9].valor[i]);
                        i7=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    }
                    if(parametrosJuegoUS[i].idparametro==="8"){
                        v8=valorNumero(tempArreglo[9].valor[i]);
                        i8=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    }
                    if(parametrosJuegoUS[i].idparametro==="10"){
                        v10=valorNumero(tempArreglo[9].valor[i]);
                        i10=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    }
                }

                if(tempArreglo[9].error[i8]===""){
                    if(v7<v8){
                        tempArreglo[9].error[i8]="Mayor a Jugadores en Cancha"; 
                        hayError=true;
                    } 
                }
                
                if(tempArreglo[9].error[i10]===""){
                    if(v10<((v6*2) + v5)) {
                        tempArreglo[9].error[i10]="Tiempo Insuficiente";
                        hayError=true;
                    }
                }
                

                setArrCampos(tempArreglo); 
                
            } else if(campo==="PARAMETRO_OPCIONAL"){
                if(newValor.length>4) newValor=newValor.substring(0,4);

                if(esformatoNumero(newValor) || newValor===""){
                    let i=maxlen[0];
                    let valMin=maxlen[1];
                    let valMax=maxlen[2];
                    tempArreglo[10].error[i]="Valor Fuera de Rango";

                    let valor=valorNumero(newValor);

                    if(valor>=valMin && valor<=valMax) tempArreglo[10].error[i]="";                    
                    
                    tempArreglo[10].valor[i]=newValor;              
                    
                    setArrCampos(tempArreglo); 
                }
            } else if(campo==="PUNTOS_PARTIDO"){
                if(newValor.length>1) newValor=newValor.substring(0,1);

                if(esformatoNumero(newValor) || newValor===""){
                    let tipo=maxlen;

                    let vGanador=valorNumero(arrCampos[11].valor);
                    let vGanadorEmp=valorNumero(arrCampos[12].valor);
                    let vPerdedorEmp=valorNumero(arrCampos[13].valor);
                    let vPerdedor=valorNumero(arrCampos[14].valor);

                    tempArreglo[11].error=""; 

                    if(tipo==="GANADOR"){                                              
                        tempArreglo[11].valor=newValor; 
                        vGanador= newValor;                               
                    }
                    else if(tipo==="GANADOR_EMPATE"){
                        tempArreglo[12].valor=newValor;  
                        vGanadorEmp= newValor; 
                    }
                    else if(tipo==="PERDEDOR_EMPATE"){
                        tempArreglo[13].valor=newValor; 
                        vPerdedorEmp= newValor;  
                    }
                    else if(tipo==="PERDEDOR"){
                        tempArreglo[14].valor=newValor; 
                        vPerdedor= newValor;  
                    }

                    if(arrCampos[7].valor!=="5"){
                        if(vGanador<=vGanadorEmp) tempArreglo[11].error="Puntos Ganador debe ser Mayor a puntos Empate";  
                        else if(vGanador<=vPerdedor) tempArreglo[11].error="Puntos Ganador debe ser Mayor a puntos Perdedor"; 
                        else if(vGanadorEmp<vPerdedor) tempArreglo[11].error="Puntos Empate debe ser Mayor o Igual a puntos Perdedor";   
                        else{
                            if(arrCampos[8].valor==="0"){ //SI NO PERMITE EMPATES
                                if(vGanadorEmp<=vPerdedorEmp) tempArreglo[11].error="Puntos Ganador-Empate debe ser Mayor a puntos Perdedor-Empate";   
                            }
                        }  
                    }
                    else{
                        if(vGanador<=vPerdedor) tempArreglo[11].error="Puntos Ganador debe ser Mayor a puntos Perdedor"; 
                    }
                     
                    setArrCampos(tempArreglo); 

                    
                }
            }        
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }         
        
    }

    const validarCampoCopa = (e, campo, maxlen, index) => {
        let nomFuncion="validarCampoCopa"; 

        try{
            let newValor = e.target.value;
            if(!campo.includes("PARAMETRO_") && maxlen!==null && newValor.length>maxlen) newValor=newValor.substring(0,maxlen);

            let tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));

            if(campo==="NOMBRE_COPA"){  
                tempArreglo[index].nombreCopa=newValor;  
                
                setIinfoGestionJornadasUS(tempArreglo);  
            } 
            else if(campo==="NOMBRE_JORNADA"){  
                tempArreglo[jornadaSelUS].jornadas[index].nombreJornada=newValor;  
                
                setIinfoGestionJornadasUS(tempArreglo);  
            }        
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }         
        
    }

    const clickGenerico = (donde, params=null) => {
        let nomFuncion="clickGenerico"; 

        try{
            
            let tempArreglo=null;
            let txtActualizar="";
            let newFecha="";
            let i=0, j=0;
            let idx=0;

            let tempOpciones=[];
            let txtOpcion="";
            let valOpcion="";
            
            switch(donde) {
 
                case "CLICK_PARAMETROS":
                    setShowParametros(!showParametros);
                         
                    break;     
                case "CLICK_OPCIONES":
                    setShowOpciones(!showOpciones);
                             
                    break;    
                case "CLICK_MODIFCAR_ESCUDO":
                        listaOrigenSel="";
                        setTipoImagenSelUS("TORNEO");
                        setImgActualSelUS(arrCampos[2].valor);
                        openImagen();
                    break;
                case "SALE_NOMBRE_TORNEO":
                    if(!esTorneoNuevoUS && arrCampos[0].error===""){
                        let nuevoDato=quitarCharEspeciales(arrCampos[0].valor);
                        nuevoDato=formatearTexto(nuevoDato,2);
                        let txtActualizar="nombre" + SEP_3 + nuevoDato;
                        if(nuevoDato!==arrCampos[0].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);
                    }
                    break;
                case "SALE_DESCRIPCION":
                    if(!esTorneoNuevoUS && arrCampos[1].error===""){
                        let nuevoDato=quitarCharEspeciales(arrCampos[1].valor);
                        //nuevoDato=formatearTexto(nuevoDato,2);
                        let txtActualizar="descripcion" + SEP_3 + nuevoDato;
                        if(nuevoDato!==arrCampos[1].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);
                    }
                    break; 
                case "ABRIR_BUSQUEDA_INSCRIBIR_DELEGADO":
                    tipoSeleccion="Telefono_Delegado";
                    regEquipoNuevoSel=params;
                    let tempBusqueda=JSON.parse(JSON.stringify(infoBusquedaBase));
                    tempBusqueda.tipoLista="Busqueda_Telefono_Delegado";
                    tempBusqueda.titulo="Incluir Delegado";
                    tempBusqueda.texto="Escriba o copie el número de telefono del Delegado del Equipo a Inscribir. Mínimo 10 dígitos.";

                    setInfoBusquedaUS(tempBusqueda);

                    setDatosCargadosBusqueda(true);
                    abrirVentanaBusqueda();

                    break;
                case "CLICK_INCLUIR_JUGADOR_BUSQUEDA":

                    tempArreglo=JSON.parse(JSON.stringify(equiposInscribirUS));
   
                    tempArreglo[regEquipoNuevoSel].telefono=params.telefono;
                    tempArreglo[regEquipoNuevoSel].datos=params;
                    tempArreglo[regEquipoNuevoSel].error="";

                    setEquiposInscribirUS(tempArreglo);
                    closeBusqueda();                    

                    break;                
                case "CERRAR_MODAL_IMAGEN":
                    closeImagen();
                    listaOrigenSel="";
                    regListaSel=-1;
                    regCampoSel=-1;

                    break;
                case "GUARDAR_IMAGEN_SERVIDOR":

                    closeImagen();                    

                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                        tempArreglo[2].valor=params;
                        setArrCampos(tempArreglo);

                    BD_solicitarDatos("GUARDAR_IMAGEN_SERVIDOR",params);                   
    
                    break;
                case "SOLICITAR_CONFIRMACION_BORRADO_IMAGEN":
                    titulo="CONFIRMAR BORRADO";
                    mensaje="Esta acción borrará la Imágen Actualmente cargada. Esta de acuerdo?";
                    ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_BORRADO_IMAGEN");
    
                    break;
                case "ACEPTAR_BORRADO_IMAGEN":  
                    setShowMensaje(false);
                    closeImagen();  

                    let tempDatos=JSON.parse(JSON.stringify(arrCampos));
                        tempDatos[11].valor=ic_torneo_gris_w;
                        setArrCampos(tempDatos);

                        BD_solicitarDatos("BORRAR_IMAGEN_SERVIDOR_TORNEO");                    
                    
                    break;
                case "MOSTRAR_FOTO":
                    if(params!==""){
                        setSrcFotoUS(params);
                        openFoto();
                    }

                    titulo="NO MODIFICABLE";
                    mensaje="Fecha de Modificaciones superada. No puede Modificar los datos adicionales. Consulte con Organizador del Torneo.";
                    ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO");
                    

                    break;
                case "CALENDARIO_INICIO_TORNEO":
                        listaOrigenSel="INICIO_TORNEO";
                        setSelectedDate(arrCampos[4].valor);
                        openCalendar();
    
                        break;
                case "CALENDARIO_LIMITE_PLANTILLA":
                        listaOrigenSel="LIMITE_PLANTILLA";
                        setSelectedDate(arrCampos[5].valor);
                        openCalendar();
    
                        break;
                case "CALENDARIO_LIMITE_EQUIPO":
                        listaOrigenSel="LIMITE_EQUIPO";
                        setSelectedDate(arrCampos[6].valor);
                        openCalendar();
    
                        break;
                case "SELECCIONAR_FECHAS":
                                    setSelectedDate("");
                                    closeCalendar();
                
                                    let fecha=params;
                                    let ano=fecha.getFullYear();
                                    let mes=fecha.getMonth() + 1;
                                    let dia=fecha.getUTCDate();
                                    
                                    mes="00" + mes;
                                    let lenMes=mes.length;
                                    mes=mes.substring(lenMes-2);
                
                                    dia="00" + dia;
                                    let lenDia=dia.length;
                                    dia=dia.substring(lenDia-2);
                
                                    newFecha=ano + "-" + mes + "-" + dia;

                                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                
                                    if(listaOrigenSel==="INICIO_TORNEO"){ 
                                        tempArreglo[4].error= "";                                 
                                        tempArreglo[4].valor=newFecha; 
                                        txtActualizar="fechainicio" + SEP_3 + newFecha;
                                        if(!esTorneoNuevoUS && newFecha!==arrCampos[4].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);
                                    }  
                                    else if(listaOrigenSel==="LIMITE_PLANTILLA"){     
                                        tempArreglo[5].error= "";                                    
                                        tempArreglo[5].valor=newFecha; 

                                        txtActualizar="fecha_maxreg" + SEP_3 + newFecha;                                        

                                        if(!showFechaLimEquipoUS){
                                            tempArreglo[6].valor=newFecha; 
                                            txtActualizar=txtActualizar + SEP_D_1 + "fecha_max_equipo" + SEP_3 + newFecha;
                                        }
                                        
                                        if(!esTorneoNuevoUS && newFecha!==arrCampos[5].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);

                                    } 
                                    else if(listaOrigenSel==="LIMITE_EQUIPO"){    
                                        tempArreglo[6].error= "";                                     
                                        tempArreglo[6].valor=newFecha; 
                                        let txtActualizar="fecha_max_equipo" + SEP_3 + newFecha;
                                        if(!esTorneoNuevoUS && newFecha!==arrCampos[6].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);
                                    }    
                                    
                                    setArrCampos(tempArreglo);
                                    
                
                                    break;
                case "LIMPIAR_LIMITE_PLANTILLA":
                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));

                    newFecha="NULL";
                    tempArreglo[5].error= "";                                    
                    tempArreglo[5].valor=""; 
                    setArrCampos(tempArreglo);

                    txtActualizar="fecha_maxreg" + SEP_3 + newFecha;                                        

                    if(!showFechaLimEquipoUS){
                        tempArreglo[6].valor=""; 
                        txtActualizar=txtActualizar + SEP_D_1 + "fecha_max_equipo" + SEP_3 + newFecha;
                    }
                                        
                    if(!esTorneoNuevoUS && tempArreglo[5].valor!==arrCampos[5].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);

                    break;
                case "LIMPIAR_LIMITE_EQUIPO":
                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));

                    newFecha="NULL";
                    tempArreglo[6].error= "";                                     
                    tempArreglo[6].valor=""; 
                    setArrCampos(tempArreglo);

                    txtActualizar="fecha_max_equipo" + SEP_3 + newFecha;
                    
                    if(!esTorneoNuevoUS && tempArreglo[6].valor!==arrCampos[6].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);

                    break;
                case "CAMBIAR_TIPO_TORNEO":
                    
                    let posFinal=valorNumero(params.value);
                    objNuevoTipoTorneo=null;

                    if(esTorneoNuevoUS){
                        setTipoTorneoSelUS(seleccionarItemLista(listaTipoTorneoUS, params.value));
                        //setTipoTorneoSelUS(posFinal);

                        tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                        tempArreglo[7].valor= "" + posFinal;
                        if(tempArreglo[7].valor==="0") tempArreglo[7].error=matrizCampos[7].error;
                        else tempArreglo[7].error="";
                        setArrCampos(tempArreglo);

                        if(posFinal===0 || posFinal===5) setPermiteEmpatesFGUS(false);
                        else setPermiteEmpatesFGUS(true);
                    }
                    else{
                        if(posFinal!==valorNumero(arrCampos[7].ultValor)){

                            let realizarCambio=true;

                            if(((posFinal<=2 || posFinal===5) && (arrCampos[7].ultValor==="3" || arrCampos[7].ultValor==="4"))){//Cambia de grupos a otro tipo de torneo
                                //Solicitar confirmación del cambio de tipo de torneo
                                if(!aceptoCambioTipoTorneo){
                                    objNuevoTipoTorneo=params;
                                    realizarCambio=false;
                                    titulo="CONFIRMAR CAMBIAR TIPO DE TORNEO";
                                    mensaje="Esta acción borrará la distribución actual de grupos del torneo. Esta de acuerdo?";
                                    ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_CAMBIO_TIPO_TORNEO");
                                }   
                                
                                aceptoCambioTipoTorneo=false;                            
                            }

                            if(realizarCambio){
                                let a=seleccionarItemLista(listaTipoTorneoUS, params.value);
                                setTipoTorneoSelUS(a);

                                tempArreglo=JSON.parse(JSON.stringify(arrCampos));

                                tempArreglo[7].valor= "" + posFinal;
                                if(tempArreglo[7].valor==="0") tempArreglo[7].error=matrizCampos[7].error;
                                else tempArreglo[7].error="";
                                

                                if(posFinal===5) setPermiteEmpatesFGUS(false);
                                else setPermiteEmpatesFGUS(true);


                                let idTipoTorneo=arrCampos[7].ultValor;
                                let valor=params.value.trim();                                                          
                                let actualizarTodo=false;

                                actualizarGrupos="0";      
                                nuevoGrupo="0";

                                if((idTipoTorneo===("1") || idTipoTorneo===("2")) && (valor===("3") || valor===("4")) ){
                                    actualizarGrupos="1";
                                    nuevoGrupo="0";
                                }

                                if((idTipoTorneo===("3") || idTipoTorneo===("4")) && (valor===("1") || valor===("2") || valor===("5")) ){
                                    actualizarGrupos="1";
                                    nuevoGrupo="1";
                                }

                                if((idTipoTorneo===("5")) && (valor===("3") || valor===("4")) ){
                                    actualizarGrupos="1";
                                    nuevoGrupo="0";
                                }

                                let puntosGanador="3";
                                let puntosGanadorEmpate="1";
                                let puntosPerdedorEmpate="1";
                                let puntosPerdedor="0";
                                let permiteEmpates="0";
                                
                                if(posFinal===("5")){
                                    permiteEmpates="0";      
                                    actualizarTodo=true;
                                }
                                else if(idTipoTorneo===("5")){
                                    permiteEmpates="1";      
                                    actualizarTodo=true;
                                }

                                idTipoTorneo=valor;
                                txtActualizar="tipo_torneo" + SEP_3 + idTipoTorneo;
                                if(actualizarTodo){

                                    txtActualizar="tipo_torneo" + SEP_3 + idTipoTorneo + SEP_D_1;

                                    txtActualizar=txtActualizar + "puntos_ganador" + SEP_3 + puntosGanador + SEP_D_1;
                                    txtActualizar=txtActualizar + "puntos_empate" + SEP_3 + puntosGanadorEmpate + SEP_D_1;
                                    txtActualizar=txtActualizar + "perdedor_empate" + SEP_3 + puntosPerdedorEmpate + SEP_D_1;
                                    txtActualizar=txtActualizar + "puntos_perdedor" + SEP_3 + puntosPerdedor + SEP_D_1;
                                    txtActualizar=txtActualizar + "permite_empate" + SEP_3 + permiteEmpates;

                                    tempArreglo[8].valor= permiteEmpates;
                                    tempArreglo[11].valor= puntosGanador;
                                    tempArreglo[12].valor= puntosGanadorEmpate;
                                    tempArreglo[13].valor= puntosPerdedorEmpate;
                                    tempArreglo[14].valor= puntosPerdedor;

                                    if(permiteEmpates==="1") setPermiteEmpatesFGUS(true);
                                    else setPermiteEmpatesFGUS(false);

                                    setArrCampos(tempArreglo);
                                }


                                BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);

                            }
                         

                        }
                    }
                    

                    

                    

                    break;    
                case "CLICK_CONFIRMO_CREAR_TORNEO":
                    setShowMensaje(false);

                    let texto="", texto2="";
                    idSede=recuperarDatoLocal("idSede");

                    texto=idSede + SEP_3 + 
                                    arrCampos[0].valor + SEP_3 + //Nombre torneo
                                    arrCampos[1].valor + SEP_3 + //Descripcion
                                    arrCampos[3].valor + SEP_3 + //Horario
                                    arrCampos[4].valor + SEP_3 + //Fecha Inicio
                                    (arrCampos[5].valor==="" ? "NULL" : arrCampos[5].valor) + SEP_3 + //Fecha Limite
                                    (arrCampos[6].valor==="" ? "NULL" : arrCampos[6].valor) + SEP_3 + //Fecha Limite datos Equipo
                                    arrCampos[7].valor + SEP_3 + //Tipo de torneo
                                    arrCampos[8].valor + SEP_3 + //Permite empates
                                    arrCampos[11].valor + SEP_3 + //Puntos ganador
                                    arrCampos[12].valor + SEP_3 + //Puntos ganador empate
                                    arrCampos[13].valor + SEP_3 + //Puntos perdedor empate
                                    arrCampos[14].valor + SEP_3 + //Puntos perdedor
                                    "1" + SEP_3 + //Acceso publico
                                    "2" + SEP_3 + //Tipo Arbitro
                                    "1" + SEP_3; //Tipo registro info

                    
                   
                    for(i=0;i<arrCampos[9].valor.length;i++){
                        if(texto2!==("")) texto2=texto2 + SEP_4;

                        let reg=arrCampos[9].regParams[i];
                        texto2=texto2 + infoParametrosO[reg].idparametro + "-" + arrCampos[9].valor[i];
                    }

                    for(i=0;i<arrCampos[10].valor.length;i++){
                        if(texto2!==("")) texto2=texto2 + SEP_4;

                        let reg=arrCampos[10].regParams[i];
                        texto2=texto2 + infoParametrosO[reg].idparametro + "-" + arrCampos[10].valor[i];
                    }

                    //presentarLog("texto: " + texto);
                    //presentarLog("texto2: " + texto2);

                    BD_solicitarDatos("CREAR_NUEVO_TORNEO",[texto + texto2, arrCampos[0].valor]);
                    
                    break;
                case "CERRAR_VENTANA_HORARIO":
                    setAbrirHorarioUS(false);
                                    
                    break;
                case "RECIBIR_HORARIO":
                    setAbrirHorarioUS(false);

                    
                        tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                        tempArreglo[15].valor=params[0];
                        tempArreglo[3].valor=params[1];

                        if(tempArreglo[3]!=="") tempArreglo[3].error="";
                        else tempArreglo[3].error=matrizCampos[3].error;

                        setArrCampos(tempArreglo);
                    
                    if(!esTorneoNuevoUS && tempArreglo[3]!==""){
                        let txtActualizar="horario" + SEP_3 + params[1];
                        if(params[1]!==arrCampos[3].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);                        
                    }
                    

                    break;
                case "ACEPTAR_CAMBIO_TIPO_TORNEO":
                    setShowMensaje(false);
                    aceptoCambioTipoTorneo=true;
                    if(objNuevoTipoTorneo!==null) clickGenerico("CAMBIAR_TIPO_TORNEO", objNuevoTipoTorneo);

                    break;
                case "SALE_PARAMETRO_JUEGO":
                    if(!esTorneoNuevoUS){
                        let hayError=false;
                        let txtActualizar="";
                        
                        if(params===null) tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                        else tempArreglo=JSON.parse(JSON.stringify(params));

                        for(i=0;i<parametrosJuegoUS.length;i++){

                            if(tempArreglo[9].error[i]!==""){
                                hayError=true;
                                i=parametrosJuegoUS.length
                            } 
                            else{
                                let reg=tempArreglo[9].regParams[i];
                                let idParam=infoParametrosO[reg].idparametro;

                                if(tempArreglo[9].valor[i]!==tempArreglo[9].ultValor[i]){
                                    if(txtActualizar==="") txtActualizar=idParam + SEP_3 + tempArreglo[9].valor[i];
                                    else txtActualizar=txtActualizar + SEP_D_1 + idParam + SEP_3 + tempArreglo[9].valor[i];
                                }                            
                            }                        
                        }

                        if(!hayError && txtActualizar!==""){
                            BD_solicitarDatos("ACTUALIZAR_PARAMS_ADMIN_TORNEO", txtActualizar);
                        }
                    } 

                    break;
                case "SALE_PARAMETRO_OPCIONAL":
                    if(!esTorneoNuevoUS){
                        let hayError=false;
                        let txtActualizar="";

                        if(params===null) tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                        else tempArreglo=JSON.parse(JSON.stringify(params));

                        for(i=0;i<parametrosOpcionalUS.length;i++){

                            if(tempArreglo[10].error[i]!==""){
                                hayError=true;
                                i=parametrosOpcionalUS.length
                            } 
                            else{
                                let reg=tempArreglo[10].regParams[i];
                                let idParam=infoParametrosO[reg].idparametro;

                                if(tempArreglo[10].valor[i]!==tempArreglo[10].ultValor[i]){
                                    if(txtActualizar==="") txtActualizar=idParam + SEP_3 + tempArreglo[10].valor[i];
                                    else txtActualizar=txtActualizar + SEP_D_1 + idParam + SEP_3 + tempArreglo[10].valor[i];
                                }                            
                            }                        
                        }

                        if(!hayError && txtActualizar!==""){
                            BD_solicitarDatos("ACTUALIZAR_PARAMS_ADMIN_TORNEO", txtActualizar);
                        }
                    } 

                    break;
                case "SALE_PUNTOS_PARTIDO":

                    if(!esTorneoNuevoUS && arrCampos[11].error===""){
                        let puntosGanador=arrCampos[11].valor;
                        let puntosGanadorEmpate=arrCampos[12].valor;
                        let puntosPerdedorEmpate=arrCampos[13].valor;
                        let puntosPerdedor=arrCampos[14].valor;

                        let txtActualizar="puntos_ganador" + SEP_3 + puntosGanador + SEP_D_1;
                        txtActualizar=txtActualizar + "puntos_empate" + SEP_3 + puntosGanadorEmpate + SEP_D_1;
                        txtActualizar=txtActualizar + "perdedor_empate" + SEP_3 + puntosPerdedorEmpate + SEP_D_1;
                        txtActualizar=txtActualizar + "puntos_perdedor" + SEP_3 + puntosPerdedor;                                  

                        BD_solicitarDatos("ACTUALIZAR_CAMPOS_ADMIN_TORNEO", txtActualizar);
                    }

                    break;
                case "CLICK_EQUIPO":

                    regEquipoSel=params;
                    tempOpciones=[];
                    txtOpcion="";
                    valOpcion="";

                    txtOpcion="Ver/Editar Información";
                    valOpcion="EDITAR INFO EQUIPO";
                    tempOpciones.push([txtOpcion,valOpcion]);

                    if(infoEquiposO[regEquipoSel].activo==="1") txtOpcion="Inactivar en el Torneo";
                    else txtOpcion="Activar en el Torneo";
                    valOpcion="ACTIVAR/INACTIVAR EQUIPO";
                    tempOpciones.push([txtOpcion,valOpcion]);

                    if(infoEquiposO[regEquipoSel].tienePartidos==="0"){
                        txtOpcion="Retirar del Torneo";
                        valOpcion="RETIRAR EQUIPO";
                        tempOpciones.push([txtOpcion,valOpcion]);
                    }                    

                    if(tempOpciones.length>0){
                        setTituloMenu("Seleccione la opción");
                        setOpcionesMenu(tempOpciones);
                        setOpcionSel(-1);
                        openMenu();
                    }

                    break;
                case "ACEPTAR_MENU":
                                    
                    if(opcionesMenu.length>0){
                        if(opcionSel>=0){
                            switch(opcionesMenu[opcionSel][1]) {
                                case "EDITAR INFO EQUIPO":
                                    let idEq=infoEquiposO[regEquipoSel].idequipo;
                                    definirModulo(0,idModulo, paramsAjustado,ID_MODULO_INFO_EQUIPO,idTorneo + SEP_4 + idEq);
                                            
                                    break;
                                case "ACTIVAR/INACTIVAR EQUIPO":
                                    tempArreglo=JSON.parse(JSON.stringify(infoEquiposO));
                                    if(tempArreglo[regEquipoSel].activo==="1") tempArreglo[regEquipoSel].activo="0";
                                    else tempArreglo[regEquipoSel].activo="1";
                                    setInfoEquiposUS(tempArreglo);

                                    BD_solicitarDatos("ACTIVAR_INACTIVAR_EQUIPO_TORNEO", regEquipoSel);                                    
                                                    
                                    break;
                                case "RETIRAR EQUIPO":
                                    titulo="CONFIRMAR RETIRO DEL TORNEO";
                                    mensaje="Esta acción borrará el Equipo seleccionado de este torneo. Esta de acuerdo?";
                                    ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_RETIRAR_EQUIPO");          
                                            
                                    break;
                                case "CREAR_JORNADA_ANTES_ACTUAL":
                                    clickGenerico("CLICK_CREAR_NUEVA_JORNADA", registroSel);
                                
                                    break;
                                case "CREAR_JORNADA_DESPUES_ACTUAL":
                                    clickGenerico("CLICK_CREAR_NUEVA_JORNADA", registroSel+1);
                                
                                    break;
                                default:
                                    break;
                            }
                                            
                            closeMenu();               
                                            
                        }
                        else{
                            titulo="SIN SELECCION";
                            mensaje="Seleccione alguna de las opciones presentadas";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ALERTA","BAJA");
                        }
                    }  
                                    
                    break;
                case "ACEPTAR_RETIRAR_EQUIPO":
                    setShowMensaje(false);
                    tempArreglo=JSON.parse(JSON.stringify(infoEquiposO));
                    tempArreglo[regEquipoSel].borrado="1";
                    setInfoEquiposUS(tempArreglo);

                    BD_solicitarDatos("RETIRAR_EQUIPO_TORNEO", regEquipoSel);                   
                                            
                    break;
                case "CLICK_CREACION_EQUIPOS":
                    if(datosSedeConsultados===false){
                        let infoSede=infoGuardadaEsMismoDia(ID_MODULO_INFO_EQUIPO,"DS" + "s" + idSede);
                        let infoTorneo=infoGuardadaEsMismoDia(ID_MODULO_INFO_EQUIPO,"DS" + "t" + idTorneo);

                        if(!infoSede || !infoTorneo) BD_solicitarDatos("RECUPERAR_INFO_JUGADORES_SEDE", "TODO");
                        else BD_solicitarDatos("CANTIDADES_INFO_JUGADORES_SEDE");
                    } 

                    setShowOpcionesEquiposUS(false);

                    let tempEquiposNuevos=[];

                    let regNuevo = {
                        indice: 0,
                        borrado: false,
                        nombre:"Equipo " + (infoEquiposUS.length+1),
                        telefono:"",
                        error:"",
                        datos: []
                    };

                    let registro=Object.assign({} , regNuevo);

                    tempEquiposNuevos.push(registro);

                    setEquiposInscribirUS(tempEquiposNuevos);


                    break;
                case "CLICK_MAS_EQUIPOS":
                    setShowOpcionesEquiposUS(false);
                    
                    tempArreglo=JSON.parse(JSON.stringify(equiposInscribirUS));

                    if(tempArreglo.length<=150){
                        let regNuevo = {
                            indice: tempArreglo.length,
                            borrado: false,
                            nombre:"Equipo " + (infoEquiposUS.length + equiposInscribirUS.length + 1),
                            telefono:"",
                            error:"",
                            datos: []
                        };

                        let registro=Object.assign({} , regNuevo);

                        tempArreglo.push(registro);

                        setEquiposInscribirUS(tempArreglo);
                    }

                    


                    break;
                case "VALIDAR_NOMBRE_NUEVO_EQUIPO": 
                    let newValor = params[0].target.value;
                    let numReg=params[1];
                    let maxlen=params[2];
                    if(maxlen!==null && newValor.length>maxlen) newValor=newValor.substring(0,maxlen);
                    tempArreglo=JSON.parse(JSON.stringify(equiposInscribirUS));                    

                    let nombre=newValor;
                    let telefono=tempArreglo[numReg].telefono.trim();
                    tempArreglo[numReg].nombre=nombre;

                    if(telefono!=="" && (nombre.length<3 || esformatoNumero(nombre))){
                            tempArreglo[numReg].error="Nombre es un campo obligatorio";
                    }
                    else if(nombre.length>=3 && !esformatoNumero(nombre) && telefono===""){
                            tempArreglo[numReg].error="Teléfono es un campo obligatorio";
                    }
                    else tempArreglo[numReg].error="";
    
                    setEquiposInscribirUS(tempArreglo);

                    break;
                case "CLICK_OPCION_BUSQUEDA_TELEFONO_DELEGADO": 
                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));

                    tipoSeleccion=params;
                    tempArreglo[17].valor="";
                    

                    if(params==="telefono"){
                        tempArreglo[17].error="Ingrese un teléfono de MÍNIMO 10 números.";
                    }
                    else if(params==="nombre"){
                        tempArreglo[17].error="Ingrese el nombre del usuario a buscar.";
                    }

                    setTipoListaUS(params);  
                    setArrCampos(tempArreglo);
                    if (refBusqueda.current)  refBusqueda.current.focus();

                    cancelarBusqueda=false;
                    buscarTexto();
                                        
                    break;
                case "CLICK_OPCION_INCLUIR_EQUIPOS_SEDE":
                    regEquipoNuevoSel=-1;
                    textoFinal="";
                    setInfoEquipoSelUS(null);
                    setDatosCargadosBusqueda(false);                    
                    
                    tempArreglo=JSON.parse(JSON.stringify(infoBusquedaBase));
                    tempArreglo.tipoLista="Busqueda_Incluir_Equipo_Sede";
                    tempArreglo.titulo="Inscribir - Equipos";
                    tempArreglo.texto="Busque y seleccione el o los Equipos existente en torneos anteriores de esta Sede que desee inscribir en el Torneo.";

                    tipoSeleccion="Equipo_Sede";
                    setInfoBusquedaUS(tempArreglo);                    
                    abrirVentanaBusqueda();       
                    
                    let infoSede=infoGuardadaEsMismoDia(idModulo,"IES" + idSede);                    
                    if(!infoSede) BD_solicitarDatos("INFO_EQUIPOS_SEDE_NO_TORNEO"); 
                    else cargarDatosGuardadosEquiposSede();
                                                         
                    break;
                case "CLICK_INCRIBIR_EQUIPOS":
                    textoFinal="";
                    let equiposCorrecto=true;
                    let alertaJugOtroEquipo=false;
                    let nuevosEquipos=[];
                    tempArreglo=JSON.parse(JSON.stringify(equiposInscribirUS));

                    for(i=0;i<equiposInscribirUS.length;i++){
                        let nombre=equiposInscribirUS[i].nombre;
                        let telefono=equiposInscribirUS[i].telefono;
                        let registroCorrecto=true;
                        
                        tempArreglo[i].error="";

                        nombre=quitarCharEspeciales(nombre).trim();
                        telefono=quitarCharEspeciales(telefono).trim();

                        if(nombre!=="" || telefono!==""){
                            if(nombre===""){
                                tempArreglo[i].error="Nombre no puede ser vacio";
                                registroCorrecto=false;
                                equiposCorrecto=false;
                            }
                            else if(telefono.length<10){
                                tempArreglo[i].error="Teléfono mínimo 10 dígitos";
                                registroCorrecto=false;
                                equiposCorrecto=false;
                            }

                            if(registroCorrecto){
                                if(jugadoresTorneo.length>0){
                                        for(j=0;j<jugadoresTorneo.length;j++){
                                            let telefonoTorneo=jugadoresTorneo[j][1].toLowerCase().trim();

                                            if(telefonoTorneo===(telefono.toLowerCase())){
                                                tempArreglo[i].error="Teléfono ya Existe en el Torneo. A nombre de: " + jugadoresTorneo[j][2] + " Equipo: " + jugadoresTorneo[j][3];
                                                
                                                alertaJugOtroEquipo=true;                                              
                                                j=jugadoresTorneo.length;
                                            }

                                        }
                                    }

                                    if(infoEquipos.length>0){
                                        for(j=0;j<infoEquipos.length;j++){
                                            let nombreEquipo=infoEquipos[j][2].toLowerCase().trim();

                                            if(nombreEquipo===(nombre.toLowerCase())){
                                                tempArreglo[i].error=infoEquipos[j][2] + " ya Existe en el Torneo.";
                                                equiposCorrecto=false;
                                                j=jugadoresTorneo.length;
                                            }

                                        }
                                    }
                            }
                        }

                        nuevosEquipos.push(equiposInscribirUS[i]);
                    }

                    for(i=0;i<nuevosEquipos.length;i++){
                            let nombreEquipo1=nuevosEquipos[i].nombre.toLowerCase().trim();
                            let telefonoEquipo1=nuevosEquipos[i].telefono.toLowerCase().trim();
                            for(j=0;j<nuevosEquipos.length;j++){
                                if(j!=i){
                                    let nombreEquipo2=nuevosEquipos[j].nombre.toLowerCase().trim();
                                    let telefonoEquipo2=nuevosEquipos[j].telefono.toLowerCase().trim();
                                    if(nombreEquipo1!==("")){
                                        if(nombreEquipo1===(nombreEquipo2)){

                                            tempArreglo[nuevosEquipos[i].indice].error="Equipo repetido con el Nuevo Equipo No. " + (j+1);
                                            equiposCorrecto=false;
                                            j=nuevosEquipos.length;
                                        }
                                    }
                                    if(telefonoEquipo1!==("")){

                                        if(telefonoEquipo1===(telefonoEquipo2)){
                                            tempArreglo[nuevosEquipos[i].indice].error="Teléfono repetido con el Telefono del Delegado No. " + (j+1);

                                            alertaJugOtroEquipo=true;        
                                            j=nuevosEquipos.length;
                                        }
                                    }

                                }
                            }


                    }

                    setEquiposInscribirUS(tempArreglo);
                    

                    if(equiposCorrecto && alertaJugOtroEquipo && !omitioAlerta) { 
                        omitioAlerta=false;  
                        setShowAlertaEquiposUS(alertaJugOtroEquipo);                     
                        titulo="ALERTA GENERADA";
                        mensaje="Existen alertas en los datos ingresados de los Nuevos Equipos";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ALERTA", "MEDIA");
                    }
                    else if(equiposCorrecto && (!alertaJugOtroEquipo || (alertaJugOtroEquipo && omitioAlerta))) {
                        setShowAlertaEquiposUS(false);
                            let texto="";

                            for(i=0;i<nuevosEquipos.length;i++){
                                if(nuevosEquipos[i].nombre!==("") || nuevosEquipos[i].telefono!==("")){
                                    if(texto!==("")) texto=texto + SEP_2;
                                    let nombreE=formatearTexto(quitarCharEspeciales(nuevosEquipos[i].nombre),2);
                                    let telefonoE=nuevosEquipos[i].telefono;
                                    let idE=nuevosEquipos[i].datos.idjugador;
                                    if(idE===("")) idE="0";

                                    texto=texto + nombreE + SEP_3 + telefonoE + SEP_3 + idE;
                                }
                            }

                            if(texto!==("")){
                                textoFinal=texto;

                                titulo="CONFIRMAR EQUIPOS";
                                mensaje="Esta acción tomará los registros con información válida y creará cada Equipo con su Delegado en el Torneo Actual.\n\nEsta de acuerdo?";
                                ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CLICK_CONFIRMO_CREAR_EQUIPOS");

                            }
                            else{
                                titulo="DATOS NO VALIDOS";
                                mensaje="No hay registros validos de Equipos que Inscribir.";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR", "MEDIA");
                            }


                    }
                    else{
                        omitioAlerta=false;
                        setShowAlertaEquiposUS(false); 
                        titulo="ERROR EN LOS DATOS";
                        mensaje="Hay errores en los datos de los equipos a Inscribir, verifiquelos y corrijalos para continuar.";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR", "MEDIA");
                    }


                    break;
                case "CLICK_OMITIR_ALERTA":
                    omitioAlerta=true;
                    setShowAlertaEquiposUS(false);
                    clickGenerico("CLICK_INCRIBIR_EQUIPOS");

                    break;
                case "CLICK_CONFIRMO_CREAR_EQUIPOS":
                    setShowMensaje(false);

                    if(textoFinal!=="") BD_solicitarDatos("INSCRIBIR_EQUIPOS_TORNEO");    

                    break;
                case "LIMPIAR_CASILLA_NUEVOS_EQUIPOS":
                    tempArreglo=JSON.parse(JSON.stringify(equiposInscribirUS));

                    tempArreglo[params].nombre="";
                    tempArreglo[params].telefono="";
                    tempArreglo[params].error="";
                    tempArreglo[params].datos=[];

                    setEquiposInscribirUS(tempArreglo);

                    break;
                case "CLICK_INCLUIR_EQUIPO_SEDE":
                    
                    let reg=params;
                    regEquipoNuevoSel=reg;
                    let maxJugadores= valorNumero(buscarParametro("11"));
                    let tJugadores=valorNumero(equiposSedeO[reg].tJugadores);

                    equiposSedeO[reg].maxJugTorneo=maxJugadores;
                    equiposSedeO[reg].jugSeleccionados=0;

                    if(tJugadores>maxJugadores){   
                        setInfoEquipoSelUS(equiposSedeO[reg]);                     
                        if(equiposSedeO[reg].jugadores.length===0){
                            setDatosCargadosBusqueda(false);
                            BD_solicitarDatos("INFO_JUGADORES_EQUIPO");    
                        }

                        openSelJugadoresEq();
                    }
                    else{
                        textoFinal="";
                        titulo="CONFIRMAR EQUIPO";
                        mensaje="Esta acción incluirá el Equipo Seleccionado en el Torneo Actual.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CLICK_CONFIRMO_INSCRIBIR_EQUIPO_SEDE");
                    }

                    break;
                case "CLICK_CONFIRMO_INSCRIBIR_EQUIPO_SEDE":
                    setShowMensaje(false);
                    

                    BD_solicitarDatos("IMPORTAR_EQUIPO_SEDE_A_TORNEO");    

                    break;
                case "CLICK_SELECCIONAR_JUGADOR_EQUIPO":
                    tempArreglo=JSON.parse(JSON.stringify(infoEquipoSelUS));

                    let cont=infoEquipoSelUS.jugSeleccionados;
                    if(tempArreglo.jugadores[params].seleccionado) cont--;
                    else cont++;

                    tempArreglo.jugSeleccionados=cont;
                    tempArreglo.jugadores[params].seleccionado=!tempArreglo.jugadores[params].seleccionado;

                    setInfoEquipoSelUS(tempArreglo);

                    break;
                case "CLICK_SELECCIONAR_TODOS_JUGADOR_EQUIPO":
                    tempArreglo=JSON.parse(JSON.stringify(infoEquipoSelUS));

                    for(let i=0;i<tempArreglo.jugadores.length;i++){
                        tempArreglo.jugadores[i].seleccionado=params;
                    }

                    if(params===true) tempArreglo.jugSeleccionados=tempArreglo.jugadores.length;
                    else tempArreglo.jugSeleccionados= 0;

                    setInfoEquipoSelUS(tempArreglo);

                    break;
                case "ACEPTAR_JUGADORES_SELECCIONADOS_EQUIPO_SEDE":
                    textoFinal="";
                    
                    if(infoEquipoSelUS.jugSeleccionados<=0){
                        titulo="SIN SELECCIÓN";
                        mensaje="Debe seleccionar los jugadores a incluir en el equipo";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ALERTA","BAJA");
                    }
                    else if(infoEquipoSelUS.jugSeleccionados>infoEquipoSelUS.maxJugTorneo){
                        titulo="CONFIRMAR";
                        mensaje="Selecciono un número mayor de jugadores al PERMITIDO por el torneo. Esta acción incluirá el equipo y jugadores seleccionados en este Torneo.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_INSCRIBIR_JUGADORES_EQUIPO_SEDE");
                    }
                    else{
                        titulo="CONFIRMAR";
                        mensaje="Esta acción incluirá el equipo y jugadores seleccionados en este Torneo.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_INSCRIBIR_JUGADORES_EQUIPO_SEDE");
                    }

                    break;
                case "CONFIRMO_INSCRIBIR_JUGADORES_EQUIPO_SEDE":  
                    setShowMensaje(false);
                    regEquipoNuevoSel=infoEquipoSelUS.indice;
                    textoFinal="";

                    for(let i=0;i<infoEquipoSelUS.jugadores.length;i++){
                        if(infoEquipoSelUS.jugadores[i].seleccionado){
                            if(textoFinal==="") textoFinal=infoEquipoSelUS.jugadores[i].idjugador;
                            else textoFinal=textoFinal + "," + infoEquipoSelUS.jugadores[i].idjugador;
                        }                        
                    }

                    if(textoFinal!==""){
                        closeSelJugadoresEq();
                        BD_solicitarDatos("IMPORTAR_EQUIPO_SEDE_A_TORNEO");    
                    }

                    break;
                case "LIMPIAR_FILTRO_BUSQUEDA":
                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                    tempArreglo[17].valor="";
                    tempArreglo[17].error="";
                    setArrCampos(tempArreglo);

                    textoBuscar="";
                
                    if (refBusqueda.current)  refBusqueda.current.focus();
                    cancelarBusqueda=true;
                    buscarTexto(); 

                    break;
                case "CLICK_EQUIPO_SELECCIONAR_GRUPO":
                    if(tipoSelGruposUS!=="MANUAL"){
                        titulo="";
                        mensaje="Configuración de Grupos debe ser Manual para seleccionar el grupo a cada equipo";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(grupoSelUS===0){
                        titulo="";
                        mensaje="Seleccione la cantidad de grupos a generar";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ALERTA", "MEDIA");
                    }
                    else{
                        regEquipoSel=params;
                        openSelGrupo();
                    }                    

                    break;
                case "CLICK_GRUPO_SELECCIONADO":
                    closeSelGrupo();

                    if(tipoGestionGrupos==="JORNADA"){
                        infoEquiposJornadaO[regEquipoSel].nuevoGrupo=params.value; 
                        
                        generarEquiposXGrupoJornada("");
                    }
                    else{
                        infoEquiposO[regEquipoSel].nuevoGrupo=params.value; 
                        generarEquiposXGrupo("");
                    }
                    

                    break;
                case "CLICK_EQUIPO_QUITAR_SELECCION_GRUPO":
                    closeSelGrupo();

                    if(tipoGestionGrupos==="JORNADA"){
                        if(infoEquiposJornadaO[params].tienePartidos!=="0" && !letCambioGrupoJornada){
                            regEquipoSel=params;
                            titulo="ALERTA - Equipo con Partidos";
                            mensaje="Desea permitir que equipos que ya tienen partidos programados o jugados CAMBIEN de grupo?";
                            ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CLICK_CONFIRMO_PERMITIR_CAMBIO_GRUPO", "NO", "PERMITIR");
                        }
                        else{
                            infoEquiposJornadaO[params].nuevoGrupo="0";
                            
                            generarEquiposXGrupoJornada("");
                        }
                    }
                    else{
                        if(infoEquiposO[params].tienePartidos!=="0" && !letCambioGrupo){
                            regEquipoSel=params;
                            titulo="ALERTA - Equipo con Partidos";
                            mensaje="Desea permitir que equipos que ya tienen partidos programados o jugados CAMBIEN de grupo?";
                            ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CLICK_CONFIRMO_PERMITIR_CAMBIO_GRUPO", "NO", "PERMITIR");
                        }
                        else{
                            infoEquiposO[params].nuevoGrupo="0";
                            
                            generarEquiposXGrupo("");
                        }
                    }
                    
                    

                    break;
                case "CLICK_CONFIRMO_PERMITIR_CAMBIO_GRUPO":
                    setShowMensaje(false);                    

                    if(tipoGestionGrupos==="JORNADA"){
                        letCambioGrupoJornada=true;
                        infoEquiposJornadaO[regEquipoSel].nuevoGrupo="0";                        
                        generarEquiposXGrupoJornada("");
                    }
                    else{
                        letCambioGrupo=true;
                        infoEquiposO[regEquipoSel].nuevoGrupo="0";                        
                        generarEquiposXGrupo("");
                    }

                    break;
                case "CLICK_REINICIAR_CONFIGURACION_GRUPOS":
                    closeSelGrupo();
                    let hayEquiposConpartidos=false;

                    if(configGruposUS.length>0){

                        if(tipoGestionGrupos==="JORNADA"){
                            if(!letCambioGrupoJornada){
                                for(let i=0;i<infoEquiposJornadaO.length;i++){
                                    if(infoEquiposJornadaO[i].borrado==="0"){
                                        if(infoEquiposJornadaO[i].tienePartidos!=="0"){
                                            hayEquiposConpartidos=true;
                                            i=infoEquiposJornadaO.length;
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            if(!letCambioGrupo){
                                for(let i=0;i<infoEquiposO.length;i++){
                                    if(infoEquiposO[i].borrado==="0"){
                                        if(infoEquiposO[i].tienePartidos!=="0"){
                                            hayEquiposConpartidos=true;
                                            i=infoEquiposO.length;
                                        }
                                    }
                                }
                            }
                        }
                        
                        
                        
                        titulo="CONFIRMAR";
                        if(!hayEquiposConpartidos){                            
                            mensaje="Esta opción reinicia TODOS los Equipos del Torneo y los deja SIN Grupo seleccionado, para que se defina nuevamente el grupo. \n\nEsta de acuerdo?";                            
                        }
                        else if(hayEquiposConpartidos){
                            mensaje="Esta opción reinicia TODOS los Equipos del Torneo y los deja SIN Grupo seleccionado, para que se defina nuevamente el grupo. " +
                                    "\n\nAdicional, existen equipos que ya tienen partidos programados o jugados, por lo que debe ACEPTAR para confirmar el reinicio y permitir que los equipos CAMBIEN de Grupo." + 
                                    "\n\nEsta de acuerdo?";      
                        }

                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_REINICIAR_CONFIGURACION_GRUPOS");
                    }                   
                    

                    break;
                case "CONFIRMO_REINICIAR_CONFIGURACION_GRUPOS":
                    
                    setShowMensaje(false);

                    if(tipoGestionGrupos==="JORNADA"){
                        letCambioGrupoJornada=true;
                        for(let i=0;i<infoEquiposJornadaO.length;i++){
                            if(infoEquiposJornadaO[i].borrado==="0"){
                                infoEquiposJornadaO[i].nuevoGrupo="0"; 
                            }
                        }

                        generarEquiposXGrupoJornada("");
                    }
                    else{
                        letCambioGrupo=true;
                        for(let i=0;i<infoEquiposO.length;i++){
                            if(infoEquiposO[i].borrado==="0"){
                                infoEquiposO[i].nuevoGrupo="0"; 
                            }
                        }

                        generarEquiposXGrupo("");
                    }
                    

                    

                    break;
                case "CLICK_GENERAR_GRUPOS_ALEATORIAMENTE":

                    let numEqXGrupo=[];

                    for(let i=0;i<=grupoSelUS;i++){
                        numEqXGrupo.push(0);
                    }

                    let numTotalGrupos=grupoSelUS;
                    let numEquiposSinGrupo=0;
                    let numTotalEquipos=0;
                    let maxEqXGrupo=0;
                    let equiposSinAsignar=[];

                    if(tipoGestionGrupos==="JORNADA"){
                        for(let i=0;i<infoEquiposJornadaO.length;i++){
                            if(infoEquiposJornadaO[i].borrado==="0" && infoEquiposJornadaO[i].activo==="1"){
                                numTotalEquipos++;
                                if(infoEquiposJornadaO[i].nuevoGrupo==="0"){
                                    equiposSinAsignar.push(i);
                                    numEquiposSinGrupo++;
                                }
                                else{
                                    let grupo=valorNumero(infoEquiposJornadaO[i].nuevoGrupo);
                                    if(grupo<numEqXGrupo.length){
                                        numEqXGrupo[grupo]=numEqXGrupo[grupo]+1;
                                    }
                                }
                            }
                        }
                    }
                    else{
                        for(let i=0;i<infoEquiposO.length;i++){
                            if(infoEquiposO[i].borrado==="0"){
                                numTotalEquipos++;
                                if(infoEquiposO[i].nuevoGrupo==="0"){
                                    equiposSinAsignar.push(i);
                                    numEquiposSinGrupo++;
                                }
                                else{
                                    let grupo=valorNumero(infoEquiposO[i].nuevoGrupo);
                                    if(grupo<numEqXGrupo.length){
                                        numEqXGrupo[grupo]=numEqXGrupo[grupo]+1;
                                    }
                                }
                            }
                        }
                    }    
                    

                    maxEqXGrupo=Math.ceil(numTotalEquipos/numTotalGrupos);

                    let grupoAsignar=1;
                    let equipoAsignado=1;
                    let finalizado=false;

                    while(!finalizado){
                        if(grupoAsignar>numTotalGrupos){
                            grupoAsignar=1;
                            equipoAsignado++;
                        }

                        if(numEqXGrupo[grupoAsignar]<equipoAsignado){
                            let numAleatorio=Math.floor(Math.random() * equiposSinAsignar.length);
                            let indice=equiposSinAsignar[numAleatorio];

                            if(tipoGestionGrupos==="JORNADA") infoEquiposJornadaO[indice].nuevoGrupo="" + grupoAsignar;
                            else infoEquiposO[indice].nuevoGrupo="" + grupoAsignar;

                            equiposSinAsignar.splice(numAleatorio,1);

                            numEqXGrupo[grupoAsignar]=numEqXGrupo[grupoAsignar]+1;
                        }

                        grupoAsignar++;

                        if(equiposSinAsignar.length<=0) finalizado=true;
                        
                    }

                    if(tipoGestionGrupos==="JORNADA") generarEquiposXGrupoJornada("");
                    else generarEquiposXGrupo("");

                    break;
                case "CLICK_GUARDAR_CONFIGURACION_GRUPOS":

                    let hayCambios=false;

                    if(tipoGestionGrupos==="JORNADA"){
                        for(let i=0;i<infoEquiposJornadaO.length;i++){
                            if(infoEquiposJornadaO[i].borrado==="0"){
                                if(infoEquiposJornadaO[i].nuevoGrupo!==infoEquiposJornadaO[i].numgrupo){
                                    hayCambios=true;
                                    i=infoEquiposJornadaO.length;
                                }                            
                            }
                        }
                    }
                    else{
                        for(let i=0;i<infoEquiposO.length;i++){
                            if(infoEquiposO[i].borrado==="0"){
                                if(infoEquiposO[i].nuevoGrupo!==infoEquiposO[i].numgrupo){
                                    hayCambios=true;
                                    i=infoEquiposO.length;
                                }                            
                            }
                        }
                    }
                    

                    if(!hayCambios){
                        titulo="SIN CAMBIOS";
                        mensaje="No se detectaron cambios en la configuración de los grupos del Torneo";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{
                        titulo="CONFIRMAR";
                        mensaje="Esta acción GUARDARÁ y aplicará los cambios realizados sobre los grupos del Torneo.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_GUARDAR_CONFIGURACION_GRUPOS");
                    }


                    break;
                case "CONFIRMO_GUARDAR_CONFIGURACION_GRUPOS":
                    setShowMensaje(false);                    
                    closeGestionGrupos();

                    txtActualizar="";

                    if(tipoGestionGrupos==="JORNADA"){
                        let tempGrupos=[];

                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                        tempArreglo[jornadaSelUS].jornadas[registroSel].infoGrupos=[];

                        for(let i=0;i<infoEquiposJornadaO.length;i++){
                                        if(infoEquiposJornadaO[i].borrado==="0" && infoEquiposJornadaO[i].nuevoGrupo!=="0"){
                                            let registro=Object.assign({} , egj);
                                            registro.idjornada=tempArreglo[jornadaSelUS].jornadas[registroSel].idjornada;
                                            registro.idequipo=infoEquiposJornadaO[i].idequipo;
                                            registro.grupo=infoEquiposJornadaO[i].nuevoGrupo;
                                            registro.tienePartidos=infoEquiposJornadaO[i].tienePartidos;

                                            tempGrupos.push(registro);

                                            if(txtActualizar===("")) txtActualizar=infoEquiposO[i].idequipo + SEP_3 + infoEquiposO[i].nuevoGrupo;
                                            else txtActualizar=txtActualizar + SEP_2 + infoEquiposO[i].idequipo + SEP_3 + infoEquiposO[i].nuevoGrupo;
                                        }                                        
                        }

                        tempArreglo[jornadaSelUS].jornadas[registroSel].infoGrupos=tempGrupos;
                        tempArreglo[jornadaSelUS].jornadas[registroSel].gruposGuadados=true;

                        setIinfoGestionJornadasUS(tempArreglo);

                    }
                    else{
                        setShowOpcionesEquiposUS(false);

                        for(let i=0;i<infoEquiposO.length;i++){
                                        if(infoEquiposO[i].borrado==="0"){
                                            if(txtActualizar===("")) txtActualizar=infoEquiposO[i].idequipo + SEP_3 + infoEquiposO[i].nuevoGrupo;
                                            else txtActualizar=txtActualizar + SEP_2 + infoEquiposO[i].idequipo + SEP_3 + infoEquiposO[i].nuevoGrupo;
                                        }                                        
                        }

                        if(txtActualizar!=="") BD_solicitarDatos("GUARDAR_CONFIGURACION_GRUPOS_TORNEO",txtActualizar);
                    }

                    break;
                case "CLICK_ASOCIAR_CANCHAS":
                    //regEquipoNuevoSel=-1;
                    //textoFinal="";
                    setInfoEquipoSelUS(null);
                    setDatosCargadosBusqueda(false);
                    
                    
                    tempArreglo=JSON.parse(JSON.stringify(infoBusquedaBase));
                    tempArreglo.tipoLista="Busqueda_Incluir_Cancha_Sede";
                    tempArreglo.titulo="Asociar - Canchas";
                    tempArreglo.texto="Busque y seleccione la o las Canchas de la sede en las que se jugará este Torneo.";

                    tipoSeleccion="Cancha_Sede";
                    setInfoBusquedaUS(tempArreglo);                    
                    abrirVentanaBusqueda();      

                    let infoCanchas=infoGuardadaEsMismoDia("ICS" + idSede);                    
                    if(!infoCanchas) BD_solicitarDatos("INFO_CANCHAS_SEDE"); 
                    else cargarDatosGuardadosCanchasSede();  

                                                         
                    break;
                case "CLICK_QUITAR_CANCHA":
                    registroSel=params;

                    titulo="CONFIRMAR";
                    mensaje="Esta acción retirará la cancha seleccionada de este Torneo.\n\nEsta de acuerdo?";
                    ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_QUITAR_CANCHA");                    

                    break;
                case "CONFIRMO_QUITAR_CANCHA":
                    setShowMensaje(false);
                    tempArreglo=JSON.parse(JSON.stringify(infoCanchasO));
                    tempArreglo[registroSel].borrado="1";
                    setInfoCanchasUS(tempArreglo);

                    BD_solicitarDatos("RETIRAR_CANCHA_TORNEO", registroSel);     

                    break;
                case "CLICK_INCLUIR_CANCHA_SEDE":
                    registroSel=params;

                    titulo="CONFIRMAR CANCHA";
                    mensaje="Esta acción incluirá la Cancha seleccionada en el Torneo Actual.\n\nEsta de acuerdo?";
                    ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_INCLUIR_CANCHA_SEDE");

                    break;
                case "CONFIRMO_INCLUIR_CANCHA_SEDE":
                    setShowMensaje(false);                    

                    BD_solicitarDatos("ASOCIAR_CANCHA_A_TORNEO", registroSel);    
                    
                    break;
                case "CLICK_INCLUIR_CANCHA_NUEVA_SEDE":
                    closeBusqueda();

                    openNewCancha();

                    break;
                case "CANCHA_CREADA_CON_EXITO":
                    closeNewCancha();

                    if(params!=="") BD_solicitarDatos("INFO_DETALLE_CANCHAS_TORNEO");

                    break;
                case "CLICK_CANCELAR_NUEVA_CANCHA":
                    closeNewCancha();

                    break;
                case "CLICK_GESTIONAR_JORNADAS":
                    /*tempArreglo=JSON.parse(JSON.stringify(infoJornadasUS));

                    if(tempArreglo.length===0){                        
                        tempArreglo.push(copa);
                    }
                    setIinfoGestionJornadasUS(tempArreglo);*/
                    setJornadaSelUS(-1)

                    openGestionJornadas(); 

                    if(hayJornadasGrupo && !consultoInfoEGJ){
                        BD_solicitarDatos("INFO_EQUIPOS_GRUPO_JORNADA");
                    }

                    break;
                case "CLICK_CREAR_NUEVA_COPA":
                    if(estaCreandoCopa){
                        titulo="CREANDO/EDITANDO COPA";
                        mensaje="Debe finalizar la creación/edición de la copa para crear o editar copas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(estaCreandoJornada){
                        titulo="CREANDO/EDITANDO JORNADA";
                        mensaje="Debe finalizar la creación/edición de la jornada para crear o editar copas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{
                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));

                        let regCopa=Object.assign({} , copa);
                        regCopa.idcopa="-1";
                        regCopa.nombreCopa="";
                        regCopa.estado="EDITANDO";

                        tempArreglo.push(regCopa);

                        estaCreandoCopa=true;
                        setIinfoGestionJornadasUS(tempArreglo);
                        setJornadaSelUS(-1)

                        setIrHastaFin(true);
                    }                   

                    break;
                case "CLICK_EDITAR_COPA":
                    if(estaCreandoCopa){
                        titulo="CREANDO/EDITANDO COPA";
                        mensaje="Debe finalizar la creación/edición de la copa para crear o editar copas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(estaCreandoJornada){
                        titulo="CREANDO/EDITANDO JORNADA";
                        mensaje="Debe finalizar la creación/edición de la jornada para crear o editar copas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{
                        idx=params;

                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                        tempArreglo[idx].estado="EDITANDO";
                        estaCreandoCopa=true;

                        setIinfoGestionJornadasUS(tempArreglo);
                    }                    
                    
                    break;
                case "CLICK_SELECCIONAR_COPA":
                    idx=params;
                    if(estaCreandoCopa){
                        titulo="CREANDO/EDITANDO COPA";
                        mensaje="Debe finalizar la creación/edición de la copa para seleccionar copas";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(estaCreandoJornada){
                        titulo="CREANDO/EDITANDO JORNADA";
                        mensaje="Debe finalizar la creación/edición de la jornada para seleccionar copas";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{
                        /*(jornadaSelUS===index) ? setJornadaSelUS(-1) : setJornadaSelUS(index)*/
                        if(jornadaSelUS===idx) setJornadaSelUS(-1);
                        else setJornadaSelUS(idx);
                    }

                    break; 
                case "ACEPTAR_MODIFICACION_COPA":
                    idx=params;
                    let nombreCopa=quitarCharEspeciales(infoGestionJornadasUS[idx].nombreCopa);

                    if(nombreCopa!==""){
                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                        tempArreglo[idx].estado="";
                        tempArreglo[idx].nombreCopa=formatearTexto(nombreCopa,2);
                        estaCreandoCopa=false;

                        setIinfoGestionJornadasUS(tempArreglo);
                    }
                    else{
                        titulo="";
                        mensaje="Nombre de la copa a crear NO puede estar vacio";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR", "MEDIA");
                    }

                    break;
                case "CLICK_BORRAR_COPA":
                    registroSel=params;    
                    let esMismoRegistro=false;
                    let borrar=false;

                    tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));

                    if(tempArreglo[registroSel].estado==="EDITANDO"){
                        esMismoRegistro=true;
                        borrar=true;
                    }                    
                    
                    if(!esMismoRegistro){

                        if(estaCreandoCopa){
                            titulo="CREANDO/EDITANDO COPA";
                            mensaje="Debe finalizar la creación/edición de la copa para borrar copas";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                        }
                        else if(estaCreandoJornada){
                            titulo="CREANDO/EDITANDO JORNADA";
                            mensaje="Debe finalizar la creación/edición de la jornada para borrar copas";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                        }
                        else borrar=true;
                    }
                    
                    if(borrar){
                        if(infoGestionJornadasUS[registroSel].jornadas.length>0){
                            titulo="CONFIRMAR BORRADO";
                            mensaje="Esta acción borrará la copa seleccionada y las jornadas creadas para esta.\n\nEsta de acuerdo?";
                            ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_BORRAR_COPA");    
                        }
                        else{     
                            if(tempArreglo[registroSel].estado==="EDITANDO") estaCreandoCopa=false;

                            if(tempArreglo[registroSel].idcopa==="-1") tempArreglo.splice(registroSel,1);
                            else tempArreglo[registroSel].estado="BORRADO";                                                

                            setIinfoGestionJornadasUS(tempArreglo);
                            registroSel=-1;
                            setJornadaSelUS(-1);
                        }
                    }                    

                    break;
                case "CONFIRMO_BORRAR_COPA":
                        setShowMensaje(false);
                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                        if(tempArreglo[registroSel].estado==="EDITANDO") estaCreandoCopa=false;
                        
                        if(tempArreglo[registroSel].idcopa==="-1") tempArreglo.splice(registroSel,1);
                        else tempArreglo[registroSel].estado="BORRADO";                       

                        setIinfoGestionJornadasUS(tempArreglo);
                        registroSel=-1;
                        setJornadaSelUS(-1);
                    break;
                case "CLICK_INCLUIR_JORNADAS_ESTANDAR":
                    let tipoJornadas=valorNumero(params);
                    tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                    let tempJornadas=[];
                    let id=-1;
                    let regJor=Object.assign({} , jornada);

                    if(tipoJornadas>=32){   
                        regJor=Object.assign({} , jornada);                     
                        regJor.idjornada="" + id;
                        regJor.nombreJornada="32avos De Final";
                        tempJornadas.push(regJor);
                    }

                    if(tipoJornadas>=16){
                        regJor=Object.assign({} , jornada);
                        regJor.idjornada="" + id;
                        regJor.nombreJornada="16avos De Final";
                        tempJornadas.push(regJor);
                    }

                    if(tipoJornadas>=8){
                        regJor=Object.assign({} , jornada);
                        regJor.idjornada="" + id;
                        regJor.nombreJornada="Octavos De Final";
                        tempJornadas.push(regJor);
                    }

                    if(tipoJornadas>=4){
                        regJor=Object.assign({} , jornada);
                        regJor.idjornada="" + id;
                        regJor.nombreJornada="Cuartos De Final";
                        tempJornadas.push(regJor);
                    }

                    if(tipoJornadas>=2){
                        regJor=Object.assign({} , jornada);
                        regJor.idjornada="" + id;
                        regJor.nombreJornada="Semifinal";
                        tempJornadas.push(regJor);  

                        regJor=Object.assign({} , jornada);
                        regJor.idjornada="" + id;
                        regJor.nombreJornada="Tercero y Cuarto";
                        tempJornadas.push(regJor);

                        regJor=Object.assign({} , jornada);
                        regJor.idjornada="" + id;
                        regJor.nombreJornada="Final";
                        tempJornadas.push(regJor);
                    }

                    tempArreglo[jornadaSelUS].jornadas=tempJornadas;

                    setIinfoGestionJornadasUS(tempArreglo);
                    

                    break;
                case "CLICK_CONFIGURAR_JORNADA_GRUPOS":                    

                    if(estaCreandoCopa){
                        titulo="CREANDO/EDITANDO COPA";
                        mensaje="Debe finalizar la creación/edición de la copa para crear o editar jornadas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(estaCreandoJornada){
                        titulo="CREANDO/EDITANDO JORNADA";
                        mensaje="Debe finalizar la creación/edición de la jornada para crear o editar jornadas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{                        
                        registroSel=params ; 
                        tipoGestionGrupos="JORNADA"; 
                        
                        generarEquiposXGrupoJornada("INICIAL"); 
                        generarListaGrupos(); 
                        setTipoSelGruposUS(""); 
                        letCambioGrupo=false;  
                        
                        openGestionGrupos();
                    }                    
                    
                    break;
                case "CLICK_EDITAR_JORNADA":                    

                    if(estaCreandoCopa){
                        titulo="CREANDO/EDITANDO COPA";
                        mensaje="Debe finalizar la creación/edición de la copa para crear o editar jornadas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(estaCreandoJornada){
                        titulo="CREANDO/EDITANDO JORNADA";
                        mensaje="Debe finalizar la creación/edición de la jornada para crear o editar jornadas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{                        
                        idx=params;
                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                        tempArreglo[jornadaSelUS].jornadas[idx].estado="EDITANDO";
                        estaCreandoJornada=true;

                        if(tempArreglo[jornadaSelUS].jornadas[idx].tienePartidos!=="0"){

                        }

                        setIinfoGestionJornadasUS(tempArreglo);
                    }                    
                    
                    break;
                case "CAMBIAR_TIPO_JORNADA":
                    idx=params[1];
                    let tipoJorNueva="" + params[0].value;

                    tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));                    

                    let tipoJorActual="" + tempArreglo[jornadaSelUS].jornadas[idx].tipoJornadaEliminacion;
                    let tienePartidos="" + tempArreglo[jornadaSelUS].jornadas[idx].tienePartidos;

                    let cambiar=true;

                    if(tienePartidos!=="0"){
                        if((tipoJorNueva!=="2" && tipoJorNueva!=="3") && (tipoJorActual==="2" || tipoJorActual==="3")){
                            cambiar=false;

                            titulo="TIENE PARTIDOS";
                            mensaje="La Jornada por Grupos que intenta cambiar, YA TIENE partidos jugados o programados por lo que no es posible modificarla.\n\nBorre los partidos de esta jornada para que pueda modificar el tipo de jornada.";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR", "ALTA");
                        }
                    }

                    if(cambiar){
                        if((tipoJorNueva==="2" || tipoJorNueva==="3") && (tipoJorActual!=="2" && tipoJorActual!=="3")){
                            tempArreglo[jornadaSelUS].jornadas[idx].gruposGuadados=true;
                        }

                        tempArreglo[jornadaSelUS].jornadas[idx].tipoJornadaSel=valorNumero(tipoJorNueva);
                        tempArreglo[jornadaSelUS].jornadas[idx].tipoJornadaEliminacion=tipoJorNueva;
                        tempArreglo[jornadaSelUS].jornadas[idx].nombreTJE=listaJornadasEliminacion[valorNumero(tipoJorNueva)].label;                    

                        setIinfoGestionJornadasUS(tempArreglo);
                    }
                    

                    break;
                case "ACEPTAR_MODIFICACION_JORNADA":
                    idx=params;
                    let nombreJornada=quitarCharEspeciales(infoGestionJornadasUS[jornadaSelUS].jornadas[idx].nombreJornada);

                    if(nombreJornada!==""){
                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                        tempArreglo[jornadaSelUS].jornadas[idx].estado="";
                        tempArreglo[jornadaSelUS].jornadas[idx].nombreJornada=formatearTexto(nombreJornada,2);
                        estaCreandoJornada=false;

                        setIinfoGestionJornadasUS(tempArreglo);
                    }
                    else{
                        titulo="";
                        mensaje="Nombre de la jornada a crear NO puede estar vacio";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR", "MEDIA");
                    }

                    break;
                case "CLICK_BORRAR_JORNADA":
                    registroSel=params;    
                    let esMismoRegistro2=false;
                    let borrar2=false;

                    tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));

                    if(tempArreglo[jornadaSelUS].jornadas[registroSel].estado==="EDITANDO"){
                        esMismoRegistro2=true;
                        borrar2=true;
                    }                    
                    
                    if(!esMismoRegistro2){

                        if(estaCreandoCopa){
                            titulo="CREANDO/EDITANDO COPA";
                            mensaje="Debe finalizar la creación/edición de la copa para borrar jornadas";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                        }
                        else if(estaCreandoJornada){
                            titulo="CREANDO/EDITANDO JORNADA";
                            mensaje="Debe finalizar la creación/edición de la jornada para borrar jornadas";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                        }
                        else borrar2=true;
                    }
                    
                    if(borrar2){
                        titulo="CONFIRMAR BORRADO";
                        mensaje="Esta acción borrará la jornada seleccionada.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_BORRAR_JORNADA");  
                    }                    

                    break;
                case "CONFIRMO_BORRAR_JORNADA":
                        setShowMensaje(false);
                        tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                        if(tempArreglo[jornadaSelUS].jornadas[registroSel].estado==="EDITANDO") estaCreandoJornada=false;                              
                        
                        if(tempArreglo[jornadaSelUS].jornadas[registroSel].idjornada==="-1") tempArreglo[jornadaSelUS].jornadas.splice(registroSel,1); 
                        else tempArreglo[jornadaSelUS].jornadas[registroSel].estado="BORRADO"; 

                        setIinfoGestionJornadasUS(tempArreglo);
                        registroSel=-1;
                    break;
                case "CLICK_CREAR_NUEVA_JORNADA":
                    if(jornadaSelUS<0){
                        titulo="SELECCIONAR COPA";
                        mensaje="Debe seleccionar la copa en la que quiere gestionar sus jornadas";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{
                        if(estaCreandoCopa){
                            titulo="CREANDO/EDITANDO COPA";
                            mensaje="Debe finalizar la creación/edición de la copa para crear o editar jornadas adicionales";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                        }
                        else if(estaCreandoJornada){
                            titulo="CREANDO/EDITANDO JORNADA";
                            mensaje="Debe finalizar la creación/edición de la jornada para crear o editar jornadas adicionales";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                        }
                        else{
                            let tipoNueva=params;
                            tempArreglo=JSON.parse(JSON.stringify(infoGestionJornadasUS));
                            
                            let regJornada=Object.assign({} , jornada);
                            regJornada.idjornada="-1";
                            regJornada.estado="EDITANDO";

                            if(tipoNueva===null){
                                tempArreglo[jornadaSelUS].jornadas.push(regJornada);
                                setIrHastaFinJornada(true);
                            } 
                            else tempArreglo[jornadaSelUS].jornadas.splice(tipoNueva,0,regJornada);

                            estaCreandoJornada=true;
                            setIinfoGestionJornadasUS(tempArreglo);
                        }       
                    }
                                

                    break;
                case "CLICK_INCLUIR_NUEVA_JORNADA":
                    if(estaCreandoCopa){
                        titulo="CREANDO/EDITANDO COPA";
                        mensaje="Debe finalizar la creación/edición de la copa para crear o editar jornadas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(estaCreandoJornada){
                        titulo="CREANDO/EDITANDO JORNADA";
                        mensaje="Debe finalizar la creación/edición de la jornada para crear o editar jornadas adicionales";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{
                        registroSel=params;
                        tempOpciones=[];
                        txtOpcion="";
                        valOpcion="";                    

                        txtOpcion="Antes de la actual";
                        valOpcion="CREAR_JORNADA_ANTES_ACTUAL";
                        tempOpciones.push([txtOpcion,valOpcion]);

                        txtOpcion="Despúes de la actual";
                        valOpcion="CREAR_JORNADA_DESPUES_ACTUAL";
                        tempOpciones.push([txtOpcion,valOpcion]);                                  

                        if(tempOpciones.length>0){
                            setTituloMenu("Crear Nueva Jornada")
                            setOpcionesMenu(tempOpciones);
                            setOpcionSel(-1);
                            openMenu();
                        }
                    }

                    

                    break;
                case "CLICK_GUARDAR_CONFIGURACION_JORNADAS":          

                    if(estaCreandoCopa){
                            titulo="CREANDO/EDITANDO COPA";
                            mensaje="Debe finalizar la creación/edición de la copa para guardar la configuración realizada";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else if(estaCreandoJornada){
                            titulo="CREANDO/EDITANDO JORNADA";
                            mensaje="Debe finalizar la creación/edición de la jornada para guardar la configuración realizada";
                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                    }
                    else{
                        let tempA1=JSON.stringify(infoGestionJornadasINICIAL);
                        let tempA2=JSON.stringify(infoGestionJornadasUS);

                        if(tempA1===tempA2){
                            titulo="SIN CAMBIOS";
                                mensaje="No existen CAMBIOS en la configuración de COPAS/JORNADAS del torneo.";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ALERTA", "MEDIA");
                        }
                        else{
                            let hayCopasSinJornadas=false;
                            for(let i=0;i<infoGestionJornadasUS.length;i++){
                                if(infoGestionJornadasUS[i].jornadas.length===0){
                                    hayCopasSinJornadas=true;
                                    i=infoGestionJornadasUS.length;
                                }
                            }                    
                            if(hayCopasSinJornadas){
                                titulo="CONFIRMAR CAMBIOS";
                                mensaje="Existen copas creadas en el torneo SIN jornadas configuradas. ";
                                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"INFO", "MEDIA");
                            }
                            else{
                                titulo="CONFIRMAR CAMBIOS";
                                mensaje="Esta acción guardará los cambios en la configuración de COPAS/JORNADAS del torneo.\n\nEsta de acuerdo?";
                                ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_GUARDAR_CONFIGURACION_JORNADAS");  
                            }
                        }

                        
                    }


                    break;
                case "CONFIRMO_GUARDAR_CONFIGURACION_JORNADAS":    
                    setShowMensaje(false);
                    let txtFinal=getTextoJornadas();

                    if(txtFinal!==""){
                        closeGestionJornadas();
                        BD_solicitarDatos("GUARDAR_CONFIGURACION_JORNADAS", txtFinal);
                    }
                    else{
                        titulo="SIN DATOS";
                        mensaje="No se ha recuperado la información para guardar la configuración, intente nuevamente o contáctese con el area de soporte MarcaGol.";
                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR", "MEDIA");
                    }

                    break;
                case "CLICK_CANCELAR_CONFIGURACION_JORNADAS":
                    
                    let tempA1=JSON.stringify(infoGestionJornadasINICIAL);
                    let tempA2=JSON.stringify(infoGestionJornadasUS);

                    if(tempA1!==tempA2){
                        titulo="CAMBIOS SIN GUARDAR";
                        mensaje="Existen CAMBIOS a la configuración de jornadas SIN guardar, si continúa se perderán los cambios realizados.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CONFIRMO_CANCELAR_CONFIGURACION_JORNADAS");  
                    }
                    else{
                        estaCreandoCopa=false;
                        estaCreandoJornada=false;
                        //setIinfoGestionJornadasUS(infoGestionJornadasINICIAL);
                        closeGestionJornadas();
                    }

                    break;
                case "CONFIRMO_CANCELAR_CONFIGURACION_JORNADAS":
                    estaCreandoCopa=false;
                    estaCreandoJornada=false;
                    setShowMensaje(false);
                    setIinfoGestionJornadasUS(infoGestionJornadasINICIAL);
                    closeGestionJornadas();

                    break;
                default:
                    break;
            }

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    } 
  


    const abrirVentanaBusqueda = (numC) => {
        let nomFuncion="abrirVentanaBusqueda";

        try{
            textoBuscar="";
            let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
            tempArreglo[17].valor="";
            tempArreglo[17].error="";
            setArrCampos(tempArreglo);

            cancelarBusqueda=false;

            setDatosEncontrados([]);            
            
            openBusqueda();

            if (refBusqueda.current)  refBusqueda.current.focus();            
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }


    const showParametrosConfig = () => {
        let nomFuncion="showParametrosConfig";

        try{

            return(
                <div className='BF_cajaBlanca' style={{fontSize:"14px", padding:"4px", textAlign:"left", paddingBottom:"14px"}}>
                    <div style={{marginLeft:"10px", marginTop:"4px"}}>Horario*</div>
                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                        <div className="IP_entradas2" style={{flexGrow: 1, flexShrink: 1, minWidth:"100px", maxWidth: "500px",  whiteSpace:"pre"}}>{arrCampos[15].valor}</div>
                        <img className='IM_imgIcono24' src={ic_modificar_gris} alt='' style={{padding:"8px",cursor:"pointer"}} onClick={() => {setAbrirHorarioUS(true)}}/> 
                        <img className='IM_imgIcono24' src={ic_transparente} alt='' style={{padding:"8px"}}/> 
                        <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                    </div>
                    {clickAceptarUS && arrCampos[3].error!=="" && (<div className="TX_error" style={{textAlign:"left", fontSize:"12px", marginTop:"-8px"}}>{arrCampos[3].error}</div>)}


                    <div style={{marginLeft:"10px", marginTop:"4px"}}>Fecha Inicio del Torneo*</div>
                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                        <div className="IP_entradas" style={{flex:"1", flexGrow: 1, flexShrink: 1, minWidth:"100px", display:"flex", flexWrap:"nowrap", alignItems:"center", background:C_fondoGrisSuperClaro, height:"27px"}}>
                                <input disabled={true} type="text" value={formatearFecha(arrCampos[4].valor,7)}  style={{border:"none", outline:"none", background:C_transparente, flexGrow: 1, flexShrink: 1, minWidth:"100px"}} placeholder="" onChange={(e) => validarCampo(e, "", 0)} /> 
                                <img className='IM_imgIcono16' src={ic_transparente} alt='' style={{padding:"4px", cursor:"pointer"}}/> 
                        </div>
                        <img className='IM_imgIcono24' src={ic_programar} alt='' style={{padding:"8px", cursor:"pointer"}} onClick={() => clickGenerico("CALENDARIO_INICIO_TORNEO")}/> 
                        <img className='IM_imgIcono24' src={ic_transparente} alt='' style={{padding:"8px"}}/> 
                        <img className='IM_imgIcono24' src={ic_transparente} alt='' style={{padding:"8px"}}/> 
                    </div>
                    {clickAceptarUS && arrCampos[4].error!=="" && (<div className="TX_error" style={{textAlign:"left", fontSize:"12px", marginTop:"-8px"}}>{arrCampos[4].error}</div>)}

                    {showFechaLimEquipoUS ? (<div style={{marginLeft:"10px", marginTop:"4px"}}>Fecha Límite Modificar Plantilla</div>) : 
                                            (<div style={{marginLeft:"10px", marginTop:"4px"}}>Fecha Límite de Modificaciones</div>) }
                    
                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                        <div className="IP_entradas" style={{flex:"1", flexGrow: 1, flexShrink: 1, minWidth:"100px", display:"flex", flexWrap:"nowrap", alignItems:"center", background:C_fondoGrisSuperClaro, height:"27px"}}>
                                <input disabled={true} type="text" value={formatearFecha(arrCampos[5].valor,7)}  style={{border:"none", outline:"none", background:C_transparente, flexGrow: 1, flexShrink: 1, minWidth:"100px"}} placeholder="" onChange={(e) => validarCampo(e, "", 0)} /> 
                                <img className='IM_imgIcono16' src={ic_cancelar_gris} alt='' style={{padding:"4px", cursor:"pointer"}} onClick={() => clickGenerico("LIMPIAR_LIMITE_PLANTILLA")}/> 
                        </div>
                        <img className='IM_imgIcono24' src={ic_programar} alt='' style={{padding:"8px", cursor:"pointer"}}  onClick={() => clickGenerico("CALENDARIO_LIMITE_PLANTILLA")}/> 
                        {showFechaLimEquipoUS && (<img className='IM_imgIcono24' src={ic_transparente} alt='' style={{padding:"8px"}}/> )}
                        {!showFechaLimEquipoUS && (<img className='IM_imgIcono24' src={ic_configura_gris} alt='' style={{padding:"8px", cursor:"pointer"}} onClick={() => setShowFechaLimEquipoUS(true)}/> )}
                        <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                    </div>

                    {showFechaLimEquipoUS && (
                        <>
                        <div style={{marginLeft:"10px", marginTop:"4px"}}>Fecha Límite Modificar Datos Equipo</div>
                        <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                            <div className="IP_entradas" style={{flex:"1", flexGrow: 1, flexShrink: 1, minWidth:"100px", display:"flex", flexWrap:"nowrap", alignItems:"center", background:C_fondoGrisSuperClaro, height:"27px"}}>
                                <input disabled={true} type="text" value={formatearFecha(arrCampos[6].valor,7)}  style={{border:"none", outline:"none", background:C_transparente, flexGrow: 1, flexShrink: 1, minWidth:"100px"}} placeholder="" onChange={(e) => validarCampo(e, "", 0)} /> 
                                <img className='IM_imgIcono16' src={ic_cancelar_gris} alt='' style={{padding:"4px", cursor:"pointer"}}onClick={() => clickGenerico("LIMPIAR_LIMITE_EQUIPO")}/> 
                            </div>
                            
                            <img className='IM_imgIcono24' src={ic_programar} alt='' style={{padding:"8px", cursor:"pointer"}} onClick={() => clickGenerico("CALENDARIO_LIMITE_EQUIPO")}/> 
                            <img className='IM_imgIcono24' src={ic_transparente} alt='' style={{padding:"8px"}}/> 
                            <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                        </div>
                        </>
                    )}

                    <div className="BF_lineaInferior" style={{marginBlock:"10px"}}></div>

                    <div style={{marginLeft:"10px", marginTop:"4px"}}>Tipo de Torneo*</div>
                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                        <div style={{flexGrow: 1, flexShrink: 1, minWidth:"100px", maxWidth: "500px", background:"white", zIndex:"99"}}>           
                        <Select     
                            styles={estilosSelect}
                            value={listaTipoTorneoUS[tipoTorneoSelUS]}
                            formatOptionLabel={listaDosItems}
                            options={listaTipoTorneoUS}
                            isSearchable={false}   
                            onChange={(e,index) => {clickGenerico("CAMBIAR_TIPO_TORNEO",e)}}            
                        />   
                        </div>                         
                        <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                    </div>
                    {clickAceptarUS && arrCampos[7].error!=="" && (<div className="TX_error" style={{textAlign:"left", fontSize:"12px", marginTop:"-4px"}}>{arrCampos[7].error}</div>)}


                    {permiteEmpatesFGUS && (
                        <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginInline:"8px", marginTop:"15px"}}>
                            <div style={{flex:"1"}}>Fase de Grupos Permite Empates?</div>
                            <div style={{display:"flex", justifyContent:"right", alignItems:"center", height:"20px", marginRight:"10px"}}>
                                <p>NO</p>
                                <label className="switch">
                                    <input type="checkbox" checked={arrCampos[8].valor!=="1" ? false : true} onChange={(e) => {validarCampo(e,"CAMBIAR_PRMITE_EMPATES",0)}}/><span className="slider round"></span>
                                </label>
                                <p>SI</p>
                            </div>
                        </div>
                    )}
                    
                    

                </div>
            );


        }catch(err){
            reportarError(nomClase, nomFuncion,"",err);
        } 
    }

    const showParametrosJuego = () => {
        let nomFuncion="showParametrosJuego";

        try{



            return(
                <div className='BF_cajaBlanca' style={{fontSize:"12px", textAlign:"left", paddingBottom:"14px", paddingLeft:"8px", paddingTop:"8px"}}>
                   {parametrosJuegoUS.length>0 && (<>
                    {parametrosJuegoUS.map ((el, index) => (<div key={index}>
                        {el.valormin==="0" && el.valormax==="1" && (
                        <div  style={{display:"flex", flexWrap:"nowrap", alignItems:"center", textAlign:"center"}}>
                            <div style={{flex:"1", textAlign:"left", color:C_uniformeGrisOscuro}}>{el.titulo}</div>
                            <div style={{width:"40px", color:C_colorPrimary}}>{"NO"}</div>
                          
                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"20px", width:"60px"}}>
                                    <label className="switch">
                                        <input type="checkbox" checked={arrCampos[9].valor[index]!=="1" ? false : true} 
                                        onChange={(e) => {validarCampo(e,"CAMBIAR_PARAMETRO_JUEGO",index)}}/><span className="slider round"></span>
                                    </label>
                            </div>                           
                            <div style={{width:"40px", color:C_colorPrimary}}>{"SI"}</div>
                            <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                        </div>
                        )}

                        {!(el.valormin==="0" && el.valormax==="1") && (<>
                        <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", textAlign:"center"}}>
                            <div style={{flex:"1", textAlign:"left", color:C_uniformeGrisOscuro}}>{el.titulo}</div>
                            <div>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", textAlign:"center"}}>
                                    <div style={{width:"50px", color:C_colorPrimary}}>{">=" + el.valormin}</div>
                                    <input type="text" value={arrCampos[9].valor[index]} className='IP_entradasPeq' style={{width: "40px", color:C_uniformeNegro, textAlign:"center"}} 
                                        onChange={(e) => {validarCampo(e,"PARAMETRO_JUEGO",[index,el.valormin,el.valormax])}}
                                        onBlur={(e) => clickGenerico("SALE_PARAMETRO_JUEGO")} />
                                    <div style={{width:"50px", color:C_colorPrimary}}>{">=" + el.valormax}</div>
                                </div>  
                                {arrCampos[9].error[index]!=="" && (<div className="TX_error" style={{textAlign:"center", fontSize:"10px", margin:"0px", padding:"0px"}}>{arrCampos[9].error[index]}</div>)}
                            </div>                          
                            <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                        </div>
                        
                        </>
                        )}

                    </div>
                    ))}
                   </>)}              

                </div>
            );


        }catch(err){
            reportarError(nomClase, nomFuncion,"",err);
        } 
    }

    const showParametrosOpcional = () => {
        let nomFuncion="showParametrosOpcional";

        try{



            return(
                <div className='BF_cajaBlanca' style={{fontSize:"12px", textAlign:"left", paddingLeft:"8px", paddingTop:"8px", color:C_uniformeGrisOscuro}}>
                    <div>ASIGNACIÓ DE PUNTOS DE PARTIDOS</div>
                    <div style={{display:"flex", flexWrap:"nowrap", textAlign:"center", paddingBottom:"10px"}}>
                        <div style={{flex:"1"}}>
                            <div style={{color:C_colorPrimary, fontSize:"14px", fontWeight:"bold"}}>Ganador</div>
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                {permiteEditarPuntosUS && (<input type="text" value={arrCampos[11].valor} className='IP_entradasPeq' style={{width: "30px", textAlign:"center"}} onChange={(e) => validarCampo(e, "PUNTOS_PARTIDO", "GANADOR")} onBlur={(e) => clickGenerico("SALE_PUNTOS_PARTIDO")} />)}                                
                                {permiteEditarPuntosUS && (<div style={{padding:"4px"}}>Pts</div>)}
                                {!permiteEditarPuntosUS && (<div style={{padding:"4px"}}>{arrCampos[11].valor} Puntos</div>)}
                            </div>
                        </div>
                        {arrCampos[7].valor!=="5" && (
                        <div style={{flex:"1"}}>
                            <div style={{color:C_colorAccent, fontSize:"14px", fontWeight:"bold"}}>Empate</div>
                            {arrCampos[8].valor==="1" && (
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}> 
                                {permiteEditarPuntosUS && (<input type="text" value={arrCampos[12].valor} className='IP_entradasPeq' style={{width: "30px", textAlign:"center"}} onChange={(e) => validarCampo(e, "PUNTOS_PARTIDO", "GANADOR_EMPATE")} onBlur={(e) => clickGenerico("SALE_PUNTOS_PARTIDO")} />)}                                
                                {permiteEditarPuntosUS && (<div style={{padding:"4px"}}>Pts</div>)}
                                {!permiteEditarPuntosUS && (<div style={{padding:"4px"}}>{arrCampos[12].valor} Puntos</div>)}
                            </div>
                            )}

                            {arrCampos[8].valor==="0" && (
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}> 
                                {permiteEditarPuntosUS && (<div style={{padding:"4px"}}>{"Ganador"}</div>)}
                                {permiteEditarPuntosUS && (<input type="text" value={arrCampos[12].valor} className='IP_entradasPeq' style={{width: "30px", textAlign:"center"}} onChange={(e) => validarCampo(e, "PUNTOS_PARTIDO", "GANADOR_EMPATE")} onBlur={(e) => clickGenerico("SALE_PUNTOS_PARTIDO")} />)}                                                                
                                {!permiteEditarPuntosUS && (<div style={{padding:"4px"}}>{" Ganador: " + arrCampos[12].valor + " Pts"} </div>)}
                            </div>
                            )}
                            
                            {arrCampos[8].valor==="0" && (
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                {permiteEditarPuntosUS && (<div style={{padding:"4px"}}>{"Perdedor"}</div>)}
                                {permiteEditarPuntosUS && (<input type="text" value={arrCampos[13].valor} className='IP_entradasPeq' style={{width: "30px", textAlign:"center"}} onChange={(e) => validarCampo(e, "PUNTOS_PARTIDO", "PERDEDOR_EMPATE")} onBlur={(e) => clickGenerico("SALE_PUNTOS_PARTIDO")} />)}                                                                
                                {!permiteEditarPuntosUS && (<div style={{padding:"4px"}}> {"Perdedor: " + arrCampos[13].valor + " Pts"}</div>)}
                            </div>
                            )}
                        </div>
                        )}
                        
                        <div style={{flex:"1"}}>
                            <div style={{color:C_uniformeRosa, fontSize:"14px", fontWeight:"bold"}}>Perdedor</div>
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                {permiteEditarPuntosUS && (<input type="text" value={arrCampos[14].valor} className='IP_entradasPeq' style={{width: "30px", textAlign:"center"}} onChange={(e) => validarCampo(e, "PUNTOS_PARTIDO", "PERDEDOR")} onBlur={(e) => clickGenerico("SALE_PUNTOS_PARTIDO")} />)}                                
                                {permiteEditarPuntosUS && (<div style={{padding:"4px"}}>Pts</div>)}
                                {!permiteEditarPuntosUS && (<div style={{padding:"4px"}}>{arrCampos[14].valor} Puntos</div>)}
                            </div>
                        </div>
                        {permiteEditarPuntosUS ? 
                        (<img className='IM_imgIcono24' src={ic_transparente} alt='' style={{padding:"8px"}}/> ) 
                        : 
                        (<img className='IM_imgIcono24' src={ic_modificar_gris} alt='' style={{padding:"8px", cursor:"pointer"}} onClick={() => {setPermiteEditarPuntosUS(true)}}/> )}
                        
                    </div>

                    {arrCampos[11].error!=="" && (<div className="TX_error" style={{textAlign:"center", fontSize:"12px", margin:"0px", padding:"0px"}}>{arrCampos[11].error}</div>)}

                    <div style={{marginTop:"15px"}}>
                   {parametrosOpcionalUS.length>0 && (<>
                    {parametrosOpcionalUS.map ((el, index) => (<div key={index}>
                        {el.valormin==="0" && el.valormax==="1" && (
                        <div  style={{display:"flex", flexWrap:"nowrap", alignItems:"center", textAlign:"center"}}>
                            <div style={{flex:"1", textAlign:"left"}}>{el.titulo}</div>
                            <div style={{width:"40px", color:C_colorPrimary}}>{"NO"}</div>
                          
                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"20px", width:"60px"}}>
                                    <label className="switch">
                                        <input type="checkbox" checked={arrCampos[10].valor[index]!=="1" ? false : true} 
                                        onChange={(e) => {validarCampo(e,"CAMBIAR_PARAMETRO_OPCIONAL",index)}}/><span className="slider round"></span>
                                    </label>
                            </div>                           
                            <div style={{width:"40px", color:C_colorPrimary}}>{"SI"}</div>
                            <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                        </div>
                        )}

                        {!(el.valormin==="0" && el.valormax==="1") && (
                        <div  style={{display:"flex", flexWrap:"nowrap", alignItems:"center", textAlign:"center"}}>
                            <div style={{flex:"1", textAlign:"left"}}>{el.titulo}</div>
                            <div>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", textAlign:"center"}}>
                                    <div style={{width:"50px", color:C_colorPrimary}}>{">=" + el.valormin}</div>
                                    <input type="text" value={arrCampos[10].valor[index]} className='IP_entradasPeq' style={{width: "40px", color:C_uniformeNegro, textAlign:"center"}} 
                                    onChange={(e) => {validarCampo(e,"PARAMETRO_OPCIONAL",[index,el.valormin,el.valormax])}}
                                    onBlur={(e) => clickGenerico("SALE_PARAMETRO_OPCIONAL")}  />
                                    <div style={{width:"50px", color:C_colorPrimary}}>{">=" + el.valormax}</div>
                                </div>  
                                {arrCampos[10].error[index]!=="" && (<div className="TX_error" style={{textAlign:"center", fontSize:"10px", margin:"0px", padding:"0px"}}>{arrCampos[10].error[index]}</div>)}
                            </div> 
                            <img className='IM_imgIcono24' src={ic_ayuda_accent} alt='' style={{padding:"8px"}}/> 
                        </div> 
                        )}

                        </div>
                    ))}
                   </>)}  
                   </div>            

                </div>
            );


        }catch(err){
            reportarError(nomClase, nomFuncion,"",err);
        } 
    }

    const buscarTexto = () => {
        let nomFuncion="buscarTexto";

        try{
            cancelarBusqueda=false;
            let regPagina=20;
            let mostrarJugadoresSede=false;
            let tempDatosEncontrados=[];
            let llavesIncluidas=[];


            if(tipoUser==="administrador") mostrarJugadoresSede=true;
            

            if(true){
                
                let datos=[];
                let datosTI=false;

                if(tipoSeleccion==="Telefono_Delegado" || tipoSeleccion==="Nombre_Delegado"){
                    if(textoBuscar!=="" && jugadoresSedeO.length>0 && mostrarJugadoresSede){
                        datos=JSON.parse(JSON.stringify(jugadoresSedeO));
                    } 
                }
                else if(tipoSeleccion==="Equipo_Sede"){
                    datos=JSON.parse(JSON.stringify(equiposSedeO));
                }
                else if(tipoSeleccion==="Cancha_Sede"){
                    datos=JSON.parse(JSON.stringify(canchasSedeO));

                    let registro=Object.assign({} , cancha);
                    registro.idCancha="-1";
                    registro.numero="NUEVA Cancha";
                    registro.nombre="Crear una nueva Cancha en la Sede";

                    tempDatosEncontrados.push(registro);

                }


                if(datos.length>0) datosTI=true;


                let total=0;
                let texto="", textoBuscado="";
                
                textoBuscado=textoBuscar;
                textoBuscado=textoBuscado.replaceAll("+","");
                textoBuscado=quitarTildes(textoBuscado).toUpperCase();

                if(datosTI){
                        let i;
                        cancelarBusqueda=false;

                        for(i=0;i<datos.length;i++){
                            if(cancelarBusqueda) return;

                            if(!cancelarBusqueda){
                                let incluir=false;                                

                                if(tipoSeleccion==="Telefono_Delegado"){
                                    texto=datos[i].telefono;
                                    if(texto.includes(textoBuscado)) incluir=true;                                  
                                } else if(tipoSeleccion==="Nombre_Delegado"){
                                    texto=datos[i].nomBusqueda;
                                    if(texto.includes(textoBuscado)) incluir=true;
                                } else if(tipoSeleccion==="Equipo_Sede"){
                                    texto=datos[i].nomLargoBusqueda;
                                    if(textoBuscado==="" || texto.includes(textoBuscado)) incluir=true;
                                    else{
                                        texto=datos[i].nomTorneoBusqueda;
                                        if(texto.includes(textoBuscado)) incluir=true;
                                    }
                                } else if(tipoSeleccion==="Cancha_Sede"){
                                    texto=datos[i].nomBusqueda;
                                    if(datos[i].activo==="1" && (textoBuscado==="" || texto.includes(textoBuscado))) incluir=true;
                                }


                                if(incluir){                                    
                                   
                                    let llave="";
                                    let dato2="";
                                    if(tipoSeleccion==="Telefono_Delegado" || tipoSeleccion==="Nombre_Delegado"){
                                        llave=datos[i].telefono;                            
                                    } else if(tipoSeleccion==="Equipo_Sede"){
                                        llave=datos[i].idEquipo;
                                        dato2=datos[i].nombreLargo;
                                    } else if(tipoSeleccion==="Cancha_Sede"){
                                        llave=datos[i].idCancha;
                                    }

                                    let correcto=true;
                                    for(let j=0;j<llavesIncluidas.length;j++){
                                            if(llavesIncluidas[j]===llave){
                                                correcto=false;
                                                j=llavesIncluidas.length;
                                            }
                                    }

                                    if(correcto && !tipoSeleccion.includes("Delegado")){
                                        correcto=!yaEstaInscrito(tipoSeleccion,llave,dato2);
                                    }
                                        
                                    if(correcto){
                                            tempDatosEncontrados.push(datos[i]);
                                            llavesIncluidas.push(llave);
                                            total++;
                                    }
                                    

                                    if(total>=regPagina) i=datos.length;
                                }

                            }
                            else i=datos.length;

                        }

                }

                if(total==0) {
                    if (tipoSeleccion==="Telefono_Delegado") {
                        if (textoBuscado.length >=10 && textoBuscado.length < 15){
                            total++;
                            let tempJugador = {
                                idjugador:"",
                                foto:"",
                                nombre:"Delegado Nuevo",
                                telefono: textoBuscado,
                                registrado:"1",
                                pendiente:"3",
                                cantEquipos:""
                            }
                            
                            tempDatosEncontrados.push(tempJugador);
                        }
                        
                    }

                }


                if(!cancelarBusqueda) setDatosEncontrados(tempDatosEncontrados);  

            }
            else setDatosEncontrados(tempDatosEncontrados);



        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 

    }

    const yaEstaInscrito = (tipoLista, id, dato2) => {
        let nomFuncion="yaEstaInscrito";

        let respuesta=false;
        try{

        

            if(tipoLista==="Equipo_Sede"){
                for(let i=0;i<infoEquiposO.length;i++){
                    if(infoEquiposO[i].idequipo===id || infoEquiposO[i].nombrelargo.toUpperCase()===dato2.toUpperCase()){
                        if(infoEquiposO[i].borrado==="0"){
                            respuesta=true;
                            i=infoEquiposO.length;
                        }                        
                    }
                }
            }
            else if(tipoLista==="Cancha_Sede"){
                for(let i=0;i<infoCanchasO.length;i++){
                    if(infoCanchasO[i].idcancha===id){
                        if(infoCanchasO[i].borrado==="0"){
                            respuesta=true;
                            i=infoCanchasO.length;
                        }                        
                    }
                }
            }
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  

        return respuesta;
    }

    const generarListaGrupos = () => {
        let nomFuncion="generarListaGrupos";

        try{
            let min=1;
            let max=Math.ceil(infoEquiposUS.length/2);

            let base={value:"", label:"", texto2:""};

            let registro=Object.assign({} , base);

            let tempLista=[];
            registro.value="0";
            registro.label="-";
            tempLista.push(registro);

            for(let i=min;i<=max; i++){
                registro=Object.assign({} , base);
                registro.value="" + i;
                registro.label="" + i;
                tempLista.push(registro)
            }

           setListaGruposUS(tempLista);
           setgGrupoSelUS(0);
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }

    const generarEquiposXGrupo = (tipo) => {
        let nomFuncion="generarEquiposXGrupo";

        try{
            let tempGrupos=[];
            let tempSinGrupos=[];

            let objBase={grupo:"", equipos:[]};
            let registro=JSON.parse(JSON.stringify(objBase));

            let tempGruposBase=[];

            registro.grupo="0";
            tempSinGrupos.push(registro);

            let max=Math.ceil(infoEquiposUS.length/2);
           

            for(let i=1;i<=max;i++){
                registro=JSON.parse(JSON.stringify(objBase));
                registro.grupo="" + i;
                tempGruposBase.push(registro);
            }
            
            for(let i=0;i<infoEquiposO.length; i++){

                if(infoEquiposO[i].borrado==="0"){
                    let numeroGrupo=0;
                    if(tipo==="INICIAL") infoEquiposO[i].nuevoGrupo=infoEquiposO[i].numgrupo;
                    
                    numeroGrupo=valorNumero(infoEquiposO[i].nuevoGrupo);

                    if(numeroGrupo===0) tempSinGrupos[0].equipos.push(infoEquiposO[i]);
                    else tempGruposBase[numeroGrupo-1].equipos.push(infoEquiposO[i]);            
                }                
            }

            for(let i=0;i<tempGruposBase.length;i++){
                if(tempGruposBase[i].equipos.length>0){
                    tempGrupos.push(tempGruposBase[i]);
                }
            }


            setConfigSinGruposUS(tempSinGrupos);
            setConfigGruposUS(tempGrupos);
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }

    const generarEquiposXGrupoJornada = (tipo) => {
        let nomFuncion="generarEquiposXGrupoJornada";

        try{
            let tempGrupos=[];
            let tempSinGrupos=[];

            let objBase={grupo:"", equipos:[]};
            let registro=JSON.parse(JSON.stringify(objBase));
            if(tipo==="INICIAL") infoEquiposJornadaO=JSON.parse(JSON.stringify(infoEquiposUS));
            else infoEquiposJornadaO=JSON.parse(JSON.stringify(infoEquiposJornadaO));

            let idJor=infoGestionJornadasUS[jornadaSelUS].jornadas[registroSel].idjornada;

            let tempGruposBase=[];

            registro.grupo="0";
            tempSinGrupos.push(registro);

            let max=Math.ceil(infoEquiposJornadaO.length/2);
           

            for(let i=1;i<=max;i++){
                registro=JSON.parse(JSON.stringify(objBase));
                registro.grupo="" + i;
                tempGruposBase.push(registro);
            }
           
            for(let i=0;i<infoEquiposJornadaO.length; i++){

                if(infoEquiposJornadaO[i].borrado==="0"){
                    let numeroGrupo=0;
                    if(tipo==="INICIAL"){
                        infoEquiposJornadaO[i].numgrupo="0";
                        infoEquiposJornadaO[i].nuevoGrupo="0";

                        let infoGruposJornada=JSON.parse(JSON.stringify(equiposGrupoJornadaO));
                        if(infoGestionJornadasUS[jornadaSelUS].jornadas[registroSel].gruposGuadados)
                            infoGruposJornada=JSON.parse(JSON.stringify(infoGestionJornadasUS[jornadaSelUS].jornadas[registroSel].infoGrupos));

                        for(let j=0;j<infoGruposJornada.length;j++){
                            if(infoGruposJornada[j].idjornada===idJor){
                                if(infoEquiposJornadaO[i].idequipo===infoGruposJornada[j].idequipo){
                                    infoEquiposJornadaO[i].numgrupo=infoGruposJornada[j].grupo;
                                    infoEquiposJornadaO[i].nuevoGrupo=infoGruposJornada[j].grupo;
                                    infoEquiposJornadaO[i].tienePartidos=infoGruposJornada[j].tienePartidos;
                                    j=infoGruposJornada.length;
                                }
                            }
                        }

                    } 
                    
                    numeroGrupo=valorNumero(infoEquiposJornadaO[i].nuevoGrupo);

                    if(numeroGrupo===0){
                        if(infoEquiposJornadaO[i].numgrupo!=="0" || infoEquiposJornadaO[i].activo==="1") tempSinGrupos[0].equipos.push(infoEquiposJornadaO[i]); 
                    }
                    else tempGruposBase[numeroGrupo-1].equipos.push(infoEquiposJornadaO[i]);
                                     
                }                
            }

            for(let i=0;i<tempGruposBase.length;i++){
                if(tempGruposBase[i].equipos.length>0){
                    tempGrupos.push(tempGruposBase[i]);
                }
            }

            setConfigSinGruposUS(tempSinGrupos);
            setConfigGruposUS(tempGrupos);
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }



    const seleccionarItemLista = (lista, id) => {
        let nomFuncion="seleccionarItemLista";

        let respuesta=0;
        try{

            if(lista.length>0){
                for(let i=0;i<lista.length;i++){
                    if(lista[i].value===id){
                        respuesta=i;
                        i=lista.length;
                    }
                }
            }
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  

        return respuesta;
    }

    const ScrollHastaFin = () => {
        const elementRef = useRef();
        useEffect(() => {
            elementRef.current.scrollIntoView();
            let newScrollYPosition = window.pageYOffset
            
            setIrHastaFin(false);

            window.scrollTo({
                top: newScrollYPosition, // Posición vertical deseada
                left: 0
            });
        });

        return <div ref={elementRef}/>;
    };

    const ScrollHastaFinJornada = () => {
        const elementRef2 = useRef();
        useEffect(() => {
            elementRef2.current.scrollIntoView();
            let newScrollYPosition = window.pageYOffset
            
            setIrHastaFinJornada(false);

            window.scrollTo({
                top: newScrollYPosition, // Posición vertical deseada
                left: 0
            });
        });

        return <div ref={elementRef2}/>;
    };

    const validarCreacionTorneo = () => {
        let nomFuncion="validarCreacionTorneo";

        try{
            
            let hayErrores=false;
            let tempArreglo=JSON.parse(JSON.stringify(arrCampos));

            //Nombre de torneo
            if(arrCampos[0].valor===""){
                hayErrores=true;
                tempArreglo[0].error=matrizCampos[0].error;
            }
            else tempArreglo[0].error="";

            
            //PARAMETROS DE CONFIGURACIÓN

            //Horario
            tempArreglo[3].error="";
            if(arrCampos[3].valor===""){
                //hayErrores=true;
                tempArreglo[3].error=matrizCampos[3].error;
            }

            //Fecha inicio Torneo
            tempArreglo[4].error="";
            if(arrCampos[4].valor===""){
                hayErrores=true;
                tempArreglo[4].error=matrizCampos[4].error;
            }

            //Tipo de Torneo
            tempArreglo[7].error="";
            if(arrCampos[7].valor==="0"){
                hayErrores=true;
                tempArreglo[7].error=matrizCampos[7].error;
            }
            

            //PARAMETROS DE JUEGO

            if(parametrosJuegoUS.length>0){
                for(let i=0;i<arrCampos[9].valor.length;i++){
                    let valor=valorNumero(arrCampos[9].valor[i]);
                    let vMin=parametrosJuegoUS[i].valormin;
                    let vMax=parametrosJuegoUS[i].valormax;

                    if(valor<vMin || valor>vMax){
                        hayErrores=true;
                        tempArreglo[9].error[i]="Valor Fuera de Rango";
                    } 
                    else tempArreglo[9].error[i]="";
                }
            }

            let v5=0, v6=0, v7=0, v8=0, v10=0;
                let i5=0, i6=0, i7=0, i8=0, i10=0;


                for(let i=0;i<parametrosJuegoUS.length;i++){
                    if(parametrosJuegoUS[i].idparametro==="5"){
                        v5=valorNumero(tempArreglo[9].valor[i]); 
                        i5=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    } 
                    if(parametrosJuegoUS[i].idparametro==="6"){
                        v6=valorNumero(tempArreglo[9].valor[i]);
                        i6=i;
                    } 
                    if(parametrosJuegoUS[i].idparametro==="7"){
                        v7=valorNumero(tempArreglo[9].valor[i]);
                        i7=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    }
                    if(parametrosJuegoUS[i].idparametro==="8"){
                        v8=valorNumero(tempArreglo[9].valor[i]);
                        i8=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    }
                    if(parametrosJuegoUS[i].idparametro==="10"){
                        v10=valorNumero(tempArreglo[9].valor[i]);
                        i10=i;
                        if(tempArreglo[9].error[i]!=="Valor Fuera de Rango") tempArreglo[9].error[i]="";
                    }
                }

                if(tempArreglo[9].error[i8]===""){
                    if(v7<v8) tempArreglo[9].error[i8]="Mayor a Jugadores en Cancha"; 
                }
                
                if(tempArreglo[9].error[i10]===""){
                    if(v10<((v6*2) + v5)) tempArreglo[9].error[i10]="Tiempo Insuficiente";
                }

            //PARAMETROS OPCIONALES

            if(parametrosOpcionalUS.length>0){
                for(let i=0;i<arrCampos[10].valor.length;i++){
                    let valor=valorNumero(arrCampos[10].valor[i]);
                    let vMin=parametrosOpcionalUS[i].valormin;
                    let vMax=parametrosOpcionalUS[i].valormax;

                    if(valor<vMin || valor>vMax){
                        hayErrores=true;
                        tempArreglo[10].error[i]="Valor Fuera de Rango";
                    } 
                    else tempArreglo[10].error[i]="";
                }
            }


            //PUNTOS PARTIDO

            let vGanador=valorNumero(arrCampos[11].valor);
            let vGanadorEmp=valorNumero(arrCampos[12].valor);
            let vPerdedorEmp=valorNumero(arrCampos[13].valor);
            let vPerdedor=valorNumero(arrCampos[14].valor);

            tempArreglo[11].error=""; 

            if(arrCampos[7].valor!=="5"){
                        if(vGanador<=vGanadorEmp) tempArreglo[11].error="Puntos Ganador debe ser Mayor a puntos Empate";  
                        else if(vGanador<=vPerdedor) tempArreglo[11].error="Puntos Ganador debe ser Mayor a puntos Perdedor"; 
                        else if(vGanadorEmp<vPerdedor) tempArreglo[11].error="Puntos Empate debe ser Mayor o Igual a puntos Perdedor";   
                        else{
                            if(arrCampos[8].valor===false){ //SI NO PERMITE EMPATES
                                if(vGanadorEmp<=vPerdedorEmp) tempArreglo[11].error="Puntos Ganador-Empate debe ser Mayor a puntos Perdedor-Empate";   
                            }
                        }  
            }
            else{
                        if(vGanador<=vPerdedor) tempArreglo[11].error="Puntos Ganador debe ser Mayor a puntos Perdedor"; 
            }

            if(tempArreglo[11].error!=="") hayErrores=true;
            
            setArrCampos(tempArreglo);
            setClickAceptarUS(true);

            
            if(!hayErrores){
                titulo="CREAR NUEVO TORNEO";
                mensaje="Esta acción creará un nuevo Torneo de acuerdo a los datos y parametros suministrados.\n\nEsta de acuerdo?";
                ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"CLICK_CONFIRMO_CREAR_TORNEO");   

            }
            else{
                titulo="DATOS INCORRECTOS";
                mensaje="Existe información incompleta o errada, por favor verifique los campos";
                ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ALERTA","MEDIA");
            }

        }catch(err){
            reportarError(nomClase, nomFuncion,"",err);
        } 
    }

    const getTextoJornadas = () => {
        let nomFuncion="getTextoJornadas";

        let resultado="";
        try{
            let i, j, k;
            let copa="";
            let ordenJornadaEnCopa=1;
            let ordenJornadaGlobal=0;

            

            let sepRegistrosN1 = SEP_3;
            let sepCamposN1 = SEP_4;
            let sepRegistrosN2 = "%" ;
            let sepCamposN2 = SEP_1;
            let sepRegistrosN3 = SEP_2;
            let sepCamposN3 = ";";

            let lineTotal="";

            let ordenCopa=0;
            copa="";
            for(i=0;i<infoGestionJornadasUS.length;i++){
                let c_copa=infoGestionJornadasUS[i];
                let estadoCopa="1";
                if(c_copa.estado==="BORRADO") estadoCopa="0";
                else ordenCopa++;
  
                let lineaN1=c_copa.idcopa + sepCamposN1 +
                        c_copa.nombreCopa + sepCamposN1 +
                        ordenCopa + sepCamposN1 +
                        estadoCopa;                
                

                let lineaJornada="";
                ordenJornadaEnCopa=0;
                for(j=0;j<c_copa.jornadas.length;j++){
                    let c_jor=c_copa.jornadas[j];
                    let estadoJor="1";
                    if(c_jor.estado==="BORRADO") estadoJor="0";
                    else{                        
                        ordenJornadaEnCopa++;
                        ordenJornadaGlobal++;
                    }

                    if(true){
                        let lineaN2=c_jor.idjornada + sepCamposN2 +
                                c_jor.nombreJornada + sepCamposN2 +
                                ordenJornadaGlobal + sepCamposN2 +
                                ordenJornadaEnCopa + sepCamposN2 +
                                c_jor.tipoJornadaEliminacion + sepCamposN2 +
                                estadoJor;

                        let lineaGrupos="";
                        if(c_jor.tipoJornadaEliminacion===("2") || c_jor.tipoJornadaEliminacion===("3")){
                            for(k=0;k<c_jor.infoGrupos.length;k++){
                                let c_grupo=c_jor.infoGrupos[k];

                                if(true){
                                    let lineaN3=c_grupo.idequipo + sepCamposN3 +
                                            c_grupo.grupo + sepCamposN3;

                                    if(lineaGrupos===("")) lineaGrupos=lineaN3;
                                    else lineaGrupos=lineaGrupos + sepRegistrosN3 + lineaN3;
                                }
                            }
                        }

                        lineaN2 =lineaN2 + sepCamposN2 + lineaGrupos;

                        if(lineaJornada===("")) lineaJornada=lineaN2;
                        else lineaJornada=lineaJornada + sepRegistrosN2 + lineaN2;
                    }

                }

                lineaN1 =lineaN1 + sepCamposN1 + lineaJornada;

                if(lineTotal===("")) lineTotal=lineaN1;
                else lineTotal=lineTotal + sepRegistrosN1 + lineaN1;

            }

            resultado=lineTotal;           

            

        }catch(err){
            reportarError(nomClase, nomFuncion,"",err);
        } 

        return resultado;
    }

    const salir = () => {       
        definirModulo(0,idModulo,params,ID_MODULO_PRINCIPAL_ADMIN,recuperarDatoLocal("idUser"));   
    }

    return (
        <> 
            
            {/* VENTANA BUSQUEDAS */}
            {isOpenBusqueda && infoBusquedaUS.tipoLista!=="" && (
                <Modal isOpen={isOpenBusqueda} closeModal={closeBusqueda} titulo={infoBusquedaUS.titulo}  isCancelable={true} txtCancelar="" txtAceptar="" >
                <div style={{margin:"10px", minHeight:"300px", maxHeight:"500px", maxWidth:"400px", fontSize:"16px", color:C_uniformeGrisOscuro}}>                    
                    
                    {infoBusquedaUS.tipoLista==="Busqueda_Telefono_Delegado" && (<>
                        <div style={{textAlign:"left", fontSize:"14px"}}>
                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}}  onClick={() => {clickGenerico("CLICK_OPCION_BUSQUEDA_TELEFONO_DELEGADO","Telefono_Delegado")}}>
                                        <input type="radio" value="pendiente" name="tipoLista" style={{margin: "10px"}} checked={tipoListaUS==="Telefono_Delegado"} onChange={() => {clickGenerico("CLICK_OPCION_BUSQUEDA_TELEFONO_DELEGADO","Telefono_Delegado")}}/>
                                        <div>{"Escriba o copie el número de telefono del Delegado del Equipo a Inscribir. Mínimo 10 dígitos."}</div>
                                    </div>
                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer", marginTop:"10px"}}  onClick={() => {clickGenerico("CLICK_OPCION_BUSQUEDA_TELEFONO_DELEGADO","Nombre_Delegado")}}>
                                        <input type="radio" value="todos" name="tipoLista" style={{margin: "10px"}} checked={tipoListaUS==="Nombre_Delegado"} onChange={() => {clickGenerico("CLICK_OPCION_BUSQUEDA_TELEFONO_DELEGADO","Nombre_Delegado")}}/>
                                        <div>{"Escriba el nombre, este se buscará entre los usuarios de la sede registrados en MarcaGol"}</div>
                                    </div>
                        </div>

                        <div style={{marginBlock:"20px", marginLeft:"20px", display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                            <input autoFocus ref={refBusqueda} type={tipoListaUS==="Telefono_Delegado" ? "number" : "text"} value={arrCampos[17].valor} className='IP_entradas' style={{width:"100%"}} placeholder="" 
                            onChange={(e) => {tipoListaUS==="telefono" ? validarCampo(e, "FILTRO_BUSQUEDA_TELEFONO", 14) : validarCampo(e, "FILTRO_BUSQUEDA_NOMBRE", 40)}}/>
                            <img className='IM_imgIcono16' src={ic_cancelar_gris} alt='' style={{paddingLeft:"10px", paddingRight:"15px", paddingBlock:"5px", cursor:"pointer"}} onClick={() => clickGenerico("LIMPIAR_FILTRO_BUSQUEDA")}/> 
                        </div>

                        </>
                    )}

                    {infoBusquedaUS.tipoLista!=="Busqueda_Telefono_Delegado" && (
                        <div style={{textAlign:"center", fontSize:"14px"}}>{infoBusquedaUS.texto}</div>
                    )}
                    
                    {(infoBusquedaUS.tipoLista==="Busqueda_Incluir_Equipo_Sede" || infoBusquedaUS.tipoLista==="Busqueda_Incluir_Cancha_Sede" || infoBusquedaUS.tipoLista==="Busqueda_Incluir_Arbitro_Sede") && (
                        <div style={{marginBlock:"20px", marginLeft:"20px", display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                            <input autoFocus ref={refBusqueda} type="text" value={arrCampos[17].valor} className='IP_entradas' style={{width:"100%"}} placeholder="" onChange={(e) => validarCampo(e, "FILTRO_BUSQUEDA_NOMBRE", 40)}/>
                            <img className='IM_imgIcono16' src={ic_cancelar_gris} alt='' style={{paddingLeft:"10px", paddingRight:"15px", paddingBlock:"5px", cursor:"pointer"}} onClick={() => clickGenerico("LIMPIAR_FILTRO_BUSQUEDA")}/> 
                        </div>
                    )}
                   

                    {(datosCargadosBusqueda) &&  (
                        <div style={{height:"250px", overflow:"auto"}}>
                            {datosEncontrados.length===0 && arrCampos[17].valor!=="" && (
                                <div style={{color:C_colorTextoSinInfo, whiteSpace:"pre-wrap", marginTop:"10px"}}>
                                    {"No hay registros que coincidan con el dato buscado."}
                                </div>
                            )} 

                            

                            {datosEncontrados.length>0 && infoBusquedaUS.tipoLista==="Busqueda_Telefono_Delegado" && (<>
                                {(datosEncontrados.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"busqueda_jugadores"} datos={reg} definirModulo={clickGenerico} incluirLinea={false} />))  )}     
                            </>)} 
                            
                            {datosEncontrados.length>0 && infoBusquedaUS.tipoLista==="Busqueda_Incluir_Equipo_Sede" && (<>
                                {(datosEncontrados.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"Busqueda_Incluir_Equipo_Sede"} datos={reg} definirModulo={clickGenerico} incluirLinea={false} />))  )}     
                            </>)} 

                            {datosEncontrados.length>0 && infoBusquedaUS.tipoLista==="Busqueda_Incluir_Cancha_Sede" && (<>
                                {(datosEncontrados.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"Busqueda_Incluir_Cancha_Sede"} datos={reg} definirModulo={clickGenerico} incluirLinea={false} />))  )}     
                            </>)} 

                            {arrCampos[17].valor==="" && (
                                <div style={{color:C_colorTextoSinInfo, whiteSpace:"pre-wrap", marginBlock:"10px"}}>                                    
                                    {infoBusquedaUS.tipoLista==="Busqueda_Telefono_Delegado" && ("Ingrese el Telefono/Nombre de usuario a buscar.")}
                                    {infoBusquedaUS.tipoLista==="Busqueda_Incluir_Equipo_Sede" && ("Ingrese el nombre de Equipo/Torneo a buscar.")}
                                    {infoBusquedaUS.tipoLista==="Busqueda_Incluir_Cancha_Sede" && ("Ingrese el nombre de la Cancha a buscar.")}
                                </div>
                            )}  

                                                       
                        </div>
                    )}   
                    


                    {(!datosCargadosBusqueda) && <div style={{margin:"100px"}}><Loader tipo={"PARCIAL"}/></div>}   

                </div> 
                </Modal>
            )}


            {/* VENTANA SELECCIONAR JUGADORES DE UN EQUIPO A IMPORTAR */}
            {isOpenSelJugadoresEq && infoEquipoSelUS!==null && (
                <Modal isOpen={isOpenSelJugadoresEq} closeModal={closeSelJugadoresEq} imgRedondeada={infoEquipoSelUS.escudo==="" ? ic_escudo_base_gris : (ruta + infoEquipoSelUS.escudo)} titulo={infoEquipoSelUS.nombreLargo}  isCancelable={true} clickAceptar={() => clickGenerico("ACEPTAR_JUGADORES_SELECCIONADOS_EQUIPO_SEDE")} >
                <div style={{margin:"10px", minHeight:"300px", maxHeight:"500px", maxWidth:"400px", fontSize:"16px", color:C_uniformeGrisOscuro}}>                    
                    
                    <div style={{textAlign:"center", fontSize:"14px", marginBottom:"8px"}}>{"El equipo seleccionado cuenta con más jugadores de los permitidos para este Torneo. Seleccione los jugadores que incluirá en este equipo."}</div>

                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginRight:"10px"}}>
                        <div style={{flex:"2", textAlign:"left", fontSize:"14px", color:C_uniformeNegro}}>{"# Max Jugadores Torneo:"}</div>
                        <div style={{textAlign:"center", fontSize:"16px", fontWeight:"bold", color:C_uniformeVerdeClaro}}>{infoEquipoSelUS.maxJugTorneo}</div>
                        <div style={{flex:"1", paddingRight:"10px"}}></div>
                    </div>                    
                    

                    {(datosCargadosBusqueda) &&  (<>
                        <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginRight:"10px"}}>
                            <div style={{flex:"2", textAlign:"left", fontSize:"14px", color:C_uniformeNegro}}>{"# Jugadores Seleccionados:"}</div>
                            <div style={{textAlign:"center", fontSize:"16px", fontWeight:"bold", color:C_uniformeAzulClaro}}>{infoEquipoSelUS.jugSeleccionados}</div>
                            <div style={{flex:"1", display:"flex", justifyContent:"right", paddingRight:"10px"}}><input type="checkbox" className="colorAccent" name="opcionMenu" onChange={(e)=> clickGenerico("CLICK_SELECCIONAR_TODOS_JUGADOR_EQUIPO",e.target.checked)}/> </div>
                        </div>

                        <div style={{height:"250px", marginBlock:"10px", overflow:"auto"}}>
                            {infoEquipoSelUS.jugadores.length>0  && (<>
                                {(infoEquipoSelUS.jugadores.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"Seleccionar_Jugadores_Equipo_Sede"} datos={reg} definirModulo={clickGenerico} incluirLinea={false} />))  )}     
                            </>)}  
                        </div>                        

                        </>
                    )}     

                    {(!datosCargadosBusqueda) && <div style={{margin:"100px"}}><Loader tipo={"PARCIAL"}/></div>}   

                </div> 
                </Modal>
            )}
            
            {/* VENTANA GESTIONAR FOTO/ESCUDO */}
            {isOpenImagen && (
                <ModalFull isOpen={isOpenImagen} closeModal={closeImagen} isCancelable={false}> 
                    <div><GestionImagen tipoImagen={tipoImagenSelUS} imgActual={imgActualSelUS} clickGenerico={clickGenerico} cortarImg={true}/></div>                
                </ModalFull>
            )}

            {/* VENTANA SELECCION FECHA */}
            {isOpenCalendar && (
                <ModalFull isOpen={isOpenCalendar} closeModal={closeCalendar} isCancelable={true} tipoVentana="SMALL"> 
                    <div><Calendar onChange={(date) => clickGenerico("SELECCIONAR_FECHAS",date)} value={selectedDate}  showNavigation={true} /></div>                
                </ModalFull>
            )} 

            {/* VENTANA PRESENTAR FOTO */}
            {isOpenFoto && (
                <ModalFull isOpen={isOpenFoto} closeModal={closeFoto} isCancelable={true} tipoVentana="SMALL"> 
                    <div style={{display:"flex"}}>
                    <div style={{flex:"1", flexShrink:"1", flexGrow:"1", minWidth:"300px", maxWidth:"500px", minHeight:"300px", maxHeight:"500px"}}>
                        <img src={srcFotoUS} className='IM_imgIcono250' style={{border:"1px solid gray"}}  />
                    </div>   
                    </div>                       
                </ModalFull>
            )}             

            {/* MODAL SELECCIONAR HORARIO */}
            {abrirHorarioUS && ( <SelHorario txtHorario={arrCampos[3].valor} clickGenerico={clickGenerico}/> )}


            {/* VENTANA CANCHA NUEVA */}
            {isOpenNewCancha && (
                <Modal isOpen={isOpenNewCancha} closeModal={closeNewCancha} isCancelable={false} txtAceptar="" txtCancelar=""> 
                    <div>
                        <Admin_Canchas params={"-1" + SEP_4 + idTorneo} definirModulo={clickGenerico} modOrigen={idModulo} />
                    </div>                
                </Modal>
            )}

            {/* VENTANA GESTIONAR JORNADAS */}
            {isOpenGestionJornadas && (
                <Modal isOpen={isOpenGestionJornadas} closeModal={closeGestionJornadas} isCancelable={false} txtAceptar="GUARDAR" titulo="Gestionar Jornadas" imgModal={ic_configura_gris}
                    clickAceptar={() => clickGenerico("CLICK_GUARDAR_CONFIGURACION_JORNADAS")}
                    clickCerrar={() => clickGenerico("CLICK_CANCELAR_CONFIGURACION_JORNADAS")}
                    clickCancelar={() => clickGenerico("CLICK_CANCELAR_CONFIGURACION_JORNADAS")} > 
                    <div>
                        <div style={{minWidth:"300px", minHeight:"400px", margin:"10px"}}>

                            {/* TITULO TORNEO */}
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"left", marginTop:"20px"}}>
                                <img className='IM_imgRedondeada28' src={datosMod.escudoTorneo} alt='' style={{marginRight:"10px"}}/>   
                                <div style={{flex:"1", fontSize:"16px", textAlign:"left"}}>
                                    <div style={{color:C_uniformeNegro}}>{datosMod.nomTorneo}</div> 
                                    <div style={{color:C_uniformeGrisOscuro, fontSize:"14px"}}>{datosMod.nomSede}</div> 
                                </div>
                            </div>

                            {/* SECCION COPAS DEL TORNEO */}
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", textAlign:"left", marginTop:"10px",marginLeft:"6px"}}>
                                <div style={{flex:"1", color:C_uniformeNegro, fontSize:"16px", fontWeight:"bold"}}>{"Copas del Torneo"}</div> 
                                <img className='IM_imgRedondeada24' src={ic_detalle_primary} alt='' style={{marginInline:"0px", padding:"6px", cursor:"pointer"}}
                                onClick={() => {clickGenerico("CLICK_CREAR_NUEVA_COPA")}}/>
                            </div>

                            <div className="BF_bordePrimary">
                                <div style={{height:"120px", margin:"2px", overflowY:"auto"}}>
                                    {infoGestionJornadasUS.map((cop, index) => (
                                                <div key={index} style={jornadaSelUS===index ? {background: C_fondolistaspar} : {background: C_transparente}}>
                                                    {cop.estado!=="BORRADO" && (
                                                        <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", padding:"6px", textAlign:"left", cursor:"pointer"}}>                                                        
                                                            {cop.estado!=="EDITANDO" && (<>
                                                                <div style={{flex:"1", fontSize:"18px", color: C_uniformeGrisOscuro}} 
                                                                    onClick={() => {clickGenerico("CLICK_SELECCIONAR_COPA",index); }}>{cop.nombreCopa}</div>
                                                                <img className="IM_imgIcono24" src={ic_modificar_gris} style={{paddingInline:"8px", paddingBlock:"4px"}} alt=""
                                                                    onClick={() => {clickGenerico("CLICK_EDITAR_COPA",index)}}/>
                                                            </>)}
                                                            {cop.estado==="EDITANDO" && (<>
                                                                <input type={"text"} value={cop.nombreCopa} className='IP_entradas' style={{flex:"1"}} 
                                                                    onChange={(e) => {validarCampoCopa(e, "NOMBRE_COPA", 20,index)}}/>
                                                                <img className="IM_imgIcono24" src={ic_ok} style={{paddingInline:"8px", paddingBlock:"4px"}} alt=""
                                                                onClick={() => {clickGenerico("ACEPTAR_MODIFICACION_COPA", index)}}/>
                                                            </>)}
                                                            

                                                            {cop.tienePartidos ? (
                                                                <img className="IM_imgIcono24" src={ic_borrar_gris} style={{padding:"4px"}} alt=""/>
                                                            ) :
                                                            (
                                                                <img className="IM_imgIcono24" src={ic_borrar_primary} style={{padding:"4px"}} alt=""
                                                                onClick={() => {clickGenerico("CLICK_BORRAR_COPA", index)}}/>
                                                            )}
                                                            
                                                        </div>
                                                    )}
                                                                                                                                                                                                          
                                                </div>
                                            ))}
                                    
                                    {irHastaFin && (<ScrollHastaFin />)}
                                    
                                    {infoGestionJornadasUS.length===0 && (
                                        <div className="TX_sinInfo" style={{maxWidth:"350px"}}>{"Torneo sin jornadas creadas"}</div>
                                    )}
                                </div>
                            </div>

                            {/* SECCION JORNADAS DE LA COPA SELECCIONADO */}
                            <div className="BF_cajaAccent" style={{marginTop:"15px"}}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", fontSize:"14px", marginInline:"5px"}} > 
                                    <img className='IM_imgIcono24' style={{padding:"0px", margin:"4px"}} src={ic_fase_eliminacion_blanco} alt='' />
                                    <div style={{flex:"1",textAlign:"left"}}>
                                        <div style={{fontSize:"14px"}} >{"Jornadas de Eliminación"}</div>
                                        {jornadaSelUS>=0 && (<div style={{fontSize:"14px", fontWeight:"bold"}} >{infoGestionJornadasUS[jornadaSelUS].nombreCopa}</div>  )}
                                                                              
                                    </div>                                    
                                    <img className='IM_imgIcono24' style={{padding:"4px", cursor:"pointer"}} src={ic_detalle_blanco} alt=''  
                                        onClick={() => {clickGenerico("CLICK_CREAR_NUEVA_JORNADA")}}/> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{height:"220px", fontSize:"16px", padding:"2px", overflowY:"auto"}}>
                                    {jornadaSelUS>=0 && (<>
                                        {/* SECCION MOSTRAR JORNADAS DE COPA SELECCIONADA */}
                                        {infoGestionJornadasUS[jornadaSelUS].jornadas.map((jor, index2) => (
                                            <div key={index2}>
                                                {jor.estado!=="BORRADO" && (
                                                <div  style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginBlock:"10px", maxWidth:"400px", minWidth:"100px"}}>
                                                        
                                                    <div style={{marginInline:"8px", color:C_uniformeNegro, fontWeight:"bold"}}>{(index2+1) + "."}</div>
                                                    
                                                    {jor.estado==="EDITANDO" && (                                                 
                                                        <div style={{flex:"1", textAlign:"left", marginBlock:"4px", flexShrink:"1", flexGrow:"1", minWidth:"100px", maxWidth:"400px"}}>
                                                            <div style={{display:"flex", marginBottom:"4px"}}>
                                                                <input type={"text"} value={jor.nombreJornada} className='IP_entradas'  style={{flex:1, minWidth:"50px"}}
                                                                    onChange={(e) => {validarCampoCopa(e, "NOMBRE_JORNADA", 20,index2)}}/>
                                                            </div>
                                                           <div>
                                                                <Select     
                                                                    styles={estilosSelect}
                                                                    value={jor.listaTipoJornada[valorNumero(jor.tipoJornadaEliminacion)]}
                                                                    formatOptionLabel={listaDosItems}
                                                                    options={jor.listaTipoJornada}
                                                                    isSearchable={false}   
                                                                    onChange={(e) => {clickGenerico("CAMBIAR_TIPO_JORNADA",[e, index2])}}            
                                                                /> 
                                                            </div>

                                                        </div>                                                     
                                                    )}                                                     

                                                    {jor.estado==="EDITANDO" && (
                                                        <img className="IM_imgIcono24" src={ic_ok} style={{padding:"8px", cursor:"pointer"}} alt="" 
                                                            onClick={() => {clickGenerico("ACEPTAR_MODIFICACION_JORNADA", index2)}}/>
                                                    )}
                                                    
                                                    {jor.estado!=="EDITANDO" && (<>
                                                        <div style={{flex:"1", flexShrink:"1", flexGrow:"1",  textAlign:"left", marginBlock:"0px"}}>
                                                                <div style={{color: C_uniformeNegro}}>{jor.nombreJornada}</div>
                                                                <div style={{fontSize:"14px", color: C_uniformeGrisOscuro, marginTop:"2px"}}>{jor.nombreTJE}</div>
                                                        </div>
                                                        
                                                        {(jor.tipoJornadaEliminacion==="2" || jor.tipoJornadaEliminacion==="3") && (consultoInfoEGJUS || jor.idjornada==="-1" || jor.gruposGuadados) &&
                                                        (<img className="IM_imgIcono24" src={ic_configura_gris} style={{padding:"6px", cursor:"pointer"}} alt=""
                                                            onClick={() => {clickGenerico("CLICK_CONFIGURAR_JORNADA_GRUPOS",index2)}}/>)}

                                                        <img className="IM_imgIcono24" src={ic_modificar_gris} style={{padding:"6px", cursor:"pointer"}} alt=""
                                                        onClick={() => {clickGenerico("CLICK_EDITAR_JORNADA",index2)}}/>

                                                        <img className="IM_imgIcono24" src={ic_agregar} style={{padding:"6px", cursor:"pointer"}} alt=""
                                                            onClick={() => {clickGenerico("CLICK_INCLUIR_NUEVA_JORNADA", index2)}}/>
                                                    </>)}                                                             
                                                            
                                                            {jor.tienePartidos!=="0" && (
                                                                <img className="IM_imgIcono24" src={ic_borrar_gris} style={{padding:"6px", cursor:"pointer"}} alt=""/>
                                                            )}
                                                            {jor.tienePartidos==="0" && (
                                                                <img className="IM_imgIcono24" src={ic_borrar_primary} style={{padding:"6px", cursor:"pointer"}} alt=""
                                                            onClick={() => {clickGenerico("CLICK_BORRAR_JORNADA", index2)}}/>
                                                            )}
                                                            
                                                </div>
                                                )}                                                
                                            </div>
                                        ))}

                                        {irHastaFinJornada && (<ScrollHastaFinJornada />)}
                                        
                                        {/* SECCION CREACIÓN DE JORNADAS ESTANDAR */}
                                        {infoGestionJornadasUS[jornadaSelUS].jornadas.length===0 && (<div style={{fontSize:"16", color:C_uniformeGrisOscuro, textAlign:"left"}}>
                                            <div className="TX_sinInfo" style={{textAlign:"center"}}>{"Copa SIN jornadas creadas"}</div>
                                            <div style={{color:C_uniformeNegro}}>{"Crea un grupo de Jornadas Estandar para la copa seleccionada..."}</div>
                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginTop:"10px", cursor:"pointer"}}
                                                onClick={() => {clickGenerico("CLICK_INCLUIR_JORNADAS_ESTANDAR","32")}}>
                                                <div className="BF_circuloGris" style={{width:"32px", height:"32px", margin:"4px",color:C_colorPrimary}}>{"32"}</div>
                                                <div style={{flex:"1"}}>{"Desde 32avos (Max 64 Eq)"}</div>
                                                <img className="IM_imgIcono24" src={ic_entrar_gris} style={{padding:"4px"}} alt=""/>
                                            </div>
                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}}
                                                onClick={() => {clickGenerico("CLICK_INCLUIR_JORNADAS_ESTANDAR","16")}}>
                                                <div className="BF_circuloGris" style={{width:"32px", height:"32px", margin:"4px",color:C_colorPrimary}}>{"16"}</div>
                                                <div style={{flex:"1"}}>{"Desde 16avos (Max 32 Eq)"}</div>
                                                <img className="IM_imgIcono24" src={ic_entrar_gris} style={{padding:"4px"}} alt=""/>
                                            </div>
                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}}
                                                onClick={() => {clickGenerico("CLICK_INCLUIR_JORNADAS_ESTANDAR","8")}}>
                                                <div className="BF_circuloGris" style={{width:"32px", height:"32px", margin:"4px",color:C_colorPrimary}}>{"8"}</div>
                                                <div style={{flex:"1"}}>{"Desde Octavos (Max 16 Eq)"}</div>
                                                <img className="IM_imgIcono24" src={ic_entrar_gris} style={{padding:"4px"}} alt=""/>
                                            </div>
                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}}
                                                onClick={() => {clickGenerico("CLICK_INCLUIR_JORNADAS_ESTANDAR","4")}}>
                                                <div className="BF_circuloGris" style={{width:"32px", height:"32px", margin:"4px",color:C_colorPrimary}}>{"4"}</div>
                                                <div style={{flex:"1"}}>{"Desde Cuartos (Max 8 Eq)"}</div>
                                                <img className="IM_imgIcono24" src={ic_entrar_gris} style={{padding:"4px"}} alt=""/>
                                            </div>
                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}}
                                                onClick={() => {clickGenerico("CLICK_INCLUIR_JORNADAS_ESTANDAR","2")}}>
                                                <div className="BF_circuloGris" style={{width:"32px", height:"32px", margin:"4px",color:C_colorPrimary}}>{"2"}</div>
                                                <div style={{flex:"1"}}>{"Desde Semifinal (Max 4 Eq)"}</div>
                                                <img className="IM_imgIcono24" src={ic_entrar_gris} style={{padding:"4px"}} alt=""/>
                                            </div>
                                        </div>)}
                                    </>)}

                                    {jornadaSelUS<0 && (
                                        <div className="TX_sinInfo" style={{maxWidth:"350px"}}>{"Seleccione la copa que desea gestionar sus jornadas"}</div>
                                    )}
                                </div>
                            </div>

                            
                            
                        </div> 


                    </div>               
                </Modal>
            )}

            {/* VENTANA GESTIONAR GRUPOS */}
            {isOpenGestionGrupos &&   (
                <Modal isOpen={isOpenGestionGrupos} closeModal={closeGestionGrupos} imgModal={ic_configura_gris} titulo={"Configuración de Grupos"}  isCancelable={false} txtAceptar="GUARDAR" clickAceptar={() => clickGenerico("CLICK_GUARDAR_CONFIGURACION_GRUPOS")} >
                <div style={{margin:"10px", minHeight:"300px", maxHeight:"800px", maxWidth:"1000px", fontSize:"16px", color:C_uniformeGrisOscuro}}>                    
                    
                    {/* SECCION SUPERIOR - 3 OPCIONES */}
                    <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"center", alignItems:"center", gap:"10px", margin:"10px"}}>
                        <div style={{flex:"1"}}></div>
                        <div className="BF_botonBordeGris" style={{width:"80px", minWidth:"50px", maxWidth:"80px", maxHeight:"50px", padding:"2px", margin:"0px"}}
                            onClick={() => {clickGenerico("CLICK_REINICIAR_CONFIGURACION_GRUPOS")}}>
                            <img className='IM_imgIcono20' src={ic_actualizar} alt='' />
                            <div style={{fontSize:"12px"}}>{"Reiniciar"}</div>
                        </div>
                        <div className={tipoSelGruposUS==="ALEATORIO" ? "BF_botonBordePrimary" : "BF_botonBordeGris"} style={{width:"80px", minWidth:"50px", maxWidth:"80px", maxHeight:"50px", padding:"2px", margin:"0px"}}
                            onClick={() => {setTipoSelGruposUS("ALEATORIO")}}>
                            <img className='IM_imgIcono20' src={ic_android_primary} alt='' />
                            <div style={{fontSize:"12px"}}>{"Aleatorio"}</div>
                        </div>
                        <div className={tipoSelGruposUS==="MANUAL" ? "BF_botonBordePrimary" : "BF_botonBordeGris"} style={{width:"80px", minWidth:"50px", maxWidth:"80px", maxHeight:"50px", padding:"2px", margin:"0px"}}
                            onClick={() => {setTipoSelGruposUS("MANUAL")}}>
                            <img className='IM_imgIcono20' src={ic_manual_primary} alt='' />
                            <div style={{fontSize:"12px"}}>{"Manual"}</div>
                        </div>
                        <div style={{flex:"1"}}></div>
                    </div>

                    {/* CANTIDAD DE GRUPOS */}
                    <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"center", alignItems:"center", color:C_uniformeNegro, margin:"10px"}}>
                        <div style={{fontSize:"14px"}}>{"No. de Grupos"}</div>
                        <div style={{width:"80px", background:"white", zIndex:"99", marginInline:"15px"}}>           
                        <Select     
                            styles={estilosSelect}
                            value={listaGruposUS[grupoSelUS]}
                            formatOptionLabel={listaDosItems}
                            options={listaGruposUS}
                            isSearchable={false}   
                            onChange={(e,index) => {setgGrupoSelUS(valorNumero(e.value))}}            
                        />   
                        </div>  
                        {tipoSelGruposUS==="ALEATORIO" && grupoSelUS>0 && (
                            <div className="BF_botonBordeAccentFull" style={{margin:"0px", paddingBlock:"2px", fontSize:"14px"}} onClick={() => {clickGenerico("CLICK_GENERAR_GRUPOS_ALEATORIAMENTE")}}>{"Generar"}</div>
                        )}
                        
                    </div>

                    {/* SECCIONES DE EQUIPOS SIN Y CON GRUPOS */}
                    <div style={{display:"flex", flexWrap:"wrap", gap:"20px", justifyContent:"center", alignItems:"start", marginTop:"20px", maxWidth:"1000px", border:"0px solid red"}}>

                            {/* SECCION EQUIPOS SIN GRUPO */}
                            <div className='BF_cajaGris' style={{flex:"1", flexShrink:"1", flexGrow:"1",  minWidth:"240px", maxWidth:"600px", alignItems:"center"}}>
                                <div className='TX_tituloCaja' style={{padding:"4px", fontWeight:"bold", fontSize:"12px"}}>{"Equipos SIN GRUPO"}</div>
                            
                               <div className='BF_cajaBlanca' style={{display:"flex", flexWrap:"wrap", gap:"10px", justifyContent:"center", alignItems:"start", maxWidth:"1000px", padding:"4px"}}>
                                {configSinGruposUS[0].equipos.length>0 && (<div style={{flex:"1", flexShrink:"1", flexGrow:"1",  minWidth:"240px", maxWidth:"300px", alignItems:"center"}}>
                                    {configSinGruposUS[0].equipos.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={reg.index} numRegistro={index+1} tipoLista={"EQUIPOS_SIN_GRUPO_CONFIG_GRUPOS"} datos={reg} modOrigen={idModulo} paramOrigen={paramsAjustado} modDestino={ID_MODULO_DETALLE_EQUIPO} paramDestino={reg.idequipo} definirModulo={clickGenerico} incluirLinea={false}  />))  }
                                </div>)}
                                {configSinGruposUS[0].equipos.length===0 && (<div className="TX_sinInfo" style={{minHeight:"80px", display:"flex", alignItems:"center"}}>{"NO HAY equipos sin asignar en Grupos"}</div>)}
                               </div>
                                
                            </div>

                            
                        {/* SECCION EQUIPOS CON GRUPO */}            
                        <div  className='BF_cajaAccent' style={{flex:"2", flexShrink:"2", flexGrow:"2", minWidth:"240px", maxWidth:"1000px", alignItems:"center"}}>
                            <div className='TX_tituloCaja' style={{padding:"4px", fontWeight:"bold", fontSize:"12px"}}>{"GRUPOS DEFINIDOS"}</div>

                            <div className='BF_cajaBlanca' style={{display:"flex", flexWrap:"wrap", gap:"10px", justifyContent:"center", alignItems:"start", maxWidth:"1000px", padding:"4px"}}>
                                {configGruposUS.length>0 && (<>
                                    {configGruposUS.map((reg, indx) => (                                        
                                        <div key={indx} style={{flex:"1", flexShrink:"1", flexGrow:"1",  minWidth:"240px", maxWidth:"300px", alignItems:"center"}}>
                                            <div className="BF_titulo_grupo_tc">{"Grupo. " + reg.grupo}</div>
                                            {reg.equipos.map((reg2, index) => (<DinamicoElementosTorneo key={index} registro={reg2.index} numRegistro={index+1} tipoLista={"EQUIPOS_CON_GRUPO_CONFIG_GRUPOS"} datos={reg2} modOrigen={idModulo} paramOrigen={paramsAjustado} modDestino={ID_MODULO_DETALLE_EQUIPO} paramDestino={reg2.idequipo} definirModulo={clickGenerico} incluirLinea={false}  />))  }
                                        </div>
                                    ))}
                                </>)}
                                {configGruposUS.length===0 && (<div className="TX_sinInfo" style={{minHeight:"80px", display:"flex", alignItems:"center"}}>{"NO HAY equipos definidos en Grupos"}</div>)}
                            </div>
                            
                        </div>

                    </div>

                    

                </div> 
                </Modal>
            )}

            {/* VENTANA SELECCIONAR GRUPO */}
            {isOpenSelGrupo &&   (
                <Modal isOpen={isOpenSelGrupo} closeModal={closeSelGrupo} titulo={"Seleccione el Grupo"}  isCancelable={true} txtAceptar="" txtCancelar="">
                <div style={{margin:"20px", minHeight:"40px",  maxHeight:"500px", minWidth:"100px", maxWidth:"300px", fontSize:"16px", color:C_uniformeGrisOscuro}}>                    
                    <div style={{display:"flex", flexWrap:"wrap", justifyContent:"center", alignItems:"center", gap:"20px", fontSize:"20px", fontWeight:"bold", color:C_uniformeNegro}}>
                    {listaGruposUS.filter(lista => (lista.value!=="0" && valorNumero(lista.value)<=grupoSelUS)).map((reg, index) => (
                        <div key={index} className="BF_cajaGris" 
                        style={{width:"40px", height:"40px", display:"flex",  justifyContent:"center", alignItems:"center", cursor:"pointer"}}
                        onClick={() => {clickGenerico("CLICK_GRUPO_SELECCIONADO", reg)}}>{index + 1}</div>
                    ))}
                    </div>
                </div> 
                </Modal>
            )}

            {/* MENU DE OPCIONES MULTIPLES DINAMICAS */}
            {isOpenMenu && (
                <Modal isOpen={isOpenMenu} closeModal={closeMenu} titulo={tituloMenu}  isCancelable={true} clickAceptar={() => clickGenerico("ACEPTAR_MENU")} >
                <div style={{margin:"20px"}}>                    
                    
                    {opcionesMenu.length>0 && (<> 
                        {(opcionesMenu.map((reg, index) => (
                            <div key={index} >
                                <label style={{display:"flex", alignItems:"center", flex:"1", justifyContent:"left", textAlign:"left", marginBlock:"15px"}}>
                                    <input type="radio" value={index} name="opcionMenu" checked={index===opcionSel} onChange={() => setOpcionSel(index)}/>
                                    <span style={{color:C_uniformeGrisOscuro, marginInline: "10px"}}>{reg[0]}</span>
                                </label>
                            </div>
                        ))  )}     
                    </>)} 

                </div> 
                </Modal>
            )}

            {/* PRESENTAR MENSAJES MODALES */}
            {showMensaje && (ventanaMensaje)}


            {/* TITULO VENTANA */}
            <div className="CT_zonaFija">
                <div className="CT_encabezado">
                    <div className="CT_elementoEncabezado" onClick={salir}><img src={ic_salir} className="IM_imgIcono24" alt="" style={{padding: "8px", cursor:"pointer"}} />  </div>
                    <div className="CT_elementoEncabezado"><img className="IM_imgRedondeada36" height="36px" width="36px" src={ic_escudo_base_gris} alt="" /></div>
                    <div className="CT_elementoEncabezado"><p className="TX_unaSolaLinea">{datosMod.tituloVentana}</p></div>
                </div>
            </div>

            {/* ENCABEZADO */}
            <div style={{paddingTop:"50px"}}>

                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", background:C_colorPrimaryDark, color:C_uniformeBlanco}}>
                    <img className="IM_imgRedondeada46" src={datosMod.fotoUsuario} alt="" style={{padding:"8px"}}/>
                    <div style={{flex:"1", fontSize:"14px", textAlign:"left", color: C_colorAccent }}>
                        <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{datosMod.rolUsuario}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomUsuario}</span></div>
                        <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{"Empresa:"}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomEmpresa}</span></div>
                        <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{"Sede:"}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomSede}</span></div>
                    </div> 
                </div>                  
            
            </div>
            
                          
            {/* AREA PRINCIPAL */}
            {!loading && esError===0 && (
                <div style={{margin: "10px", paddingBottom:"60px"}}>  
                    <div className="CT_contenedorTitulo" style={{marginBottom:"20px", cursor:"pointer"}} onClick={salir}>
                        <img className='IM_imgIcono28' src={ic_flecha_expandir} alt='' />   
                        <img className='IM_imgRedondeada36' src={datosMod.escudoTorneo} alt='' style={{marginInline:"10px"}}/>   
                        <div style={{flex:"1", fontSize:"18px", textAlign:"left"}}>{datosMod.nomTorneo}</div>  
                        <img className='IM_imgIcono28' src={datosMod.activo==="1" ? ic_activo : ic_inactivo} alt='' />              
                    </div>

                    {/* INFORMACIÓN PRINCIPAL DEL TORNEO */}
                    <div style={{display:"block", justifyContent:"center"}}>

                        <div style={{flex:"1", display:"flex", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            {!esTorneoNuevoUS && (
                                <div style={{position:"relative", cursor:"pointer"}} onClick={() => clickGenerico("CLICK_MODIFCAR_ESCUDO") }>
                                    <img className="IM_imgRedondeada80" src={arrCampos[2].valor} alt="" style={{padding:"0px", zIndex:"1"}}/>
                                    <div style={{position:"absolute", bottom:"0px", left:"0px"}}>
                                        <img className="IM_imgIcono24" src={ic_tomarfoto_dark} alt="" style={{padding:"0px", zIndex:"2"}}/>
                                    </div>
                                </div>
                            )}                           
                            
                            
                            <div style={{flex:"1", display:"block", justifyContent:"left", textAlign:"left"}}>
                                <div style={{fontSize:"16px", color:"black"}}>Nombre*</div>
                                <div style={{display:"flex", alignItems:"center"}}>                                    
                                    <input type="text" value={arrCampos[0].valor} className='IP_entradas' style={{flexGrow: 1, flexShrink: 1, minWidth:"100px", maxWidth: "500px"}} placeholder="Nombre del Torneo" onChange={(e) => validarCampo(e, "NOMBRE_TORNEO", 60)} onBlur={(e) => clickGenerico("SALE_NOMBRE_TORNEO")} /> 
                                </div>
                                {arrCampos[0].error!==""  && clickAceptarUS && (
                                    <div>
                                        <span className="TX_error">{arrCampos[0].error}</span>
                                    </div>
                                )}

                                <div style={{fontSize:"16px", color:"black", marginTop:"10px"}}>{"Descripción"}</div>
                                <div style={{display:"flex"}}>                                    
                                    <textarea rows={3} value={arrCampos[1].valor} className='IP_entradasTA' style={{flexGrow: 1, flexShrink: 1, minWidth:"100px", maxWidth: "500px", font:"inherit"}} placeholder="Información detallada del torneo" onChange={(e) => validarCampo(e, "DESCRIPCION", 990)} onBlur={(e) => clickGenerico("SALE_DESCRIPCION")}/> 
                                </div>
                                {arrCampos[1].error!==""  && clickAceptarUS && (
                                    <div>
                                        <span className="TX_error">{arrCampos[1].error}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {!esTorneoNuevoUS && (
                        <div className="BF_botonBordePrimary" style={{flex:"1", display:"flex", flexWrap:"nowrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center", justifyContent:"space-around", maxHeight:"40px", marginBlock:"20px", color:C_uniformeGrisOscuro, fontSize:"16px",cursor:"unset"}}>
                            <div style={{color:C_uniformeNegro}}>Reglamento (PDF)</div>
                            {arrCampos[16].valor!=="" && (
                            <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => clickGenerico("CLICK_BORRAR_REGLAMENTO")} >
                                <img className="IM_imgIcono24" src={ic_borrar_primary} alt="" style={{margin:"4px", zIndex:"2"}}/>
                                <div>Borrar</div>
                            </div>
                            )}
                            
                            {arrCampos[16].valor!=="" && (
                            <a href={arrCampos[16].valor} target="_blank" rel="noreferrer noopener" style={{textDecoration:"none", color:C_uniformeGrisOscuro}}>
                            <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}}>
                                <img className="IM_imgIcono24" src={ic_buscar_gris} alt="" style={{margin:"4px", zIndex:"2"}}/>
                                <div>Ver</div>
                            </div>
                            </a>
                            )}

                            <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => clickGenerico("CLICK_SUBIR_REGLAMENTO")} >
                                <img className="IM_imgIcono24" src={ic_upload_primary} alt="" style={{margin:"4px", zIndex:"2"}}/>
                                <div>Subir</div>
                            </div>                       
                            
                        </div>
                        )}                        

                    </div>

                    {/* PARAMETROS DEL TORNEO */}
                    <div style={{display:"flex", flexWrap:"wrap", gap:"30px", justifyContent:"center", alignItems:"start", marginTop:"20px", maxWidth:"1200px"}}>

                        {/* PARAMETROS DE CONFIGURACIÓN */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaGris' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} onClick={() => {setShowParamConfigUS(!showParamConfigUS)}}> 
                                    <p className='TX_tituloCaja' style={{flex:"1"}}>{"Parametros de Configuración"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={showParamConfigUS ? (ic_contraer_vertical_primary) : (ic_expandir_vertical_primary)} alt='' /> 
                                </div>
                            
                               {showParamConfigUS && (showParametrosConfig())}
                                
                            </div> 
                            
                        </div>

                        {/* PARAMETROS DE JUEGO */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaGris' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} onClick={() => {setShowParamJuegoUS(!showParamJuegoUS)}}> 
                                    <p className='TX_tituloCaja' style={{flex:"1"}}>{"Parametros de Juego"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={showParamJuegoUS ? (ic_contraer_vertical_primary) : (ic_expandir_vertical_primary)} alt='' /> 
                                </div>

                                {showParamJuegoUS && (showParametrosJuego())}
                                
                            </div>                            
                            
                        </div>

                        {/* PARAMETROS OPCIONALES */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaGris' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} onClick={() => {setShowParamOpcionalUS(!showParamOpcionalUS)}}> 
                                    <p className='TX_tituloCaja' style={{flex:"1"}}>{"Otros Parametros (Opcional)"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={showParamOpcionalUS ? (ic_contraer_vertical_primary) : (ic_expandir_vertical_primary)} alt='' /> 
                                </div>

                                {showParamOpcionalUS && (showParametrosOpcional())}
                                
                            </div>                            
                            
                        </div>

                    </div>

                    {/* SECCIONES DE CONFIGURACIÓN 1 A 7 */}
                    {!esTorneoNuevoUS && (
                    <div style={{display:"flex", flexWrap:"wrap", gap:"30px", justifyContent:"center", alignItems:"start", marginTop:"30px", maxWidth:"1200px"}}>

                        {/* 1. EQUIPOS */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaAccent' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} > 
                                    <p className='TX_tituloCaja' style={{flex:"1"}} onClick={() => {infoEquiposUS.length>0 ? setShowSeccionEquiposUS(!showSeccionEquiposUS):(setShowSeccionEquiposUS(showSeccionEquiposUS))}}>{"1. Equipos Inscritos"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_puntos_verticales_blancos} alt='' onClick={() => {setShowOpcionesEquiposUS(!showOpcionesEquiposUS)}}/>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={showSeccionEquiposUS ? (ic_contraer_vertical_blanco) : (ic_expandir_vertical_blanco)} alt=''  onClick={() => {infoEquiposUS.length>0 ? setShowSeccionEquiposUS(!showSeccionEquiposUS):(setShowSeccionEquiposUS(showSeccionEquiposUS))}}/> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{color:C_colorTextoSinInfo, fontSize:"16px", padding:"4px"}}>   

                                    {/* MENU DE OPCIONES PARA EQUIPOS */}
                                    {showOpcionesEquiposUS && (
                                        <div className="BF_botonBordeGris" style={{maxWidth:"100%", maxHeight:"100%", fontSize:"14px", color:C_colorPrimary, cursor:"auto"}}>
                                            <div style={{textAlign:"left", color:C_uniformeGrisOscuro}}>Opciones para Gestión de Equipos</div>

                                            {(arrCampos[7].valor==="3" || arrCampos[7].valor==="4") && (
                                            <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"right", alignItems:"center", cursor:"pointer"}} onClick={() => {tipoGestionGrupos="FASE DE GRUPOS"; generarEquiposXGrupo("INICIAL"); generarListaGrupos(); setTipoSelGruposUS(""); letCambioGrupo=false;  openGestionGrupos();}}>
                                                <div>Configuración de Grupos</div>
                                                <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_configura_gris} alt=''/>
                                            </div>
                                            )}
                                            
                                            <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"right", alignItems:"center", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_CREACION_EQUIPOS")}}>
                                                <div>Creación Rápida de Equipos</div>
                                                <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_jugador_registro_gris} alt=''/>
                                            </div>
                                            <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"right", alignItems:"center", cursor:"pointer"}}  onClick={() => {clickGenerico("CLICK_OPCION_INCLUIR_EQUIPOS_SEDE")}}>
                                                <div>Incluir Equipos de la sede</div>
                                                <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_detalle_gris} alt=''/>
                                            </div>
                                        </div>
                                    )}


                                    {/* OPCION 2. CREACIÓN RAPIDA DE EQUIPOS */}
                                    {equiposInscribirUS.length>0 && (
                                        <div style={{marginBottom:"0px"}}>
                                            
                                            {/* ALERTA DELEGADO EN VARIOS EQUIPOS */}
                                            {showAlertaEquiposUS && (
                                                <>
                                                <div className="TX_sinInfo" style={{textAlign:"left", fontSize:"12px"}}>
                                                    <div>{"ALERTA: Existen Delegados de equipo que ya pertenecen a otros equipos de este mismo torneo, por favor verifique la información."}</div>
                                                    <div style={{marginTop:"8px"}}>{"Si es correcto y su Torneo lo permite, OMITA esta alerta."}</div>
                                                </div>
                                                <div className="BF_botonBordePrimary" style={{maxWidth:"100px"}} onClick={() => clickGenerico("CLICK_OMITIR_ALERTA")}>{"Omitir Alerta"}</div>
                                                </>
                                            )}
                                            

                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                                <img className='IM_imgIcono16' src={ic_transparente} alt='' style={{paddingInline:"4px", marginTop:"0px"}}/> 
                                                <div className="TX_letraPeq" style={{flex:"1"}}>{"Nombre Corto Equipo*"}</div>
                                                <div className="TX_letraPeq" style={{flex:"1"}}>{"Telefono Delegado*"}</div>
                                            </div>

                                            {/* INGRESAR NOMBRE Y TELEFONO NUEVOS EQUIPOS */}
                                            {(equiposInscribirUS.map((reg, index) => (
                                                <div key={index} >
                                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", paddingBlock:"4px"}}>
                                                        <img className='IM_imgIcono16' src={ic_cancelar_gris} alt='' style={{padding:"4px", cursor:"pointer"}}  onClick={() => clickGenerico("LIMPIAR_CASILLA_NUEVOS_EQUIPOS", index)}/> 
                                                        <div style={{flex:"1", display:"flex", alignItems:"center", minWidth:"50px", marginRight:"10px"}}>
                                                            <input type="text" value={reg.nombre} className={"IP_entradas "} style={{marginInline:"0px", width:"100%", fontSize:"14px", height:"23px"}} placeholder="" onChange={(e) => clickGenerico("VALIDAR_NOMBRE_NUEVO_EQUIPO", [e,index,14])}  />  
                                                        </div>                                                        
                                                        <div className='IP_entradas' style={{flex:"1", cursor:"pointer", display:"flex", alignItems:"center", fontSize:"14px"}} onClick={() => clickGenerico("ABRIR_BUSQUEDA_INSCRIBIR_DELEGADO", index)} >
                                                            <span style={{paddingLeft:"10px"}}>{reg.telefono}</span>
                                                        </div>
                                                        
                                                    </div>
                                                    {reg.error!=="" && (
                                                        <div style={{marginTop:"-4px", marginBottom:"4px", marginLeft:"28px", textAlign:"left"}}>
                                                            <span className="TX_error" style={{fontSize:"12px", padding:"0px", margin:"0px"}}>{reg.error}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            ))  )} 

                                            {/* OPCIONES AGRGAR O INSCRIBIR EQUIPOS */}
                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginTop:"4px", marginBottom:"15px"}}>
                                                <div style={{flex:"2"}}></div>
                                                <img className='IM_imgIcono28' src={ic_agregar} alt='' style={{cursor:"pointer"}} onClick={() => clickGenerico("CLICK_MAS_EQUIPOS")}/> 
                                                <div style={{flex:"3"}}></div>
                                                <div className="BF_botonPrimaryFull" style={{padding:"3px", margin:"0"}} onClick={() => clickGenerico("CLICK_INCRIBIR_EQUIPOS")}>Inscribir</div>
                                                <div style={{flex:"1"}}></div>
                                            </div>
                                        </div>
                                    )}   

                                    {/* PRESENTA DETALLE EQUIPOS INSCRITOS */}
                                    {showSeccionEquiposUS && (<>
                                        {infoEquiposUS.length>0 && (<>
                                            {infoEquiposUS.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={reg.index} numRegistro={index+1} tipoLista={"EQUIPOS_ADMIN_TORNEO"} datos={reg} modOrigen={idModulo} paramOrigen={paramsAjustado} modDestino={ID_MODULO_DETALLE_EQUIPO} paramDestino={reg.idequipo} definirModulo={clickGenerico} incluirLinea={false}  />))  }
                                        </>)}
                                    </>)}
                                    
                                    {/* DETALLE EQUIPOS OCULTO - PRESENTA CANTIDAD */}
                                    {!showSeccionEquiposUS && cantEquiposUS<=0 && ("No hay equipos inscritos")}
                                    {!showSeccionEquiposUS && cantEquiposUS===1 && ("1 Equipo inscrito")}
                                    {!showSeccionEquiposUS && cantEquiposUS>1 && (cantEquiposUS + " Equipos inscritos")}
                                </div>
                            </div>                            
                            
                        </div>

                        {/* 2. CANCHAS */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaAccent' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} > 
                                    <p className='TX_tituloCaja' style={{flex:"1"}} onClick={() => {infoCanchasUS.length>0 ? setShowSeccionCanchasUS(!showSeccionCanchasUS):(setShowSeccionCanchasUS(showSeccionCanchasUS))}}>{"2. Canchas"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_detalle_blanco} alt='' onClick={() => {clickGenerico("CLICK_ASOCIAR_CANCHAS")}}/>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={showSeccionCanchasUS ? (ic_contraer_vertical_blanco) : (ic_expandir_vertical_blanco)} alt=''  onClick={() => {infoCanchasUS.length>0 ? setShowSeccionCanchasUS(!showSeccionCanchasUS):(setShowSeccionCanchasUS(showSeccionCanchasUS))}}/> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{color:C_colorTextoSinInfo, fontSize:"16px", padding:"4px"}}>   
                                                                        

                                    {/* PRESENTA DETALLE CACHAS ASOCIADAS */}
                                    {showSeccionCanchasUS && (<>
                                        {infoCanchasUS.length>0 && (<>
                                            {infoCanchasUS.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={reg.indice} numRegistro={index+1} tipoLista={"CANCHAS_ADMIN_TORNEO"} datos={reg} modOrigen={idModulo} paramOrigen={paramsAjustado} definirModulo={clickGenerico} incluirLinea={false}  />))  }
                                        </>)}
                                    </>)}
                                    
                                    {/* DETALLE CANCHAS OCULTO - PRESENTA CANTIDAD */}
                                    {!showSeccionCanchasUS && cantCanchasUS<=0 && ("No hay canchas asociadas")}
                                    {!showSeccionCanchasUS && cantCanchasUS===1 && ("1 Cancha asociada")}
                                    {!showSeccionCanchasUS && cantCanchasUS>1 && (cantCanchasUS + " Canchas asociadas")}
                                </div>
                            </div>                            
                            
                        </div>

                        {/* 3. JORNADAS DE FASE FINAL */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaAccent' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} > 
                                    <p className='TX_tituloCaja' style={{flex:"1"}} onClick={() => {infoJornadasUS.length>0 && setShowSeccionJornadasUS(!showSeccionJornadasUS)}}>{"3. Jornadas Fase Final (Opcional)"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_configura_blanco} alt='' onClick={() => {clickGenerico("CLICK_GESTIONAR_JORNADAS")}}/>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={showSeccionJornadasUS ? (ic_contraer_vertical_blanco) : (ic_expandir_vertical_blanco)} alt=''  onClick={() => {infoJornadasUS.length>0 && setShowSeccionJornadasUS(!showSeccionJornadasUS)}}/> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{color:C_colorTextoSinInfo, fontSize:"16px", padding:"4px"}}>   
                                    
                                    {/* PRESENTA DETALLE JORNADAS DE FASE FINAL */}   
                                    {showSeccionJornadasUS && (<>
                                        
                                        {infoJornadasUS.length>0 && (<>
                                            {arrCampos[7].valor!=="5" && (
                                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                                            <img className="IM_imgIcono28" src={ic_fase_grupos} style={{margin:"3px"}} alt=""/>
                                                            <div style={{fontSize:"14px", color: C_uniformeNegro, fontWeight:"bold"}}>{"Fase de Grupos"}</div>
                                                </div>
                                            )}

                                            {infoJornadasUS.map((cop, index) => (
                                                <div key={index} style={{marginTop:"10px"}}>
                                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                                        <img className="IM_imgIcono28" src={ic_torneo_gris_w} style={{margin:"3px"}} alt=""/>
                                                        <div style={{fontSize:"14px", color: C_uniformeNegro, fontWeight:"bold"}}>{cop.nombreCopa}</div>
                                                    </div>
                                                    {cop.jornadas.map((jor, index2) => (
                                                        <div key={index2} style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginLeft:"25px", marginTop:"4px"}}>
                                                            <img className="IM_imgIcono24" src={ic_fase_eliminacion} style={{margin:"4px"}} alt=""/>
                                                            <div style={{textAlign:"left"}}>
                                                                <div style={{fontSize:"14px", color: C_uniformeNegro}}>{jor.nombreJornada}</div>
                                                                <div style={{fontSize:"12px", color: C_uniformeGrisOscuro, marginTop:"-2px"}}>{jor.nombreTJE}</div>
                                                            </div>
                                                        </div>
                                                    ))}                                                                                                        
                                                </div>
                                            ))}
                                        </>)}
                                    </>)}

                                    {/* DETALLE JORNADAS OCULTO - PRESENTA CANTIDAD */}
                                    {!showSeccionJornadasUS && cantJornadasUS<=0 && ("No hay jornadas de fase final creadas")}
                                    {!showSeccionJornadasUS && cantJornadasUS===1 && ("1 jornada de fase final creada")}
                                    {!showSeccionJornadasUS && cantJornadasUS>1 && (cantJornadasUS + " jornadas de fase final creadas")}

                                </div>
                            </div>                            
                            
                        </div>

                        {/* 4. ARBITROS */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaAccent' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} onClick={() => clickGenerico("CLICK_PARAMETROS")}> 
                                    <p className='TX_tituloCaja' style={{flex:"1"}}>{"4. Árbitros (Opcional)"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_contraer_vertical_blanco} alt='' /> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{color:C_colorTextoSinInfo, fontSize:"16px", padding:"4px"}}>   
                                    Falta hacer contenido  
                                </div>
                            </div>                            
                            
                        </div>

                        {/* 5. COBROS CONFIGURADOS */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaAccent' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} onClick={() => clickGenerico("CLICK_PARAMETROS")}> 
                                    <p className='TX_tituloCaja' style={{flex:"1"}}>{"5. Cobros Configurados (Opcional)"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_contraer_vertical_blanco} alt='' /> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{color:C_colorTextoSinInfo, fontSize:"16px", padding:"4px"}}>   
                                    Falta hacer contenido  
                                </div>
                            </div>                            
                            
                        </div>

                        {/* 6. PUBLICIDAD */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaAccent' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} onClick={() => clickGenerico("CLICK_PARAMETROS")}> 
                                    <p className='TX_tituloCaja' style={{flex:"1"}}>{"6. Publicidad - Patrocinios (Opcional)"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_contraer_vertical_blanco} alt='' /> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{color:C_colorTextoSinInfo, fontSize:"16px", padding:"4px"}}>   
                                    Falta hacer contenido  
                                </div>
                            </div>                            
                            
                        </div>

                        {/* 7. INFORMACION ADICIONAL */}
                        <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"300px", maxWidth:"500px", alignItems:"center"}}>
                            
                            <div className='BF_cajaAccent' style={{minWidth:"300px", maxWidth:"500px", flexGrow:"1", flexShrink:"1" }}>
                                <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", cursor:"pointer"}} onClick={() => clickGenerico("CLICK_PARAMETROS")}> 
                                    <p className='TX_tituloCaja' style={{flex:"1"}}>{"7. Info Adicional (De Jugadores)"}</p>
                                    <img className='IM_imgIcono28' style={{padding:"4px"}} src={ic_contraer_vertical_blanco} alt='' /> 
                                </div>
                                
                                <div className='BF_cajaBlanca' style={{color:C_colorTextoSinInfo, fontSize:"16px", padding:"4px"}}>   
                                    Falta hacer contenido  
                                </div>
                            </div>                            
                            
                        </div>
                        

                    </div>
                    )}
                    


                </div>
            )}
                
            {/* OPCIONES PIE DE VENTANA - TORNEO EXISTENTE */}
            {!esTorneoNuevoUS && (
                 <div className='CT_zonaFijaInferior' style={{display:"flex", flexWrap:"nowrap", alignItems:"center", padding:"8px", cursor:"pointer"}} >
                
                    <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}} >
                        <img src={ic_cancelar_gris} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                        <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>Inactivar</span>
                    </div>

                    <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                        <img src={ic_copiar_blanco} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                        <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>Copiar</span>
                    </div>
                    {tienePartidosUS && (
                        <div style={{flex:"1"}}> </div>
                    )}
                    {!tienePartidosUS && (
                        <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}} >
                            <img src={ic_borrar_blanco} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                            <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>Borrar</span>
                        </div>
                    )}                    
                    
                </div>   
            )}

            {/* OPCIONES PIE DE VENTANA - TORNEO NUEVO */}
            {esTorneoNuevoUS && (
                 <div className='CT_zonaFijaInferior' style={{display:"flex", flexWrap:"nowrap", alignItems:"center", padding:"8px"}} >
                
                    <div style={{flex:"1"}}> </div>
                    <div style={{flex:"1"}}> </div>
                    <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => {validarCreacionTorneo()}}>
                            <img src={ic_ok} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                            <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>Crear</span>
                        </div>                   
                    
                </div>   
            )}
            
           

            {esError!==0 && <ShowError tipoError={esError} funcionCerrar={salir} />}

            {loading && <Loader tipo={"TOTAL"}/>}   
        </>
    );

};

export default Admin_Torneo;